/* eslint-disable max-len */
/* eslint-disable camelcase */
export default {
  components: {
    AiEditor: {
      adjustTone: 'Adjust tone',
      aiIsWriting: 'AI is writing',
      applyChanges: 'Apply changes',
      descriptive: 'Descriptive',
      friendly: 'Friendly',
      hint: 'Suggestions may sometimes be inaccurate; review carefully.',
      improveWriting: 'Improve writing',
      professional: 'Professional',
      proofread: 'Proofread',
      refineText: 'Refine text',
      shorten: 'Shorten',
    },
    ChildForm: {
      FamilyInfoForm: {
        LanguageSpokenAtHome: {
          label: 'Language spoken at home',
          placeholder: 'Language',
        },
        PositionInFamily: {
          label: 'Position in family',
          options: {
            eldest: 'Eldest',
            middle: 'Middle',
            multiple: 'Multiple',
            onlyChild: 'Only child',
            twin: 'Twin',
            youngest: 'Youngest',
          },
          placeholder: 'Unspecified',
        },
        Siblings: {
          label: 'Siblings',
          placeholder: 'Siblings',
        },
        title: 'Family information',
      },
      Religion: {
        agnostic: 'Agnostic',
        animism: 'Animism',
        atheist: 'Atheist',
        bahai: 'Bahá\'í Faith',
        buddhism: 'Buddhism',
        christianity: 'Christianity',
        confucianism: 'Confucianism',
        druidism: 'Druidism',
        hinduism: 'Hinduism',
        islam: 'Islam',
        jainism: 'Jainism',
        judaism: 'Judaism',
        paganism: 'Paganism',
        shinto: 'Shinto',
        sikhism: 'Sikhism',
        taoism: 'Taoism',
        zoroastrianism: 'Zoroastrianism',
      },
    },
    CommentDrawer: {
      createdOn: 'Created on',
    },
    DatePicker: {
      dateRangePlaceholder: 'Start date - End date',
      singleDatePlaceholder: 'Date',
    },
    Finance: {
      AccountInCredit: {
        label: 'Account in credit by',
      },
      InvoiceTable: {
        Header: {
          cost: 'Cost',
          itemType: 'Item type',
          quantity: 'Quantity',
          totalCost: 'Total Cost',
        },
        addLineItemLabel: 'Add line item',
        amountDue: 'Amount due',
        creditBroughtForwardLabel: 'Credit brought forward',
        creditNoteLabel: 'Credit note issued',
        debitBroughtForwardLabel: 'Debit brought forward',
        fundingHours: '{{ quantity }} hours',
        totalSummaryLabel: 'Total:',
      },
    },
    GridChildrenPicker: {
      selectAllChildren: 'Select all children',
      totalChildrenSelected: 'Total children selected',
    },
    GroupAvatars: {
      Group: 'Group',
      Months: 'Months',
    },
    InfiniteDropdowns: {
      AbsenceReasons: {
        placeholder: 'Absence reason',
      },
      AttendancePeriods: {
        placeholder: 'Attendance period',
      },
      ClosureDayTypes: {
        placeholder: 'Closure day type',
      },
      LeaveTypes: {
        placeholder: 'Leave type',
      },
      NurseryDiscountsV3: {
        placeholder: 'Nursery discounts',
      },
      NurseryFundingsV3: {
        placeholder: 'Nursery fundings',
      },
      NurseryItemsV3: {
        placeholder: 'Nursery items',
      },
      NurserySessionsV3: {
        placeholder: 'Nursery sessions',
      },
      Organisations: {
        placeholder: 'Organisation',
      },
      Periods: {
        placeholder: 'Attendance schedule',
      },
      SupportedCurrency: {
        placeholder: 'Currency',
      },
      SupportedLocale: {
        placeholder: 'Country',
      },
      SupportedReligions: {
        placeholder: 'Religion',
      },
      SupportedTimezones: {
        placeholder: 'Timezone',
      },
    },
    LastSaveDateTime: {
      by: 'by',
      lastSaved: 'Last Saved',
      saving: 'Saving',
    },
    Legend: {
      key: 'Key',
    },
    MaxCharactersText: {
      remaining: ' character(s) remaining',
    },
    MediaPicker: {
      addDescription: 'Add description',
      addFiles: 'Upload files',
      childrenTagged: 'Children tagged',
      deleteFile: 'Do you want to delete this file?',
      downloadFile_first: 'Preview not available.',
      downloadFile_second: 'Do you want to download this file?',
      exceededMaxFiles: 'Exceeded the maximum numbers of files ({{ maxOfFiles }}). The rest of the files have been omitted.',
      file: 'file',
      files: 'files',
      filesMax: '{{ limit }} files max',
      invalidFileHasBeenSkipped: '{{ fileName }} is invalid and has been skipped.',
      invalidFilesHasBeenSkipped: 'Files {{ fileName }} are invalid and have been skipped.',
      maxFileSize: 'Max file size',
      noChildrenTagged: 'No children tagged',
      noInternet: 'Upload error (no internet connection)',
      previewIsNotAvailable: 'Preview this file is not available',
      previewWhenNotUploaded: 'Preview this file when fully uploaded',
      size: 'Size',
      sizeTooLarge: 'File size too large',
      stopUpload: 'Are you sure you want to stop uploading this file?',
      supportedFileTypes: 'Supported file types',
      tagChildren: 'Tag children',
      uploadDate: 'Upload date',
      uploadError: 'Upload error',
      uploadErrorDetails: 'The file has been uploaded incorrectly',
      waiting: 'Waiting...',
    },
    Page: {
      defaultView: 'Default view',
      expandView: 'Expand view',
    },
    PasswordInput: {
      text: 'You will have access to confidential information and your password must be secure. Your password must include a minimum of 8 characters and you should consider using upper case and lower case characters, numbers and symbols.',
    },
    PhotoUpload: {
      changePhoto: 'Change photo',
    },
    ReportView: {
      emptyStateText: 'There are no reports.',
    },
    Settings: {
      AnnualisedSetting: {
        allowOverwrites: 'Allow overwrites on child level',
        excludedMonths: 'Excluded months for invoicing',
        weekLabel: 'Weeks and months to average',
      },
      InvoiceBankSettings: {
        accountName: 'Account name',
        accountNumber: 'Account number',
        bank: 'Bank',
        defaultTitle: 'Invoice bank details',
        notes: 'Notes',
        sortCode: 'Sort code',
        subtitle: 'The bank will appear on invoices under payment options.',
      },
      InvoiceSettings: {
        AutoCalculationDate: {
          caption: 'Start invoice from',
        },
        ExtraItems: {
          ActualCost: {
            title: 'Actual cost',
            tooltip: 'The platform will charge for the extras taken that month',
          },
          AverageCost: {
            title: "Average over 'x' weeks",
            tooltip: 'The platform will charge for the average cost of extras per month',
          },
          caption: 'Fee calculation for extras',
        },
        FeesCalculations: {
          title: 'Fees calculations',
        },
        FundingAllocation: {
          CheapestSessions: {
            title: 'Select cheapest sessions',
            tooltip: 'The platform will select the cheapest sessions allocated to a child to deduct from the invoice',
          },
          SubtractFunding: {
            title: 'Subtract funding from invoice',
            tooltip: 'The platform will subtract the total amount of funding for the month from the total invoice amount',
          },
        },
        InvoiceDetail: {
          GroupWithoutCost: {
            title: 'Grouped item types without cost breakdown',
            tooltip: 'This option will group each line item into the ‘item type’ categories and only show the overall item type category cost instead of a cost breakdown of each individual line item.',
          },
          WithCost: {
            title: 'Item types with cost breakdown',
            tooltip: 'This option will show a cost breakdown for each individual line item on the invoice.',
          },
          caption: 'Invoice level of detail displayed',
          previewButtonLabel: 'Preview',
        },
        InvoiceDisplay: {
          title: 'Invoice display',
        },
        InvoiceDueDate: {
          caption: 'Invoice due date',
          tooltip: 'This specifies the time period the invoice must be paid within (calculated based upon date of invoice being issued.)',
        },
        InvoiceNote: {
          caption: 'Additional invoice notes',
        },
        InvoiceNotesAndReminders: {
          title: 'Invoice notes and reminders',
        },
        InvoiceNumberSequencing: {
          nextCreditNoteNumberLabel: 'Next credit note numbers from',
          nextInvoiceNumberLabel: 'Next invoice numbers from',
          nextReceiptNumberLabel: 'Next receipt numbers from',
          title: 'Invoice number sequencing',
        },
        InvoiceNumbersSetting: {
          creditNoteNumber: 'Next credit note numbers from',
          creditNoteNumberPrefix: 'Credit note numbers prefix',
          invoiceNumber: 'Next invoice numbers from',
          invoiceNumberPrefix: 'Invoice numbers prefix',
          receiptNumber: 'Next receipt numbers from',
          receiptNumberPrefix: 'Receipt numbers prefix',
        },
        PaymentReminder: {
          caption: 'Automated payment reminders to bill payers',
          infoBlockCopy: "The following custom tags can be used to personalise the reminder message. Start by typing '{' and selecting one from the list:",
        },
        SessionCalculation: {
          ActualSessions: {
            title: 'Actual sessions',
            tooltip: 'The platform will select the cheapest sessions allocated to a child to deduct from the invoice',
          },
          AverageCost: {
            title: "Average over 'x' weeks",
            tooltip: 'The platform will charge for the average cost of sessions per month',
          },
          caption: 'Default fee calculation for sessions',
        },
        SessionCalculationWeekDays: {
          caption: 'Weeks and days to average fee and extra item calculations',
          tooltip: 'This specifies the time period the invoice must be paid within (calculated based upon date of invoice being issued.)',
        },
        StatementOfAccount: {
          caption: 'Additional statement account notes',
        },
      },
    },
    StagesIndicator: {
      disabledTooltip: 'You need to finish all previous steps first.',
    },
    Table: {
      noData: 'No data.',
    },
  },
  global: {
    Absence: 'Absence',
    Absent: 'Absent',
    Action: 'Action',
    Actions: 'Actions',
    Active: 'Active',
    Actual: 'Actual',
    Add: 'Add',
    AddItem: 'Add item',
    Added: 'Added',
    Address: 'Address',
    After: 'After',
    Age: 'Age',
    All: 'All',
    AllAges: 'All ages',
    AllEntries: 'All entries',
    AllRooms: 'All rooms',
    AllSites: 'All sites',
    Allocate: 'Allocate',
    Apply: 'Apply',
    Archive: 'Archive',
    Archived: 'Archived',
    AssignContact: 'Assign contact',
    Back: 'Back',
    Before: 'Before',
    Booking: 'Booking',
    Calculate: 'Calculate',
    Cancel: 'Cancel',
    Child: {
      DOB: 'D.O.B.',
      FinishDate: 'Finish date',
      LeaveDate: 'Leave date',
      RegistrationDate: 'Registration date',
      StartDate: 'Start date',
      childRefCode: 'Child ref. code',
      childReferenceCode: 'Child reference code',
      childReferenceCodeGeneration: 'Child reference code generation',
      childReferenceCodes: 'Child reference codes',
      referenceCode: 'Reference code',
    },
    Children: 'Children',
    ClearAll: 'Clear All',
    Closed: 'Closed',
    Comment: 'Comment',
    Comments: 'Comments',
    Confirm: 'Confirm',
    Contact: 'Contact',
    Continue: 'Continue',
    Cost: 'Cost',
    Create: 'Create',
    Created: 'Created',
    Current: 'Current',
    Date: 'Date',
    DateRange: 'Date range',
    DateRangePlaceholder: 'Start date - End date',
    Day: 'Day',
    DayNames: {
      1: 'Monday',
      2: 'Tuesday',
      3: 'Wednesday',
      4: 'Thursday',
      5: 'Friday',
      6: 'Saturday',
      7: 'Sunday',
    },
    Days: 'Days',
    Default: 'Default',
    Delete: 'Delete',
    DeleteAndContinue: 'Delete and continue',
    Deleted: 'Deleted',
    Description: 'Description',
    Disabled: 'Disabled',
    Discard: 'Discard',
    Download: 'Download',
    Duration: 'Duration',
    Edit: 'Edit',
    EditAllergy: 'Edit allergy',
    EditPreferences: 'Edit preferences',
    Email: 'Email',
    EmptyState: {
      long: 'There is no data matching your criteria.',
      short: 'Nothing found',
    },
    End: 'End',
    Enrolled: 'Enrolled',
    Expired: 'Expired',
    Export: 'Export',
    ExtraSession: 'Extra session',
    FileType: {
      CSV: 'CSV',
      PDF: 'PDF',
    },
    Filters: 'Filters',
    Finance: {
      Consumable: 'Consumable',
      Consumables: 'Consumables',
      CreatedDate: 'Created date',
      Deposit: 'Deposit',
      DepositRefund: 'Deposit refund',
      DepositRefunds: 'Deposit refunds',
      Deposits: 'Deposits',
      Discount: 'Discount',
      Discounts: 'Discounts',
      ExtraConsumables: 'Extra consumables',
      ExtraItems: 'Extra items',
      ExtraSessions: 'Extra sessions',
      Fee: 'Fee',
      FeeIncome: 'Fee income',
      Fees: 'Fees',
      FundingDeducted: 'Funding deducted',
      FundingDeficit: 'Funding deficit',
      FundingIncome: 'Funding income',
      Gross: 'Gross',
      InvoiceDate: 'Invoice date',
      InvoiceName: 'Invoice name',
      InvoiceNumber: 'Invoice no.',
      Other: 'Other',
      OutstandingBalance: 'Outstanding balance',
      Packages: 'Packages',
      Payment: 'Payment',
      Payout: 'Payout',
      RegularConsumables: 'Regular consumables',
      RegularItems: 'Regular items',
      RegularSessions: 'Regular sessions',
      Revenue: 'Revenue',
      Sessions: 'Sessions',
      Status: 'Status',
      Total: 'Total',
      TotalIncome: 'Total income',
      TotalInvoicedAmount: 'Total invoiced amount',
      TotalRevenue: 'Total revenue',
      UnpaidAmount: 'Unpaid amount',
      site: 'Site',
    },
    Flexible: 'Flexible',
    Framework: 'Framework',
    From: 'From',
    Generate: 'Generate',
    Hide: 'Hide',
    Holiday: 'Holiday',
    Hours: '{{ value }}h',
    Item: 'Item',
    JobTitle: 'Job title',
    KeyPerson: 'Key person',
    Later: 'Later',
    LeavingDate: 'Leaving date',
    Location: 'Location',
    Logo: 'Logo',
    Logout: 'Log out',
    MarkAsSent: 'Mark as sent',
    Migrate: 'Migrate',
    Minutes: '{{ value }}m',
    MomentRelativeShortTime: {
      day: 'd',
      hour: 'h',
      minute: 'm',
      month: 'mo',
      second: '<1m',
      week: 'w',
      year: 'y',
    },
    Montessori: 'Montessori',
    MonthsNames: {
      1: 'January',
      10: 'October',
      11: 'November',
      12: 'December',
      2: 'February',
      3: 'March',
      4: 'April',
      5: 'May',
      6: 'June',
      7: 'July',
      8: 'August',
      9: 'September',
    },
    Name: 'Name',
    Next: 'Next',
    No: 'No',
    NoOptions: 'No options',
    Now: 'Now',
    Nursery: 'Nursery',
    NurseryFunding: 'Nursery funding',
    NurserySession: 'Nursery session',
    Off: 'Off',
    Ok: 'Ok',
    On: 'On',
    Options: 'Options',
    Organisation: 'Organisation',
    Other: 'Other',
    Parent: 'Parent',
    Past: 'Past',
    Pending: 'Pending',
    Permission: 'Permission',
    Permissions: 'Permissions',
    Planned: 'Planned',
    Preview: 'Preview',
    Price: 'Price',
    Primary: 'Primary',
    PrimaryBillPayer: 'Primary bill payer',
    Processing: 'Processing',
    ProcessingCheckLater: 'We are processing your video. Please check back in few minutes',
    Reference: 'Reference',
    Refresh: 'Refresh',
    Register: 'Register',
    Remove: 'Remove',
    Repeat: 'Repeat',
    Resend: 'Resend',
    Reset: 'Reset',
    Retry: 'Retry',
    Role: 'Role',
    Roles: 'Roles',
    Room: 'Room',
    RoomMoves: 'Room Moves',
    Rooms: 'Rooms',
    Save: 'Save',
    SaveAndContinue: 'Save and continue',
    SaveDraft: 'Save draft',
    Select: 'Select',
    Send: 'Send',
    ServiceError: 'Something went wrong whilst communicating with the server, please try again later.',
    Session: 'Session',
    Set: 'Set',
    Setup: 'Setup',
    Show: 'Show',
    ShowAll: 'Show all',
    ShowDetails: 'Show details',
    Skip: 'Skip',
    Staff: 'Staff',
    StaffName: 'Staff name',
    Start: 'Start',
    Subdomain: 'Subdomain',
    Submit: 'Submit',
    Telephone: 'Telephone',
    Time: 'Time',
    TimedIn: 'Timed in',
    TimedOut: 'Timed out',
    To: 'To',
    Type: 'Type',
    Unarchive: 'Unarchive',
    Unspecified: 'Unspecified',
    Update: 'Update',
    Updated: 'Updated',
    User: 'User',
    Value: 'Value',
    View: 'View',
    Yes: 'Yes',
    activate: 'activate',
    activated: 'activated',
    activity: 'Activity',
    age: 'age',
    ageMonths: '{{ ageMonths }} months',
    allergies: 'allergies',
    amount: 'amount',
    approve: 'approve',
    archive: 'archive',
    archived: 'archived',
    at: 'at',
    bytes: 'bytes',
    cancel: 'cancel',
    child: 'child',
    children: 'children',
    clear: 'clear',
    clipboardCopy: 'Link copied to clipboard',
    comment: 'comment',
    companyName: 'Blossom Educational',
    createdBy: 'Created by',
    custom: 'custom',
    date: 'date',
    dateOfBirthShort: 'D.O.B',
    dateRange: 'Date range',
    day: 'day',
    deactivate: 'deactivate',
    deactivated: 'deactivated',
    delete: 'delete',
    deleteAll: 'Delete all',
    dietaryPreference: 'dietary preference',
    disabled: 'disabled',
    dobAge: 'D.O.B. (Age)',
    domain: 'domain',
    draft: 'draft',
    emptyState: 'Nothing found',
    enabled: 'enabled',
    endDate: 'end date',
    endTime: 'End time',
    expand: 'expand',
    export: 'export',
    featureFlag: 'feature flag',
    featureFlags: 'feature flags',
    firstAid: 'first Aid',
    frameworks: 'Frameworks',
    fte: 'FTE',
    hour: 'hour',
    hourShortcut: 'h',
    hours: 'hours',
    import: 'import',
    inactive: 'inactive',
    keyPerson: 'key person',
    lastEdited: 'Last edited',
    location: 'location',
    medicationInformation: 'medication information',
    min: 'min',
    minuteShortcut: 'm',
    minutes: 'minutes',
    month: 'month',
    months: 'months',
    more: 'more',
    no: 'no',
    noDataFound: 'No data found',
    noPermissionInGroupPhotos: 'No permission to be in group media',
    noPermissionInPhotos: 'No permission to be in media',
    nursery: 'nursery',
    of: 'of',
    ongoing: 'ongoing',
    optional: 'optional',
    options: 'options',
    or: 'or',
    other: 'other',
    oz: 'oz',
    pagination: {
      child: 'child',
      children: 'children',
      entries: 'entries',
      entry: 'entry',
      report: 'report',
      reports: 'reports',
      staffMember: 'staff member',
      staffMembers: 'staff members',
    },
    parents: 'parents',
    parentsGuardian: 'parent/Guardian',
    pending: 'pending',
    period: 'Period',
    profile: 'profile',
    referenceCode: 'Reference code',
    returnToPreviousWebsite: 'Return to previous website',
    role: 'role',
    roles: {
      DEPUTY_MANAGER: 'Deputy manager',
      NURSERY_ADMIN: 'Nursery admin',
      NURSERY_MANAGER: 'Manager',
      ORGANIZATION_DIRECTOR: 'Director',
      ORGANIZATION_FINANCE_ADMIN: 'Finance admin',
      ORGANIZATION_LINE_MANAGER: 'Area manager',
      ORGANIZATION_NATIONAL_ADMIN: 'National admin',
      ROOM_LEADER: 'Room leader',
      SENIOR_TEACHER: 'Senior Practitioner',
      SUPER_ADMIN: 'Super admin',
      TEACHER: 'Practitioner',
    },
    room: 'room',
    saveAsDraft: 'Save as draft',
    searchByFileName: 'Search by file name',
    searchChild: 'Search child',
    searchPlaceholder: 'Search child, contact name, or reference number',
    selectAll: 'Select all',
    selectDate: 'Select date',
    selectRoom: 'Select room',
    send: 'send',
    sendForApproval: 'send for approval',
    sessions: 'sessions',
    shortDayNames: {
      1: 'Mon',
      2: 'Tue',
      3: 'Wed',
      4: 'Thu',
      5: 'Fri',
      6: 'Sat',
      7: 'Sun',
    },
    showMore: 'Show more',
    staffMember: 'staff member',
    staffMembers: 'staff members',
    startDate: 'start date',
    startTime: 'Start time',
    status: 'status',
    time: 'time',
    to: 'to',
    today: 'today',
    unarchive: 'unarchive',
    unarchived: 'unarchived',
    unknown: 'unknown',
    upcoming: 'upcoming',
    uploading: 'uploading',
    week: 'week',
    weeks: 'weeks',
    witness: 'witnesses',
    year: 'year',
    yes: 'yes',
    yesterday: 'yesterday',
    youAreOffline: 'You are offline.',
  },
  modals: {
    AddDiscountToRegularBookings: {
      afterFunding: 'After funding',
      beforeFunding: 'Before funding',
      consumablesAddedToSessions: 'Consumables added to sessions',
      dailyDiscountValue: 'Daily discount value',
      daysApplicable: 'Days applicable',
      discountAppliedOnSessions: 'Discount applied on sessions',
      discountName: 'Discount name',
      discountPercentage: 'Discount percentage',
      discountType: 'Discount type',
      extraItems: 'Extra items',
      extraSessions: 'Extra sessions',
      regularSessions: 'Regular sessions',
      title: 'Add discount',
      weeklyValue: 'Weekly value',
    },
    AddFundingToRegularBookings: {
      allocateHoursWithinSessionTimes: 'Please allocate funded hours within the session times.',
      allocateWeeklyFundedHoursToATypicalWeek: 'Allocate weekly funded hours to a typical week',
      closureDay: 'Closure day',
      customHourlyRateInfo: 'When using a custom hourly rate, any schedule funding hourly rate changes will not be applied during the duration of this booking pattern.',
      editTitle: 'Edit funding for week {{ week }}',
      endTimeLater: 'End time must be later than start time',
      fundingExclusionPeriod: 'Funding exclusion period',
      fundingType: 'Funding type',
      hoursPerWeek: 'Hours per week',
      localAuthorityHourlyRate: 'Local authority hourly rate',
      maxHoursPerDay: 'Max hours per day',
      migratedFundingBannerText: 'We`ve updated our funding options. Please reapply to cheapest hours or select a preferred time slot.',
      previewTitle: 'Preview funding for week {{ week }}',
      reapplyToCheapestHours: 'Reapply to cheapest hours',
      removeAllFundedHours: 'Remove all funded hours',
      removeFundedHoursFromThisWeek: 'Remove funded hours from this week',
      saveAllocation: 'Save allocation',
      showActualAllocationPerWeek: 'Show actual allocation per week',
      startTimeEarlier: 'Start time must be earlier than end time',
      termTimeHoliday: 'Term time holiday',
      title: 'Add funding for week {{ week }}',
      useCustomHourlyRate: 'Use custom hourly rate',
      useDefaultHourlyRate: 'Use default hourly rate',
      weeklyHoursAllocated: 'weekly hours allocated',
    },
    AddRegularItemsToRegularBookings: {
      daysApplicable: 'Days applicable',
      itemName: 'Item name',
      pricePerDay: 'Price per day',
      quantity: 'Quantity per day',
      title: 'Add regular item',
    },
    AddSessionToRegularBookings: {
      daysApplicable: 'Days applicable',
      endTimeValidation: 'End time must be later than start time',
      includeConsumables: 'Include consumables',
      sessionName: 'Session name',
      sessionsCannotOverlap: 'You can not add overlapping sessions for {{ dayOfWeeks }}.',
      title: 'Add Sessions',
    },
    Administration: {
      AddAdministration: {
        Form: {
          Child: {
            placeholder: 'Select child',
          },
          Dose: {
            label: 'Dose',
            placeholder: 'Select dose',
          },
          Medicine: {
            label: 'Medicine',
            placeholder: 'Select medicine',
          },
          OtherNotes: {
            label: 'Other notes',
          },
          Signatures: {
            StaffDropdown: {
              label: 'Administrated by',
              placeholder: 'Select staff',
            },
            StaffSignature: {
              label: 'Staff signature',
            },
            WitnessDropdown: {
              label: 'Witness',
              placeholder: 'Select staff',
            },
            WitnessSignature: {
              label: 'Witness signature',
            },
            title: 'Signatures',
          },
          sameStaffSelectionValidation: 'Administered by and witness can not be a same staff member',
          title: 'Medication details',
        },
        addTitle: 'Administer medication',
      },
      AddEmergencyDose: {
        Form: {
          Dose: {
            label: 'Dose',
            placeholder: 'Select dose',
          },
          MedicationDetails: {
            Dose: {
              label: 'Dose (amount and unit)',
              placeholder: 'Amount and unit',
            },
            ExpiryDate: {
              label: 'Medication expiry date',
            },
            Medication: {
              label: 'Emergency medication',
              placeholder: 'Medication name',
            },
            MethodOfAdministration: {
              label: 'Method of administration',
              placeholder: 'Method of administration',
            },
            OtherNotes: {
              label: 'Other notes',
            },
            ReasonForMedication: {
              label: 'Reason for medication',
              placeholder: 'Reason for medication',
            },
            SideEffects: {
              label: 'Known side effects',
            },
            title: 'Medication details',
          },
          Parent: {
            label: 'Contacted parent',
            placeholder: 'Select parent',
          },
          Signatures: {
            StaffDropdown: {
              label: 'Administrated by',
              placeholder: 'Select staff',
            },
            StaffSignature: {
              label: 'Staff signature',
            },
            WitnessDropdown: {
              label: 'Witness',
              placeholder: 'Select staff',
            },
            WitnessSignature: {
              label: 'Witness signature',
            },
            title: 'Signatures',
          },
          canReceiveMedicineBanner: 'This сhild has permission to give medicine (e.g. Calpol) for the treatment of a high temperature.',
          cannotReceiveMedicineBanner: 'This сhild doesn\'t have permission to give medicine (e.g. Calpol) for the treatment of a high temperature. Written permission must be obtained to administer medication.',
          emptyContactBanner: 'This child doesn’t have any contacts in the system. By ticking the box below, you confirm that the parents were contacted.',
          noContactLabel: 'No contact information',
          sameStaffSelectionValidation: 'Administered by and witness can not be a same staff member',
          wasParentContacted: {
            label: 'Parents were contacted',
          },
        },
        addTitle: 'Emergency dose',
      },
      ParentSignature: {
        title: 'Parent\'s signature',
      },
    },
    AiConfirmDiscardModal: {
      content: 'Keep or discard your pending AI edits?',
      keep: 'Keep',
    },
    PeriodHasInvoice: {
      content: 'The period has one or more invoices.',
      content2: 'To avoid issues, please credit note the invoices before creating the new booking pattern.',
      goToInvoices: 'Go to invoices',
      proceedAnyway: 'Proceed anyway',
    },
    SendRegistrationForm: {
      Form: {
        Recipient: {
          emailNotFoundError: 'No email address added for contact.',
          label: 'Send to child contact',
          placeholder: 'Select child contact',
        },
        emptyAgreementAndTermsSectionText: 'The Agreement and Terms and Conditions sections are currently empty. Please fill in the required details before sending the registration form.',
        emptyAgreementSectionText: 'The Agreement sections are currently empty. Please fill in the required details before sending the registration form.',
        emptyBookingPatternText1: 'No booking pattern added.',
        emptyBookingPatternText2: 'Create a booking pattern first in order to show it on the registration form.',
        emptyTermsSectionText: 'The Terms and Conditions section is currently empty. Please fill in the required details before sending the registration form.',
        enrolmentInfo: 'Check enrolment related details before sending, as they will be displayed on the form.',
        sendSuccessMessage: 'Registration form has been sent to {{ name }}.',
      },
      title: 'Send registration form',
    },
    SubmitRegistrationForm: {
      content: 'Once the registration form is submitted, you must contact the nursery to make any further changes to the information provided.',
      title: 'Submit registration form',
    },
    TermsAndConditions: {
      title: 'Terms and conditions',
    },
    UnsavedChanges: {
      content: 'You have unsaved changes in this form. Would you like to save your progress before leaving?',
      leaveWithoutSaving: 'Leave without saving',
      saveAsDraft: 'Save as draft',
      title: 'Unsaved changes',
    },
  },
  module: {
    Account: {
      Routing: {
        edit: 'Edit profile',
        index: 'Your Blossom profile',
      },
    },
    Approvals: {
      AccidentsIncidents: {
        title: 'Accidents & Incidents',
      },
      FormativeReports: {
        FormativeReportPreview: {
          title: 'Formative report preview',
        },
        title: 'Formative reports',
      },
      Observations: {
        EditObservation: {
          title: 'Edit observation',
        },
        Frameworks: {
          title: 'Frameworks',
        },
        NextSteps: {
          title: 'Next steps',
        },
        ReviewObservation: {
          title: 'Review observation',
        },
        title: 'Observations',
      },
      Status: {
        approved: 'Approved',
        changesRequested: 'Changes requested',
        parentApproved: 'Parent approved',
        pendingApproval: 'Pending approval',
      },
      title: 'Approvals',
    },
    Authentication: {
      ChangePassword: {
        changePassword: 'Change password',
        setNewPassword: 'Set new password',
        youHaveSetANewPassword: 'You have set a new password.',
        youHaveSetANewPasswordContent: 'You can now sign into the Blossom app using the password you just set.',
      },
      Invitation: {
        alreadyGotALogin: 'Already got a Login?',
        footerText: 'By clicking register, you agree to our <0>Terms</0> and that you have read our <1>Child protection policy</1> and <2>Security policy</2>.',
        linkExpired1: 'Oops!',
        linkExpired2: 'Your password link has expired.',
        linkExpired3: 'Please request a new password reset or contact your manager to send you a new invitation email.',
        register: 'Register',
        thankYouForJoining: 'Thank you for joining Blossom Educational. Please enter a password. Keep this password safe and secure.',
      },
      Login: {
        authoriseDevice: 'Authorise device',
        forgottenYourPassword: 'Forgotten your password?',
        identifier: 'Username / Email',
        logIn: 'Log in',
        password: 'Password',
        pin: 'Pin',
        pinMessage: 'This device is not authorised, please contact your setting manager for a 6-digit authorisation pin.',
        weveJustSentYou: "We've just sent you an email with the details you need to reset your password.",
        youHaveBeenLoggedOut: 'You have been logged out.',
        yourPasswordHasBeenUpdated: 'Your password has been updated, please log in with your new password to continue.',
      },
      ResetPassword: {
        email: 'Email',
        requestPasswordReset: 'Request password reset',
        signInWithYourPassword: 'or Sign in with your password',
      },
      SetPassword: {
        confirmPassword: 'Confirm password',
        newPassword: 'New password',
        passwordMustBeAtLeast8Characters: 'Your password must be at least 8 characters.',
        yourRetypedPasswordDidNotMatch: 'Your retyped password did not match.',
      },
      components: {
        BoxWrapper: {
          by: 'By {{ siteName }}',
        },
        PasswordStrength: {
          fair: 'Fair',
          good: 'Good',
          strong: 'Strong',
          toShort: 'Too short (at least 8 characters)',
          weak: 'Weak',
        },
      },
      passwordDetails: 'You will have access to confidential information and your password must be secure. Your password must include a\n      minimum of 8 characters and you should consider using upper case and lower case characters, numbers and symbols.',
    },
    Children: {
      Child: {
        About: {
          Absences: {
            DeleteLeave: {
              Confirm: {
                dateRange: "{{ firstName }}'s {{ type }} from {{ startDate }} to {{ endDate }} will be deleted.",
                oneDay: "{{ firstName }}'s {{ type }} on {{ startDate }} will be deleted.",
              },
              snackbar: '{{ type }} for {{ firstName }} has been deleted.',
            },
            Title: {
              long: 'Absences & holidays',
              short: 'Absences',
            },
            absenceReason: 'Absence reason',
            addLeave: 'Add leave',
            emptyState: 'There is no data matching your criteria.',
            leaveType: 'Leave type',
          },
          Profile: {
            RegistrationForm: {
              Statuses: {
                completed: 'Completed',
                linkExpired: 'Link expired',
                notSend: 'Not sent',
              },
              completedByItemLabel: 'Completed by {{ name }}',
              description: 'The registration form lets parents provide essential details, updating the child\'s profile upon completion.',
              emptyBookingPattern: 'No booking pattern added. Schedule it first to display on the registration form.',
              sentToItemLabel: 'Sent to {{ name }}',
              title: 'Registration form',
            },
          },
          ProfileHistory: {
            childProfileCreated: 'Child profile created',
            emptyState: 'List of update history of child profile is empty',
            parent: 'Parent',
            photoRemoved: 'Photo removed',
            photoUpdated: 'Photo updated',
            photoUploaded: 'Photo uploaded',
            updatedMadeBy: 'Updated made by',
            updatedSectionPlaceholder: 'Updated section',
          },
        },
        Add: {
          AddContactAlertModal: {
            buttonLabel: 'Add contacts',
            text1: '{{ firstName }} {{ surname }} has been added!',
            text2: "Please add the child's contacts and booking pattern.",
          },
          BookingPatternPopup: {
            bookingPatternButtonLabel: 'Add booking pattern',
            message: 'Do you want to add the {{ firstName }}\'s regular booking pattern now?',
          },
          Contacts: {
            Section: {
              title: 'Contact {{ number }}',
            },
            title: 'Contacts',
          },
          Development: {
            Subsections: {
              Routine: {
                Form: {
                  AttendsOtherSettings: {
                    label: 'Attends another setting?',
                    placeholder: 'Name and type of setting e.g. playgroup, nursery, childminder, swimming classes',
                  },
                  DayTimeSleep: {
                    label: 'Sleeps during the day',
                  },
                  DayTimeSleepDetails: {
                    placeholder: 'any additional details',
                  },
                  Routine: {
                    label: 'Daily routine',
                    placeholder: 'Any information you think may be helpful e.g. Sleep time, Naps',
                  },
                },
                title: 'Routine',
              },
              Skills: {
                Form: {
                  ChildBehavior: {
                    label: 'Social skills',
                    placeholder: 'How are they with other children and/or family members? Do they interact with others? Do they like sharing their things?',
                  },
                  DrinkingMethods: {
                    label: 'Drinks from',
                  },
                  EnglishAdditionalLanguage: {
                    label: 'English as additional language (EAL)',
                  },
                  EnglishAdditionalLanguageDetails: {
                    placeholder: 'any additional details',
                  },
                  LanguageCapability: {
                    label: 'Language skills',
                    placeholder: 'Do they have a lot of language? How much are they using words to engage? e.g. babbling, using a few words, using simple sentences, etc.',
                  },
                  MovementCapability: {
                    label: 'Physical skills',
                    placeholder: 'What are their physical skills? Can they crawl, walk, run & jump?',
                  },
                  SpecialEducation: {
                    label: 'Special educational needs (SEND)',
                  },
                  SpecialEducationDetails: {
                    placeholder: 'any additional details',
                  },
                  Toileting: {
                    label: 'Toileting',
                  },
                },
                title: 'Skills',
              },
            },
            title: 'Development',
          },
          EnrolmentDetails: {
            Sections: {
              attendance: 'Attendance',
            },
            Subsections: {
              Attendance: {
                Form: {
                  RegistrationDate: {
                    label: 'Registration date',
                    placeholder: 'Registration date',
                  },
                  Room: {
                    label: 'Room',
                    placeholder: 'Select room',
                  },
                  StartDate: {
                    label: 'Start date',
                    placeholder: 'Start date',
                  },
                  User: {
                    label: 'Key person',
                    placeholder: 'Key person',
                  },
                },
                title: 'Attendance',
              },
              Funding: {
                Form: {
                  EYPPFunding: {
                    label: 'Child receives EYPP funding',
                  },
                  TwoYearFunding: {
                    label: 'Child receives two year funding',
                  },
                },
                title: 'Funding',
              },
              Sessions: {
                Form: {
                  SessionEnd: {
                    label: 'Session end',
                    placeholder: 'Session end',
                  },
                  SessionStart: {
                    label: 'Session start',
                    placeholder: 'Session start',
                  },
                },
                emptySessionText: 'Add a session set below',
                emptyStatePreviewText: 'Sessions were not defined. You can add them later.',
              },
            },
            title: 'Enrolment details',
          },
          Family: {
            Form: {
              FamilyLanguage: {
                label: 'Language at home',
                placeholder: 'Language at home',
              },
              FamilyMaritalStatus: {
                label: 'Parents\' marital status',
                placeholder: 'Parents\' marital status',
              },
              FamilyPosition: {
                label: 'Position in family',
                placeholder: 'Position in family',
              },
              ParentArmedForcesPersonnel: {
                label: 'Child of serving armed forces personnel',
              },
              Siblings: {
                label: 'Siblings',
                placeholder: 'Siblings',
              },
            },
            title: 'Family',
          },
          GeneralInformation: {
            Form: {
              Address: {
                label: 'Address',
                placeholder: 'Address',
              },
              DateOfBirth: {
                label: 'Date of birth',
                placeholder: 'Date of birth',
              },
              DisplayName: {
                label: 'Display name',
                placeholder: 'Display name',
              },
              Ethnicity: {
                label: 'Ethnicity',
                placeholder: 'Ethnicity',
              },
              FirstName: {
                label: 'First name',
                placeholder: 'First name',
              },
              FundingCode: {
                label: 'Funding code',
                placeholder: 'Funding code',
              },
              Gender: {
                label: 'Gender',
              },
              MiddleName: {
                label: 'Middle name',
                placeholder: 'Middle name',
              },
              Photo: {
                label: 'Profile photo',
              },
              Postcode: {
                label: 'Postcode',
                placeholder: 'Postcode',
              },
              ReferenceCode: {
                label: 'Reference code',
                placeholder: 'Leave blank for auto-generated code',
              },
              Religion: {
                label: 'Religion',
                placeholder: 'Religion',
              },
              Surname: {
                label: 'Surname',
                placeholder: 'Surname',
              },
              TaxFreeChildcareCode: {
                label: 'Tax Free Childcare code / reference',
                placeholder: 'Tax Free Childcare code / reference',
              },
            },
            Sections: {
              allergiesPreferences: 'Allergies and dietary preferences',
              personalInformation: 'Personal information',
            },
            title: 'General information',
          },
          HealthAndDiet: {
            Subsections: {
              Diet: {
                Form: {
                  AdditionalNotes: {
                    label: 'Additional note',
                    placeholder: 'Additional note',
                  },
                  DietaryPreference: {
                    label: 'Dietary preference',
                    placeholder: 'Dietary preference',
                  },
                  FussyEater: {
                    label: 'Fussy eater',
                  },
                },
                title: 'Diet',
              },
              Health: {
                Form: {
                  Allergies: {
                    label: 'Allergies',
                    placeholder: 'Allergies',
                  },
                  AllergiesDetails: {
                    label: 'Allergies details',
                    placeholder: 'Allergies details',
                  },
                  CanConsumeFoodWithNutTraces: {
                    label: 'Has permission to consume food with nut traces',
                  },
                  CanReceiveMedicine: {
                    label: 'Has permission to have medicine administered (e.g. Calpol)',
                  },
                  FacePaint: {
                    label: 'Has permission to have face painted',
                  },
                  HasPermissionToBeTakenToHospital: {
                    label: 'Has permission to be taken to a hospital',
                  },
                  MedicalInformation: {
                    label: 'Medical information',
                    placeholder: 'Medical information',
                  },
                  MedicalInformationInfo: {
                    message1: 'The name of the medication',
                    message2: 'If the medication is short or long term',
                    message3: 'When the medication expires',
                    message4: 'If the medication can be administered',
                    message5: 'When and how to administer the medication and how much',
                    title: 'When detailing medical information ensure you detail the following:',
                  },
                  NappyCream: {
                    label: 'Has permission to have nappy cream applied',
                  },
                  Patches: {
                    label: 'Has permission to have adhesive dressings applied',
                  },
                  SunCream: {
                    label: 'Has permission to have sun cream applied',
                  },
                },
                title: 'Health',
              },
            },
            title: 'Medical details',
          },
          LeavePopup: {
            message: 'You have unsaved changes. Do you want to discard changes or continue editing?',
          },
          LikesDislikes: {
            Form: {
              Books: {
                label: 'Books',
                placeholder: 'Favourite Books',
              },
              Food: {
                label: 'Food',
                placeholder: 'Favourite Food',
              },
              Interests: {
                label: 'Interests',
                placeholder: 'Interests',
              },
              Toys: {
                label: 'Toys',
                placeholder: 'Favourite Toys',
              },
            },
            title: 'Likes & dislikes',
          },
          Permissions: {
            Subsections: {
              Media: {
                Form: {
                  CanBePhotographed: {
                    label: 'Permission to share media with the child\'s family on Blossom',
                  },
                  CanBeTaggedInGroupPhotos: {
                    label: 'Permission to share media with the other children’s families on Blossom',
                  },
                  ClosedSocialMediaPhotoSharingPermitted: {
                    label: 'Permission to share on closed social media channels',
                  },
                  OtherMarketingMaterialPhotoSharing: {
                    label: 'Permission to use child media as marketing material',
                  },
                  SocialMediaPhotoSharing: {
                    label: 'Permission to share on open social media channels',
                  },
                  UseOnSiteMediaPermitted: {
                    label: 'Permission to use media on-site',
                  },
                },
                title: 'Media',
              },
              Play: {
                Form: {
                  CanGoToExternalOutgoings: {
                    label: 'Has permission to go on external outings',
                  },
                },
                title: 'Play',
              },
              Safety: {
                Form: {
                  CanTakeTheBus: {
                    label: 'Has permission to take a bus',
                  },
                },
                title: 'Safety',
              },
            },
            title: 'Permissions',
          },
          Review: {
            submitLabel: 'Enrol child',
            title: 'Review',
          },
          Summary: {
            title: 'Summary',
          },
          createChildButtonLabel: 'Add child',
          title: 'Add a new child',
        },
        BookingPattern: {
          AutoCreditNoting: {
            CreditNoteInvoices: {
              Form: {
                CreditNoteDate: {
                  label: 'Credit note date',
                  placeholder: 'Credit note date',
                },
                CreditNoteReason: {
                  label: 'Credit note reason',
                  placeholder: 'Enter reason',
                },
              },
              Table: {
                Header: {
                  invoice: 'Invoice',
                  invoiceDate: 'Invoice date',
                  invoiceNumber: 'Invoice number',
                  invoiceTotal: 'Invoice total',
                },
              },
              emptyStateText: 'No invoices to credit note.',
              subtitle: 'The following invoices are impacted by the funding and session set change and will be credit noted if you continue. Drafts will be removed.',
              title: 'Credit note invoices',
            },
            LeavePagePopup: {
              cancelButtonLabel: 'Leave page',
              confirmButtonLabel: 'Stay on page',
              leaveOtherPage: 'Leaving this page will close this correction process and you cannot return here to complete it later.',
              leaveReIssueInvoicePageText: 'Leaving this page will close this correction process and save all invoices as drafts.',
            },
            ReAllocateFunding: {
              Table: {
                Header: {
                  fundingAllocation: 'Funding allocation',
                  fundingPeriod: 'Funding period',
                  fundingType: 'Funding type',
                },
                allocateButtonLabel: 'Allocate',
                automaticallyReallocated: 'Automatically re-allocated',
              },
              emptyStateText: 'No funding to allocate',
              subtitle: 'The allocated hours for the following funding types may have been affected by the session set change. Please check and re-allocate the funding hours if needed.',
              title: 'Re-allocate funding',
            },
            ReIssueInvoices: {
              Table: {
                Columns: {
                  Action: {
                    noItemCopy: 'Invoice will not be re-issued',
                    prevDraftCopy: 'Draft invoice will be saved',
                  },
                  Total: {
                    discountReviewCopy: 'Review discount value',
                    errorCopy: 'Invoice error (see top of the page)',
                    noItemCopy: 'No item to invoice',
                  },
                },
                Header: {
                  action: 'Action',
                  invoice: 'Invoice',
                  invoiceDate: 'Invoice date',
                  invoiceTotal: 'Invoice total',
                },
              },
              addInvoiceButtonLabel: 'Add invoice',
              continuePopupText: "This will save all re-issued invoices. If an invoices was marked as 'Save and send', it will send the invoice to the child's invoice recipients.",
              deleteInvoicePopupText: 'Are you sure you want to delete this invoice?',
              emptyStateText: 'No credit noted invoices to re-issue.',
              invoicesTotalLabel: 'Account credit',
              invoicesTotalTooltip: 'Account credit is applied from the oldest invoice first when the invoices are sent.',
              subtitle: 'The invoices below will be re-issued if you continue. Please choose how you want to save them.',
              title: 'Re-issue invoices',
            },
            title: 'Correcting funding and invoices',
          },
          Discounts: {
            discount: 'discount',
            discounts: 'discounts',
            title: 'Discounts',
          },
          ExtraItems: {
            Add: {
              Form: {
                AttendancePeriod: {
                  label: 'Attendance period',
                  placeholder: 'Attendance period',
                  tooltip: 'The attendance period will determine which days the child can attend and when this extra item can be invoiced.',
                },
              },
            },
            extraItem: 'extra item',
            extraItems: 'extra items',
            title: 'Extra items',
          },
          ExtraSessions: {
            Add: {
              LinkedToRequestedExtraSession: {
                banner: 'This extra session is linked to a request made by a child contact.',
                viewRequest: 'View request',
              },
              Title: {
                add: 'Add extra session',
                edit: 'Edit extra session',
              },
            },
            extraSession: 'extra session',
            extraSessions: 'extra sessions',
            title: 'Extra Sessions',
          },
          Funding: {
            Add: {
              addTitle: 'Assign funding',
              archivePopupCopy: 'Are you sure you want to archive this child funding? You can unarchive it again at any time.',
              editTitle: 'Edit funding allocation',
              exclusionPeriodLabel: 'Exclusion periods',
              fundingPopupCopy: 'Changes to this funding will only affect uninvoiced sessions. You may also need to reallocate funding.',
              fundingTypeLabel: 'Funding type',
              fundingTypePlaceholder: 'Select funding type',
              hourlyRateLabel: 'Hourly rate',
              hourlyRatePlaceholder: '0.00',
              hoursPerWeekLabel: 'Hours per week',
              maxHoursPerDay: 'Max hours per day',
              periodLabel: 'Period',
              periodTooltip: 'The start date of the funding allocation cannot be changed if and invoice has already been sent with the funding allocated.',
              subtitle: 'Here you can select funding type create for the nursery and configure them for {{ childName }}.',
              totalFundingValueLabel: 'Total funding value',
              totalFundingValuePlaceholder: '0.00',
              totalHoursInfoBlock1: 'You have changed the default period for this funding.',
              totalHoursInfoBlock2: 'Please enter the number of hours this child will receive funding for.',
              totalHoursInfoBlock3: "If full month periods are not selected, your funding will be calculated on 'actuals' rather than 'averages'.",
              totalHoursLabel: 'Total hours',
              unarchivePopupCopy: 'Are you sure you want to unarchive this child funding? You can archive it again at any time.',
            },
            Allocation: {
              Description: {
                closureDateLabel: 'Closure date',
                subtitle: 'Select a session below to allocate funded hours for',
              },
              Form: {
                addFundingTimeButtonLabel: 'Add funding time',
              },
              FundingDetail: {
                TotalFundingValue: 'Total funding value: ',
                TotalFundingValueDivider: ' / ',
                canOverridden: 'can overridden',
                cannotOverridden: 'cannot overridden',
                fundingHoursAllocated: 'Funded hours allocated: {{ hoursAllocated }} /  {{ totalHours }} hours',
                maxHoursPerDay: 'Max hours per day',
                maxHoursPerWeek: 'Max hours per week',
              },
              addSessionSetLabel: 'Add session set',
              allocatingCopy: 'Please wait allocating',
              applyButtonLabel: 'Apply allocation to following weeks',
              applyFundingSuccessCopy: 'Funding has been successfully allocated to future weeks.',
              applyFundingWarningCopy: 'Are you sure you want to allocate funding for future weeks?',
              emptyStateText1: '{{ childFirstName }} has no sessions to allocate funding.',
              finishAllocationLabel: 'Finish allocation',
              subtitle: 'Editing the funded hours allocation here will update across the whole session set until the end of the funding period.',
              title: 'Allocate funding',
            },
            title: 'Funding',
          },
          RegularBookings: {
            Add: {
              addDiscount: 'Add discount',
              addFundingType: 'Add funding type',
              addRegularItems: 'Add regular items',
              addSessions: 'Add sessions',
              allocationRecalculationIsInProgress: 'Allocation recalculation is in progress',
              alternateEvery: 'Alternate every',
              alternateWeek: 'Alternate week',
              attendanceSchedule: 'Attendance schedule',
              confirmCancel: 'Do you want to cancel the process?',
              confirmChangeAlternateWeek: 'You have added items for alternate weeks. This change will remove some of them. Are you sure?',
              defineRequireFields: 'Please fill required fields to go next',
              discount: 'Discount',
              discountForAlternatingWeek: 'Discount for alternating week',
              discounts: 'Discounts',
              existChildProductAddedToNotOpenedDay: 'There are line items added on days the nursery is not open ({{ weekdays }}). Please remove the line items to save the booking pattern.',
              existInvoices: 'This booking pattern already has invoices. Please credit note the invoices or create a new booking pattern.',
              feeCalculation: 'Fee calculation',
              fixedAmount: 'Fixed amount',
              funding: 'Funding',
              fundingAllocationWillBeRecalculated: 'The funding allocation will be recalculated due to the session changes',
              fundingForAlternatingWeek: 'Funding for alternating week',
              fundingType: 'Funding type',
              generalInformation: 'General information',
              hoursPerWeek: 'Hours per week',
              invoiceDisplaySettings: 'Invoice display settings',
              invoicing: 'Invoicing',
              localAuthorityHourlyRate: 'Local authority hourly rate',
              maxHoursPerDay: 'Max hours per day',
              monthlyPackagePrice: 'Monthly package price',
              moreAlternatingWeeksInfo: 'When using alternating weeks you will not be able to annualise the invoices or create weekly or monthly packages & fixed price fees.',
              packageInvoiceLineItem: 'Package invoice line item description',
              packageInvoiceLineItemPlaceholder: 'Eg. 3 day package',
              periodHasInvoice: 'This period has one or more invoices. Please credit note the invoices before creating the new booking pattern.',
              recalculationFailed: 'Recalculation failed',
              regularSessionsAndRegularItems: 'Regular sessions and regular items',
              removeChildProduct: 'Are you sure you want to remove this item?',
              saveBookingPattern: 'Save booking pattern',
              sessionAndRegularItems: 'Session & regular items',
              title: 'Create new regular booking',
              untilChildLeaves: 'Until child leaves',
              weeklyPackagePrice: 'Weekly package price',
              weeklyTotal: 'Weekly total',
              weeks: 'week(s)',
              youMustAsFirstSetStartDate: 'You must as first set start date',
            },
            Preview: {
              actualPriceForTypicalWeek: 'Actual price fo typical week',
              annualised: 'Annualised',
              attendanceSchedule: 'Attendance schedule',
              calendarMonthly: 'Calendar monthly',
              difference: 'Difference',
              estimatedWeeklyTotal: 'Estimated weekly total',
              fundingSummary: 'Funding summary',
              invoiceCalculation: 'Invoice calculation',
              invoicing: 'Invoicing',
              monthlyAnnualisedTotal: 'Monthly annualised total',
              monthlyPackage: 'Monthly package',
              priceChanges: 'Price changes',
              priceChangesTooltip: 'Price changes are calculated automatically and include scheduled price changes for sessions, items and funding hourly rates, as well increase of thession prices based on the child\'s age.',
              priceGroup: 'Price group',
              scheduleBookingPatternChange: 'Schedule booking pattern change',
              title: 'Regular bookings',
              totalForATypicalWeek: 'Total for a typical week',
              week: 'Week {{ index }}',
              weeklyFixedPrice: 'Weekly fixed price',
              weeklyPackage: 'Weekly package',
            },
            components: {
              AllocationBar: {
                fundedHours: 'Funded hours',
              },
              FundingSummary: {
                fundingAllocatedAcrossBookingPatterns: 'Funding allocated across booking patterns',
                fundingAllocatedForThisBookingPattern: 'Funding allocated for this booking pattern',
                fundingAllocatedForTypicalWeek: 'Funding allocated for typical week (Alternating week {{ week }})',
                fundingInvoiced: 'Funding invoiced',
              },
            },
          },
          Sessions: {
            Add: {
              addTitle: 'Create session set',
              allocationPeriodTitle: 'Are these sessions term time or year round?',
              attendancePeriod: 'Attendance period',
              attendancePeriodSetupPopup: 'Set up your attendance periods first to determine which dates children can attend.',
              attendancePeriodTooltip: 'The attendance period will determine which days the child can attend and when these sessions can be invoiced.',
              carerEmailExistsCopy: '{{ emailIds }} already exists. Please edit the contact and select "existing contact".',
              dateError: 'Please enter End date or check Ongoing sessions.',
              dateRangeConflictCopy: 'The date range of these sessions conflict with other sessions set for this child. Please amend your start or end date.',
              dateRangeConflictError: 'The session end date can not be earlier than the start date.',
              dateSectionTitle: 'When do these sessions start and end?',
              deletePopupCopy: 'Are you sure you want to remove this child session?',
              editTitle: 'Edit session set',
              emptySessionCopy: 'Please select at least one session to save this session set.',
              fundingPopupCopy: 'Are you sure you want to edit these sessions? Please note: any changes will affect uninvoiced sessions. You may also need to reallocate funding.',
              invoiceExistsWarningText: 'There are already invoices for this session set. To change sessions create a new session set.',
              listActionButtonText: 'Add session',
              noSessions: 'No sessions',
              ongoingSession: 'Ongoing sessions',
              ongoingSessionTooltip: "Ongoing sessions will discontinue when the child's end date arrives.",
              sessionCalculationTitle: 'Fee calculation for sessions',
              sessionTime: 'Session time',
              timeOverlappingError: 'Session times can not be overlapping on {{ days }}.',
            },
            List: {
              Current: {
                EmptyState: {
                  actionButtonLabel: 'Add session',
                  text1: 'There are no current sessions for {{ firstName }}.',
                  text2: 'Add a session set below',
                },
                OpeningDaysEmptyState: {
                  actionButtonLabel: 'Set opening days',
                  text1: 'Please set your opening days in the nursery settings to add sessions.',
                },
                ongoing: 'Ongoing',
                title: 'Current sessions',
              },
              Future: {
                EmptyState: {
                  text1: 'Are {{ firstName }}’s sessions going to change in the future?',
                  text2: 'Add them here for your invoices and planning.',
                },
                addButtonLabel: 'Add future session',
                title: 'Future sessions',
              },
              sessionHistory: 'Session history',
            },
            title: 'Sessions',
          },
        },
        Contacts: {
          Form: {
            accessToParentApp: 'Access to parent app',
            addContact: 'Add contact',
            addNewContact: 'Add new contact',
            address: 'Address',
            chooseContact: 'Choose contact',
            contactInformation: 'Contact Information',
            editContact: 'Edit contact',
            email: 'E-mail address',
            existingContact: 'Existing contact',
            firstName: 'First name',
            generalInformation: 'General Information',
            lostUnsavedChanges: 'Are you sure? Any unsaved changes will be lost',
            mobile: 'Mobile',
            newContact: 'New contact',
            occupation: 'Occupation',
            parentalResponsibility: 'Parental responsibility',
            passwordForCollection: 'Password for collection',
            permissions: 'Permissions',
            photo: 'Photo',
            postcode: 'Postcode',
            receivesDiaryViaEmail: 'Receives diary via email',
            receivesNewsPostsViaEmail: 'Receives news posts via email',
            relation: 'Relation',
            removeCarer: 'Are you sure you want to delete this carer?',
            resendInvitationButton: 'Resend invitation',
            resendInvitationModalErrorText: 'We were not able to resend the invitation, please try again later.',
            resendInvitationModalSuccessText: 'Your invitation has been resent to {{ carerEmail }}. This may take a few minutes.',
            specificInformationFor: 'Specific information for',
            surname: 'Surname',
            telephone: 'Telephone',
            title: 'Title',
            workNumber: 'Work number',
          },
          List: {
            Access: 'Access',
            AddNewContact: 'Add new contact',
            Contacts: 'Contacts',
            FamilyContact: 'Family contact',
            Name: 'Name',
            Pagination: {
              plural: 'contacts',
              singular: 'contact',
            },
            ParentApp: 'Parent app',
            ParentalResponsibility: 'Parental Responsibility',
            Relation: 'Relation',
            emailNote: 'This e-mail address can not be changed because it is used by the contact as login credentials for the parent app.',
            notFound: 'No contact information for current child. Add new contact to get started.',
          },
        },
        DailyDiary: {
          administerWas: '{{ child }} was administered',
          attendanceStart: '**Started** {{ determiner }} day',
          attendanceStop: '**Finished** {{ determiner }} day',
          bottleFeed: '{{ child }} drank **{{ amount }}oz** of **milk**',
          childDidNotSleep: '{{ child }} did not **sleep**',
          childSlept: '{{ child }} **slept** for {{ time }}',
          comments: 'Comments ({{ amount }})',
          diaryEntry: 'Diary entry',
          eatingRecord: '{{ child }} {{ hadA }} **{{ type }}**',
          foodItemContent: 'had {{ amount }} of {{ determiner }} {{ food }}',
          had: 'had',
          hadA: 'had a',
          hadANappyRash: 'Had a nappy rash',
          hadAccident: 'Had an accident',
          her: 'her',
          his: 'his',
          myDailyDiaryTitle: "{{ child }}'s diary",
          nappyChanged: "{{ child }}'s **nappy** was changed",
          nappyWas: 'Nappy was {{ action }}',
          notFound: 'There is no diary available for this date.',
          their: 'their',
          title: 'Diary timeline',
          toiletTrainingRecordTitle: "{{ child }}'s **toilet training** progress",
          toiletTrainingUsed: 'Used a {{ action }}',
          wasCreamApplied: 'Cream was applied',
        },
        Edit: {
          ConfirmMessageBeforeSave: {
            GeneralInformation: {
              BirthDate: {
                occupancy: 'Are you sure you want to edit the child general information? Please note: edit the date of birth will unconfirm and recalculate any confirmed room moves.',
              },
            },
            NurseryInformation: {
              StartOrLeavingDate: {
                OccupancyFunding: {
                  copy1: 'Are you sure you want to edit the child nursery information? Please note: edit the start or leaving date will:',
                  copy2: '- Unconfirm and recalculate any confirmed room moves',
                  copy3: '- You may also reallocate funding',
                },
                funding: 'Are you sure you want to edit the child nursery information? Please note: edit the start or leaving date you may also reallocate funding.',
                occupancy: 'Are you sure you want to edit the child nursery information? Please note: edit the start or leaving date will unconfirm and recalculate any confirmed room moves.',
              },
            },
          },
          deleteConfirmationMessage: 'Are you sure you want to {{ action }} {{ childName }}?',
        },
        Finance: {
          BacsDetails: {
            EmptyState: {
              text: 'No active BACS Direct Debit mandate.',
            },
            Form: {
              AccountHolder: {
                label: 'Account holder',
                placeholder: 'Account holder',
              },
              AccountNo: {
                label: 'Account no.',
                placeholder: 'Account no.',
              },
              ActiveBacsMandate: {
                label: 'Active BACS mandate',
              },
              BankName: {
                label: 'Bank name',
                placeholder: 'Bank name',
              },
              SortCode: {
                label: 'Sort code',
                placeholder: 'Sort code',
              },
              StartMonthlyDirectDebitRunOn: {
                label: 'Start monthly Direct Debit run on',
                placeholder: 'Select date',
                tooltip: 'A Direct Debit run usually take around 3 business days to be completed',
              },
            },
            accountHolder: 'Account holder:',
            accountNo: 'Account no.:',
            activeBacsMandate: 'Active BACS mandate:',
            bankName: 'Bank name:',
            disabledInfo: 'BACS Direct Debit mandate is created via Stripe and cannot be deactivated.',
            sortCode: 'Sort code:',
            startMonthlyDirectDebitRunOn: 'Start monthly Direct Debit run on:',
            tabTitle: 'BACS details',
            title: 'BACS Direct Debit details',
          },
          BankDetails: {
            EmptyState: {
              buttonLabel: 'Add Bank Details',
              text1: 'Add bank details for this parent account.',
            },
            Form: {
              AccountName: {
                label: 'Account holder',
                placeholder: 'Account holder',
              },
              AccountNumber: {
                label: 'Account number',
                placeholder: 'Account number',
              },
              BankName: {
                label: 'Bank name',
                placeholder: 'Bank name',
              },
              Notes: {
                label: 'Bank account notes',
                placeholder: 'Bank account notes',
              },
              SortCode: {
                label: 'Sort code',
                placeholder: 'Sort code',
              },
              UsualPaymentMethod: {
                label: 'Usual payment method',
                placeholder: 'Usual payment method',
              },
            },
            accountNameLabel: 'Account holder:',
            accountNumberLabel: 'Account no:',
            bankNameLabel: 'Bank name:',
            notesLabel: 'Bank account notes:',
            sortCodeLabel: 'Sort code:',
            tabTitle: 'Bank details',
            usualPaymentMethodLabel: 'Usual payment method:',
          },
          ContactDetails: {
            AdditionalInvoiceRecipients: 'Additional invoice recipients',
            ContactForm: {
              PostCode: {
                label: 'Post Code',
              },
              SelectContact: {
                placeholder: 'Select contact',
              },
              UseCustomEmail: {
                label: 'Use custom email',
              },
            },
            EmptyState: {
              actionButtonLabel: 'Select contact',
              missingContactText: 'There are no contacts for {{ childFirstName }}. Add a contact in their profile to select as the primary contact for invoices.',
              text1: 'Add a primary contact for invoicing and billing.',
            },
            Validation: {
              carerEmailNotFound: 'A selected recipient does not have an email address and therefore cannot be selected as an invoice recipient.',
              customEmailRequired: 'Please enter a different email address or switch off this option.',
              fundingLoopCarerDetailsNotFound: 'To select a contact for funding, please fill in the address, postcode and email fields in the contact settings.',
              invoiceRecipientSameAsPrimary: 'Primary invoicing contact can not be added here.',
            },
            additionalParticipantText: '{{ count }} additional recipient',
            additionalParticipantsText: '{{ count }} additional recipients',
            addressLabel: 'Address',
            contactAndBankDetails: 'Contact and bank details',
            emailLabel: 'Email address',
            fundingLoopContact: 'Funding loop contact',
            invoiceRecipientsLabel: 'Invoice recipients',
            nameLabel: 'Name',
            postCodeLabel: 'Postcode',
            primaryInvoicingContact: 'Primary invoicing contact',
          },
          CreditNotes: {
            Table: {
              Header: {
                amount: 'Amount',
                itemType: 'Item type',
              },
              Summary: {
                creditNote: 'Credit note',
              },
            },
            createdBy: 'Created by',
            createdOn: 'Created on',
            date: 'Credit note date',
            downloadComplete: 'Credit note has been downloaded',
            downloading: 'Downloading...',
            invoiceReference: 'Invoice reference',
            member: 'Credit note number',
            resendAlertText: 'Are you sure you want to resend this credit note?',
            sendAlertText: 'Are you sure you want to send this credit note?',
            sendComplete: 'Credit note has been send',
            title: 'Credit note',
          },
          Invoice: {
            Add: {
              Modals: {
                autoCalculateItems: 'Do you want to automatically calculate your fees for this date range',
                calculatingInvoice: 'Calculating...',
                deleteInvoice: 'Are you sure you want to delete this invoice?',
                downloadInvoice: 'Are you sure you want to save and download this invoice?',
                downloadingInvoice: 'Downloading...',
                markAsBadDebt1: 'Are you sure you want to unmark this invoice as bad debt?',
                markAsBadDebt2: 'Please note: you can mark this invoice as bad debt again at any time.',
                markAsSent: 'Your invoice has been marked as sent!',
                markingAsSent: 'Marking as sent...',
                noItemFound: 'No item(s) found to invoice',
                sendingInvoice: 'Sending...',
                sentInvoice: 'Your invoice has been sent!',
              },
              addTitle: 'Add an invoice',
              editTitle: 'Edit draft invoice',
              invoiceDatePlaceholder: 'Invoice date',
              invoiceDueDateLabel: 'Due date',
              invoiceDueDatePlaceholder: 'Due date',
              invoiceNamePlaceholder: 'Invoice title',
              invoiceNumberPlaceholder: 'Invoice number',
              invoicePeriodPlaceholder: 'Invoice period',
            },
            draftInvoiceNumberCopy: 'The invoice number and any debit or credit will be applied when the draft invoice is sent or marked as sent.',
          },
          Invoicing: {
            amount: 'Amount',
            cannotBePaidOverTheParentApp: 'The outstanding balance is below {{ value }} and can not be paid over the parent app.',
            creditNoteLinked: 'Credit note linked',
            date: 'Date',
            invoice: 'Invoice',
            invoiceDate: 'Invoice date',
            invoicePeriod: 'Invoice period',
            refNumber: 'Ref number',
            selectStatus: 'Select status',
            selectType: 'Select type',
            status: 'Status',
            title: 'Invoicing',
            titleTable: 'Title',
            totalBilledToDate: 'Total billed to date',
            totalOutstanding: 'Total outstanding',
            type: 'Type',
            unpaidAmount: 'Unpaid amount',
          },
          Notes: {
            Add: {
              placeholder: 'Add notes',
            },
            tabTitle: 'Notes',
          },
          Payment: {
            Add: {
              amountTooltip: 'This will allocate the payment to invoices in the order from oldest invoices first. If all outstanding invoices are covered, the remainder will go into account overpayment',
              breadcrumbsTitle: 'Add payment',
              commentPlaceholder: 'Enter comment',
              duplicatePaymentError: 'Unable to save payment. Please try again.',
              receiptNumberLabel: 'Receipt number',
              sendReceiptErrorAlert: "A primary contact has not been selected to send receipts to. Please assign a contact in the child's account or untick the box to register the payment.",
              sendReceiptLabel: 'Send receipt',
              title: 'Register a payment',
              totalOutstandingLabel: 'Total outstanding',
              totalOutstandingSuffix: ' CR',
              voucherNameLabel: 'Voucher name',
            },
          },
          PaymentHistory: {
            emptyState: 'No payments have been registered to this account yet! Register a payment against an invoice to see it here.',
            title: 'Payment history',
          },
          PlanView: {
            Summary: {
              detailViewButtonLabel: 'View plan details',
              discount: 'Discounts',
              discountEmptyState: 'No discounts',
              emptyState: 'There is nothing added to the current plan for {{ childFirstName }}.',
              extraItems: 'Extra items',
              extraItemsEmptyState: 'No extra items',
              extraSessions: 'Extra Sessions',
              extraSessionsEmptyState: 'No extra sessions',
              funding: 'Funding',
              fundingEmptyState: 'No funding',
              more: '+{{ count }} more',
              session: 'Sessions',
              sessionEmptyState: 'No sessions',
            },
            tabTitle: 'Current plan',
          },
          Transactions: {
            title: 'Transactions',
            transaction: 'transaction',
            transactions: 'transactions',
          },
        },
        Funding: {
          List: {
            Table: {
              Headers: {
                fundingType: 'Funding type',
                hourlyRate: 'Hourly rate',
                period: 'Period',
                totalFundingValue: 'Total funding value',
                totalHours: 'Total hours',
              },
            },
            assignFundingLabel: 'Assign funding',
            emptyStateText1: 'Does {{ childFirstName }} receive funding?',
            emptyStateText2: 'Track all funding for {{ childFirstName }} here.',
            statusDropdownPlaceholder: 'Status',
            title: 'Funding',
          },
        },
        LearningJourney: {
          FormativeReports: {
            title: 'Formative reports',
          },
          Framework: {
            ageGroup: 'Age group',
            areaOfLearning: 'Area of learning',
            bulkMark: 'Bulk Mark',
            createFormativeReport: 'Create formative report',
            noFrameworksList: 'To use the framework page, activate a curriculum in the settings that is compatible with it.',
            title: 'Framework',
          },
          NextSteps: {
            title: 'Next steps',
          },
          Observations: {
            title: 'Observations',
          },
        },
        Menu: {
          about: 'About',
          accidentsIncidents: 'Safeguarding',
          bookingPattern: 'Booking pattern',
          contacts: 'Contacts',
          diary: 'Diary',
          finance: 'Finance',
          learningJourney: 'Learning Journey',
          notes: 'Notes',
        },
        Notes: {
          Edit: {
            confirmRemove: 'Are you sure you want to delete this note?',
            enterNotesHere: 'Enter notes here',
            title: 'Title',
            titleAdd: 'Add new note',
            titleEdit: 'Edit note',
          },
          List: {
            addANewNote: 'Add a new note',
            notFound: 'There are no notes at the moment',
            title: 'Notes',
          },
        },
        Setup: {
          Contact: {
            title: 'Add a contact',
            tooltip: 'You may have had your children uploaded by Blossom. If so, you will have their contacts uploaded! You may want to add childminders & grandparents too. If you are creating a contact from scratch, you have the ability to search for an existing contact or create a new one!',
          },
          RoomMoves: {
            title: 'Check and confirm room moves',
            tooltip: 'By confirming room moves, you are finalising when each child will move. They will then appear on the register accordingly. If room moves are not confirmed, they will still create an occupancy forecast but this will be an estimate until room moves confirmed.',
          },
          Session: {
            title: 'Add a session set',
            tooltip: "Here you can add children's booking patterns. You can stipulate, start and end dates or simply click ongoing if it is a continuous pattern. This will populate your registers and feed into your invoicing and occupancy. You can also create future session sets if you know a child will be amending days.",
          },
          title: 'Basic child setup',
        },
        accessDeniedEmptyText: "You don't have permission to see this child profile, because the child is not part of your typical room.",
      },
      Constants: {
        ChildAgesOptions: {
          '2years': '2 years old',
          '3years': '3 years old',
          '4years': '4 years old',
          '5years': '+5 years old',
          allAges: 'All ages',
          under2: 'Under 2 years old',
        },
        ChildrenStatusOptions: {
          active: 'Active',
          archived: 'Archived',
          enrolled: 'Enrolled',
          upcoming: 'Upcoming',
        },
        DietaryAllergiesOptions: {
          allergiesDetailsLabel: 'Allergies details',
          allergiesLabel: 'Allergies',
          hasAllergyLabel: 'Has allergy',
          noAllergiesLabel: 'No allergies',
          noAllergyLabel: 'No allergy',
          unknownAllergyLabel: 'Unknown allergy',
        },
        DietaryRequirementsOptions: {
          childDietaryNoPreferenceLabel: "Child's dietary preference is required.",
          missingInfoLabel: 'Missing info',
          noPreferenceLabel: 'No preference',
          pescatarianLabel: 'Pescatarian',
          unknownDietaryPreference: 'Unknown dietary preference',
          veganLabel: 'Vegan',
          vegetarianLabel: 'Vegetarian',
        },
        FamilyMaritalStatusOptions: {
          coHabiting: 'Co-habiting',
          divorced: 'Divorced',
          married: 'Married',
          partners: 'Partners',
          separated: 'Separated',
          single: 'Single',
          widowed: 'Widowed',
        },
        GenderOptions: {
          femaleLabel: 'Female',
          maleLabel: 'Male',
          nonBinary: 'Non-binary',
          otherLabel: 'Other',
          unknown: 'Unknown',
        },
        LanguagesOptions: {
          abkhaz: 'Abkhaz',
          afar: 'Afar',
          afrikaans: 'Afrikaans',
          akan: 'Akan',
          albanian: 'Albanian',
          amharic: 'Amharic',
          arabic: 'Arabic',
          aragonese: 'Aragonese',
          armenian: 'Armenian',
          assamese: 'Assamese',
          avaric: 'Avaric',
          avestan: 'Avestan',
          aymara: 'Aymara',
          azerbaijani: 'Azerbaijani',
          bambara: 'Bambara',
          bashkir: 'Bashkir',
          basque: 'Basque',
          belarusian: 'Belarusian',
          bengali: 'Bengali',
          bihari: 'Bihari',
          bislama: 'Bislama',
          bosnian: 'Bosnian',
          breton: 'Breton',
          bulgarian: 'Bulgarian',
          burmese: 'Burmese',
          cantonese: 'Cantonese',
          catalan: 'Catalan; Valencian',
          chamorro: 'Chamorro',
          chechen: 'Chechen',
          chichewa: 'Chichewa; Chewa; Nyanja',
          chuvash: 'Chuvash',
          cornish: 'Cornish',
          corsican: 'Corsican',
          cree: 'Cree',
          croatian: 'Croatian',
          czech: 'Czech',
          danish: 'Danish',
          divehi: 'Divehi; Dhivehi; Maldivian;',
          dutch: 'Dutch',
          english: 'English',
          esperanto: 'Esperanto',
          estonian: 'Estonian',
          ewe: 'Ewe',
          faroese: 'Faroese',
          fijian: 'Fijian',
          finnish: 'Finnish',
          french: 'French',
          french_creole: 'French Creole',
          fula: 'Fula; Fulah; Pulaar; Pular',
          galician: 'Galician',
          georgian: 'Georgian',
          german: 'German',
          greek: 'Greek; Modern',
          guarani: 'Guaraní',
          gujarati: 'Gujarati',
          haitian: 'Haitian; Haitian Creole',
          hausa: 'Hausa',
          hebrew: 'Hebrew (modern)',
          herero: 'Herero',
          hindi: 'Hindi',
          hiri_motu: 'Hiri Motu',
          hungarian: 'Hungarian',
          icelandic: 'Icelandic',
          ido: 'Ido',
          igbo: 'Igbo',
          indonesian: 'Indonesian',
          interlingua: 'Interlingua',
          interlingue: 'Interlingue',
          inuktitut: 'Inuktitut',
          inupiaq: 'Inupiaq',
          irish: 'Irish',
          italian: 'Italian',
          japanese: 'Japanese',
          javanese: 'Javanese',
          kalaallisut: 'Kalaallisut; Greenlandic',
          kannada: 'Kannada',
          kanuri: 'Kanuri',
          kashmiri: 'Kashmiri',
          kazakh: 'Kazakh',
          khmer: 'Khmer',
          kikuyu: 'Kikuyu; Gikuyu',
          kinyarwanda: 'Kinyarwanda',
          kirghiz: 'Kirghiz; Kyrgyz',
          kirundi: 'Kirundi',
          komi: 'Komi',
          kongo: 'Kongo',
          korean: 'Korean',
          kurdish: 'Kurdish',
          kwanyama: 'Kwanyama; Kuanyama',
          lao: 'Lao',
          latin: 'Latin',
          latvian: 'Latvian',
          limburgish: 'Limburgish; Limburgan; Limburger',
          lingala: 'Lingala',
          lithuanian: 'Lithuanian',
          luba_katanga: 'Luba-Katanga',
          luganda: 'Luganda',
          luxembourgish: 'Luxembourgish; Letzeburgesch',
          macedonian: 'Macedonian',
          malagasy: 'Malagasy',
          malay: 'Malay',
          malayalam: 'Malayalam',
          maltese: 'Maltese',
          mandarin: 'Mandarin',
          manx: 'Manx',
          maori: 'Māori',
          marathi: 'Marathi (Marāṭhī)',
          marshallese: 'Marshallese',
          mongolian: 'Mongolian',
          nauru: 'Nauru',
          navajo: 'Navajo; Navaho',
          ndonga: 'Ndonga',
          nepali: 'Nepali',
          north_ndebele: 'North Ndebele',
          northern_sami: 'Northern Sami',
          norwegian: 'Norwegian',
          norwegian_bokmål: 'Norwegian Bokmål',
          norwegian_nynorsk: 'Norwegian Nynorsk',
          nuosu: 'Nuosu',
          occitan: 'Occitan',
          ojibwe: 'Ojibwe; Ojibwa',
          old_church_slavonic: 'Old Church Slavonic; Church Slavic; Church Slavonic; Old Bulgarian; Old Slavonic',
          oriya: 'Oriya',
          oromo: 'Oromo',
          ossetian: 'Ossetian; Ossetic',
          pali: 'Pāli',
          panjabi: 'Panjabi; Punjabi',
          papiamentu: 'Papiamentu',
          pashto: 'Pashto; Pushto',
          persian: 'Persian',
          polish: 'Polish',
          portuguese: 'Portuguese',
          quechua: 'Quechua',
          romanian: 'Romanian',
          romanian_moldavian: 'Romanian; Moldavian; Moldovan',
          romansh: 'Romansh',
          russian: 'Russian',
          samoan: 'Samoan',
          sango: 'Sango',
          sanskrit: 'Sanskrit (Saṁskṛta)',
          sardinian: 'Sardinian',
          scottish_gaelic: 'Scottish Gaelic; Gaelic',
          serbian: 'Serbian',
          shona: 'Shona',
          sign_language: 'Sign language',
          sindhi: 'Sindhi',
          sinhala: 'Sinhala; Sinhalese',
          slovak: 'Slovak',
          slovene: 'Slovene',
          somali: 'Somali',
          south_ndebele: 'South Ndebele',
          southern_soth: 'Southern Sotho',
          spanish_castilian: 'Spanish; Castilian',
          sundanese: 'Sundanese',
          swahili: 'Swahili',
          swati: 'Swati',
          swedish: 'Swedish',
          tagalog: 'Tagalog',
          tahitian: 'Tahitian',
          tajik: 'Tajik',
          tamil: 'Tamil',
          tatar: 'Tatar',
          telugu: 'Telugu',
          thai: 'Thai',
          tibetan_standard: 'Tibetan Standard; Tibetan; Central',
          tigrinya: 'Tigrinya',
          tonga: 'Tonga (Tonga Islands)',
          tsonga: 'Tsonga',
          tswana: 'Tswana',
          turkish: 'Turkish',
          turkmen: 'Turkmen',
          twi: 'Twi',
          uighur: 'Uighur; Uyghur',
          ukrainian: 'Ukrainian',
          urdu: 'Urdu',
          uzbek: 'Uzbek',
          venda: 'Venda',
          vietnamese: 'Vietnamese',
          volapuk: 'Volapük',
          wallon: 'Walloon',
          welsh: 'Welsh',
          western_frisian: 'Western Frisian',
          wolof: 'Wolof',
          xhosa: 'Xhosa',
          yiddish: 'Yiddish',
          yoruba: 'Yoruba',
          zhuang: 'Zhuang; Chuang',
        },
      },
      List: {
        Filters: {
          ageInMonthsFromPlaceholder: 'From',
          ageInMonthsLabel: 'Age in months',
          ageInMonthsToPlaceholder: 'To',
          allRoomsPlaceHolder: 'All rooms',
          statusPlaceHolder: 'Status',
        },
        createButtonLabel: 'Add a new child',
        emptyStateText: 'There are no children matching your current criteria.',
        exportChildren: 'Export children',
        title: 'Children',
      },
      Routing: {
        Child: {
          BookingPattern: {
            autoCreditNoting: 'Auto credit noting',
          },
          Profile: {
            Profile: 'Profile',
            ProfileHistory: 'Profile history',
          },
        },
      },
    },
    DailyDiary: {
      Activities: {
        Media: 'Media',
        activity: 'Activity',
        activityName: 'Activity name',
        addedSuccess: 'Activity record has been added.',
        changeChildren: 'This will update the children in this activity. You may need to update the media tags.',
        confirmRemove: 'Are you sure you want to remove this activity record?',
        listInfo: 'Children who are present and registered for activities are listed below.',
        numberOfActivities: 'Number of activities completed',
        removeActivity: 'This will remove the child from this activity',
        removedSuccess: 'Activity record has been successfully removed.',
        updatedSuccess: 'Activity record has been successfully updated.',
      },
      Bottles: {
        addBottleFeed: 'Add bottle feed',
        addedSuccess: 'Bottle feed record has been added.',
        amountDrunk: 'Amount drunk',
        confirmRemove: 'Are you sure you want to remove this bottle feed record?',
        listInfo: 'Children who are present and registered for bottle feeds are listed below.',
        noRecords: 'There are no children in this date who have bottle feeds.',
        removedSuccess: 'Bottle feed record has been successfully removed.',
        updatedSuccess: 'Bottle feed record has been successfully updated.',
      },
      DailyDiary: {
        Activities: 'News/Activ.',
        Bottles: 'Bottles',
        Meals: 'Meals',
        Sleeps: 'Sleeps',
        Snacks: 'Snacks',
        dailyDiary: 'Daily diary',
        medications: 'Medications',
        nappiesToilet: 'Nappies/Toilet',
      },
      Foods: {
        Meal: 'Meal',
        Snack: 'Snack',
        addBottleFeed: 'Add bottle feed',
        addedSuccess: 'Bottle feed record has been added.',
        amountDrunk: 'Amount drunk',
        confirmRemove: 'Are you sure you want to remove this bottle {{ name }} record?',
        foodAmount: {
          all: 'All',
          most: 'Most',
          none: 'None',
          over: '+1',
          overLong: 'more than one portion',
          some: 'Some',
        },
        foodMenu: {
          GeneralMenu: 'General menu',
          VegetarianMenu: 'Vegetarian menu',
          menuSaved: 'Menu has been successfully saved',
          menuUpdated: 'Menu has been successfully updated',
          typeAFoodOption: '...type a food option',
        },
        listInfo: 'Children who are present and registered for bottle feeds are listed below.',
        meal: 'meal',
        noRecords: 'There are no children in this date who have bottle feeds.',
        recordReset: 'Record data has been cleared',
        removedSuccess: '{{ name }} record has been successfully removed.',
        snack: 'snack',
        updatedSuccess: '{{ name }} record has been successfully updated.',
      },
      Medication: {
        Table: {
          ActionButtons: {
            administer: 'Administer',
            parentSignature: 'Parent signature',
          },
          DropdownMenu: {
            administrationDetails: 'Administration details',
            medicationForm: 'Medication form',
          },
          dose: 'Dose',
          expiredMessage: '{{ medication }} is expired. Please end the <0>medication form</0> and create a new one.',
          medication: 'Medication',
        },
        emptyStateText1: 'There are no active medication forms.',
        emptyStateText2: 'The list of all required administrations will be shown here.',
        listInfo: 'Children who are present for medication administers are listed below.',
      },
      Nappies: {
        accident: 'Accident',
        addNappyFeed: 'Add nappy change',
        addToiletTraining: 'Add toilet training',
        addedSuccess: 'Nappy record has been added.',
        confirmRemove: 'Are you sure you want to remove this nappy record?',
        creamApplied: 'Cream applied',
        listInfo: 'Children who are present and registered for nappy changes are listed below.',
        nappyChange: 'Nappy change',
        nappyRash: 'Nappy rash',
        nappyWas: 'Nappy was',
        noRecords: 'There are no children in this date who are scheduled to nappy change.',
        removedSuccess: 'Nappy record has been successfully removed.',
        toiletTraining: 'Toilet training',
        toiletTrainingAddedSuccess: 'Toilet training has been added.',
        toiletTrainingConfirmRemove: 'Are you sure you want to remove this toilet training record?',
        toiletTrainingRemovedSuccess: 'Toilet training record has been successfully removed.',
        toiletTrainingUpdatedSuccess: 'Toilet training record has been successfully updated.',
        trackToiletTraining: 'Track toilet training',
        updatedSuccess: 'Nappy record has been successfully updated.',
        used: 'Used',
      },
      Sleeps: {
        addSleepFeed: 'Add sleep record',
        addedSuccess: 'Sleep record has been added.',
        childDidNotSleep: 'Child did not sleep',
        confirmRemove: 'Are you sure you want to remove this sleep record?',
        fellAsleep: 'Fell asleep',
        listInfo: 'Children who are present and registered for sleeps are listed below.',
        noRecords: 'There are no children in this date who are scheduled to sleep.',
        removedSuccess: 'Sleep record has been successfully removed.',
        sleepTimeError: 'Enter sleep times in correct order',
        totalTime: 'Total time',
        updatedSuccess: 'Sleep record has been successfully updated.',
        wokeUp: 'Woke up',
      },
      global: {
        addChild: 'Add child',
        addChildren: 'Add children',
        additionalNotes: 'Additional notes',
        eatingTypes: {
          breakfast: 'Breakfast',
          dinner: 'Tea',
          lunch: 'Lunch',
          snack: 'Snack',
        },
        enterAdditionalNotesHere: 'Enter additional notes here',
        food: 'Food',
        foods: 'Foods',
        inThisRoom: 'in this room.',
        nappyTypes: {
          both: 'Both',
          bothLong: 'Wet & soiled',
          clean: 'Clean',
          soiled: 'Soiled',
          wet: 'Wet',
        },
        noAddedItems: 'No recorded entries for this date.',
        noChildrenAttending: 'There are no children attending on this date',
        notFoundChildren: 'Not found any available children',
        toiletTrainingTypes: {
          potty: 'potty',
          toilet: 'toilet',
        },
      },
      routing: {
        Activities: 'Activities',
        Bottles: 'Bottles',
        Meals: 'Meals',
        Nappies: 'Nappies',
        Sleeps: 'Sleeps',
        Snacks: 'Snacks',
        dailyDiary: 'Daily diary',
        medications: 'Medications',
      },
    },
    Dashboard: {
      NurseryDashboard: {
        customiseWidgets: 'Customise widgets',
        emptyStateText: 'Add widgets to your BlossomBoard to access shortcuts to your most used features',
      },
      NurseryItem: {
        noAddressProvided: 'No address provided',
        noPrimaryContact: 'Select a manager (system owner) from the nursery information settings.',
      },
      Organization: {
        nothingFound: 'No nurseries found',
        searchBarPlaceholder: 'Search by nursery name',
      },
      Widgets: {
        AccidentsIncidentsSignaturesWidget: {
          emptyStateText1: 'Phew! No signatures needed',
          emptyStateText2: 'New records that require signatures will appear here.',
          parent: 'Parent',
          parents: 'Parents',
          signaturesNeeded: 'Signatures Needed',
          staff: 'Staff',
          title: 'Accidents & Incidents',
          titleInSettings: 'Accidents and incidents signatures needed',
        },
        AgedDebtWidget: {
          emptyStateText1: 'Woohoo!',
          emptyStateText2: 'All invoices are paid.',
          title: 'Aged Debt',
          titleInSettings: 'Aged debt',
        },
        AnnualRevenueWidget: {
          title: 'Annual Revenue',
          titleInSettings: 'Annual revenue',
        },
        AttendanceWidget: {
          title: 'Attendance',
          titleInSettings: "Today's attendance",
          viewRegister: 'View register',
        },
        BirthdaysWidget: {
          emptyStateText1: 'No upcoming birthdays!',
          emptyStateText2: 'Keep track of children\'s and staff\'s birthdays here.',
          title: 'Birthdays',
          titleInSettings: 'Upcoming birthdays',
          whichBirthday: '{{ ordinalNumber }} birthday',
        },
        ChildrenSearchWidget: {
          emptyStateText1: 'No children found',
          emptyStateText2: 'Try adjusting your search or adding new children',
          searchByChildName: 'Search by child name',
          title: 'Children',
          titleInSettings: 'Children search',
        },
        DraftInvoicesWidget: {
          emptyStateText1: 'You’re all caught up!',
          emptyStateText2: 'Draft invoices will appear here.',
          title: 'Draft Invoices',
          titleInSettings: 'Draft invoices',
        },
        ExtraSessionRequestsWidget: {
          emptyStateText1: 'You\'re all caught up',
          emptyStateText2: 'New pending extra session requests will appear here.',
          pendingApproval: 'Pending Approval',
          title: 'Extra Session Requests',
          titleInSettings: 'Pending extra session requests',
        },
        MonthlyIncomeWidget: {
          funding: 'Funding',
          invoiced: 'Invoiced',
          monthIncome: '{{ monthName }} Income',
          titleInSettings: 'Monthly income',
        },
        NeedsAttentionWidget: {
          emptyStateText1: 'All caught up!',
          emptyStateText2: 'New items that need your attention will appear here.',
          pendingApprovalFormativeReports: '<0>{{ value }} formative report</0> pending approval',
          pendingApprovalFormativeReports_plural: '<0>{{ value }} formative reports</0> pending approval',
          pendingApprovalInjuries: '<0>{{ value }} accident/incident</0> pending approval',
          pendingApprovalInjuries_plural: '<0>{{ value }} accident/incidents</0> pending approval',
          pendingApprovalObservations: '<0>{{ value }} observation</0> pending approval',
          pendingApprovalObservations_plural: '<0>{{ value }} observations</0> pending approval',
          pendingRequestExtraSessions: '<0>{{ value }} extra session</0> request',
          pendingRequestExtraSessions_plural: '<0>{{ value }} extra sessions</0> requests',
          signaturesNeededInjuries: '<0>{{ value }} accident/incident</0> require signatures',
          signaturesNeededInjuries_plural: '<0>{{ value }} accident/incidents</0> require signatures',
          title: 'Attention Needed',
          titleInSettings: 'Needs attention',
          todayViewings: '<0>{{ value }} viewing</0> today',
          todayViewings_plural: '<0>{{ value }} viewings</0> today',
        },
        NextStepsWidget: {
          emptyStateText1: 'No next steps',
          emptyStateText2: 'Next steps set on observations will appear here.',
          title: 'Next Steps',
          titleInSettings: 'Next steps',
        },
        ObservationDiaryButtonsWidget: {
          makeObservation: 'Make Observation',
          sendDiary: 'Send Diary',
          titleInSettings: 'Observation and diary button',
        },
        ObservationsWidget: {
          draftObservations: 'Draft observations',
          emptyStateText1: 'No draft observations',
          emptyStateText2: 'Saved drafts will appear here.',
          pendingApproval: 'Pending Approval',
          titleInSettings: 'Observations',
        },
        StaffingOverviewWidget: {
          emptyStateText1: 'No Rooms',
          emptyStateText2: 'Add rooms to view the staffing overview.',
          staffingFlags: 'Staffing flags',
          title: 'Staffing Overview',
          titleInSettings: 'Staffing overview',
        },
        StartersAndLeaversWidget: {
          emptyStateText1: 'All settled for now',
          emptyStateText2: 'Upcoming starters and leavers will appear here a month ahead.',
          title: 'Starters & Leavers',
          titleInSettings: 'Starters and Leavers',
        },
        TimeWidget: {
          titleInSettings: "Today's date and time",
        },
        TodayAllergiesWidget: {
          emptyStateText1: 'All clear!',
          emptyStateText2: 'No children with allergies today.',
          titleInSettings: 'Today\'s Allergies',
        },
        TopOutstandingAccountsWidget: {
          emptyStateText1: 'Woohoo!',
          emptyStateText2: 'You have no overdue invoices.',
          largestBalances: '10 Largest Balances',
          title: 'Total Outstanding',
          titleInSettings: 'Top outstanding accounts',
        },
        ViewingsWidget: {
          emptyStateText1: 'No upcoming viewings',
          emptyStateText2: 'Scheduled tours will appear here to help you welcome new families.',
          thisMonth: 'This month',
          thisWeek: 'This week',
          title: 'Viewings',
          titleInSettings: 'Viewings',
          unassigned: 'Unassigned',
          upcoming: 'Upcoming',
          viewingBy: 'Viewing by',
        },
      },
      seeMore: 'See more',
    },
    Enquiries: {
      List: {
        Add: {
          BookingInformation: {
            Room: {
              label: 'Room to start',
              placeholder: 'Select room',
            },
            StartDate: {
              label: 'Desired start date',
              placeholder: 'Select date',
            },
            WeeklySessionValue: {
              label: 'Weekly session value',
            },
            title: 'Desired booking',
          },
          ChildInformation: {
            DateOfBirth: {
              label: 'Date of birth',
              placeholder: 'Select date',
            },
            FirstName: {
              label: 'First name',
              placeholder: 'First name',
            },
            Gender: {
              label: 'Gender',
              placeholder: 'Select gender',
            },
            Surname: {
              label: 'Surname',
              placeholder: 'Surname',
            },
            title: 'Child information',
          },
          ContactInformation: {
            Address: {
              label: 'Address',
              placeholder: 'Address',
            },
            Email: {
              label: 'Email',
              placeholder: 'Email',
            },
            FirstName: {
              label: 'First name',
              placeholder: 'First name',
            },
            Gender: {
              label: 'Gender',
              placeholder: 'Select gender',
            },
            Phone: {
              label: 'Phone number',
              placeholder: 'Phone number',
            },
            Postcode: {
              label: 'Postcode',
              placeholder: 'Postcode',
            },
            RelationToChild: {
              label: 'Relation to child',
              placeholder: 'Relation to child',
            },
            Surname: {
              label: 'Surname',
              placeholder: 'Surname',
            },
            title: 'Contact information',
          },
          EnquiryDetails: {
            EnquiryDate: {
              label: 'Enquiry date',
              placeholder: 'Enquiry date',
            },
            EnquiryReason: {
              label: 'Enquiry reasons',
              placeholder: 'Select reason',
            },
            OtherConsideredNurseries: {
              label: 'Other nurseries the parent is considering',
              placeholder: 'Name of the nurseries',
            },
            OtherEnquiryReason: {
              label: 'Other enquiry reason',
              placeholder: 'Other enquiry reason',
            },
            OtherSource: {
              label: 'Other source',
              placeholder: 'Other source',
            },
            Source: {
              label: 'Source (how did you hear about us?)',
              placeholder: 'Select source',
            },
            title: 'Enquiry details',
          },
          SessionDetails: {
            title: 'Desired sessions',
            weeklyValueLabel: 'Weekly session value',
          },
          ViewingInformation: {
            Notes: {
              label: 'Additional viewing notes',
              placeholder: 'Enter notes',
            },
            Staff: {
              label: 'Staff taking viewing',
              placeholder: 'Select staff',
            },
            Status: {
              label: 'Status',
              placeholder: 'Select status',
            },
            ViewingDate: {
              label: 'Viewing date',
              placeholder: 'Select date',
            },
            ViewingTime: {
              label: 'Time',
            },
            title: 'Viewing',
          },
          addTitle: 'Add enquiry',
          editTitle: 'Edit enquiry',
          saveLabel: 'Save enquiry',
          updateLabel: 'Update enquiry',
        },
        Detail: {
          Activity: {
            Entry: {
              SnackbarMessage: {
                Actions: {
                  created: 'created',
                  deleted: 'deleted',
                  edited: 'edited',
                },
                Types: {
                  call: 'Phone Call',
                  email: 'Email',
                  note: 'Note',
                  viewing: 'Viewing',
                },
                message: '{{ type }} has been {{ action }}.',
              },
              Tabs: {
                Call: {
                  Note: {
                    placeholder: 'Write about the phone call',
                  },
                  submitButtonLabel: 'Log call',
                  title: 'Log phone call',
                },
                Email: {
                  Note: {
                    placeholder: 'Write about the email content',
                  },
                  submitButtonLabel: 'Log email',
                  title: 'Log email',
                },
                Note: {
                  Note: {
                    placeholder: 'Write your note',
                  },
                  submitButtonLabel: 'Save note',
                  title: 'Create note',
                },
                Viewing: {
                  Note: {
                    placeholder: 'Write any additional notes',
                  },
                  submitButtonLabel: 'Log viewing',
                  title: 'Log viewing',
                },
              },
            },
            Header: {
              childRouteLinkLabel: 'View child profile',
              enrolChildLabel: 'Enrol child',
            },
            List: {
              ActivitySubtitle: {
                call: 'logged a call',
                create: 'logged the enquiry',
                createFromPublicForm: 'Enquiry created via website form submission.',
                email: 'logged an email',
                note: 'added a note',
                statusChange: "changed the enquiry status to '{{ status }}'",
                statusMigrate: "deleted the enquiry status '{{ oldStatus }}' and migrated the enquiry to '{{ newStatus }}'",
                viewingCreate: 'logged a viewing',
                viewingRemove: 'deleted a viewing',
                viewingUpdate: 'updated a viewing',
              },
              ShowAround: {
                additionalNotes: 'Additional viewing notes:',
                additionalPreviousNotes: 'Previously:',
                status: 'Status:',
                viewingDate: 'Viewing date:',
                viewingTime: 'Time:',
                visitTakenBy: 'Visit taken by:',
              },
              Tabs: {
                All: {
                  title: 'All',
                },
                Calls: {
                  emptyState: 'No phone calls logged',
                  title: 'Phone calls',
                },
                Emails: {
                  emptyState: 'No emails logged',
                  title: 'Emails',
                },
                Notes: {
                  emptyState: 'No notes logged',
                  title: 'Notes',
                },
                Viewings: {
                  emptyState: 'No viewings logged',
                  title: 'Viewings',
                },
              },
              confirmRemoveActivity: 'This will delete the logged activity.',
              lostReasonNote: 'Lost reason: {{ lostReason }}',
              title: 'Activities',
              viewingActivityDate: 'Viewing date {{ date }}.',
              viewingActivityName: 'Visit taken by {{ name }}.',
            },
            deleteActivityMessage: 'Are you sure, do you want to delete this activity?',
            deleteViewingMessage: 'This will delete the viewing.',
            seeLess: 'See less',
            seeMore: 'See more',
          },
          deleteMessage: 'This will permanently delete the enquiry and all associated information.',
          title: 'Enquiry detail',
        },
        Filters: {
          EnquiryDate: {
            label: 'Enquiry date',
          },
          StartDate: {
            label: 'Desired start date',
          },
          Status: {
            label: 'Status',
            placeholder: 'Select status',
          },
          ViewingStatus: {
            label: 'Viewings',
            placeholder: 'Select status',
          },
        },
        Table: {
          Header: {
            child: 'Child',
            contact: 'Contact',
            enquiryDate: 'Enquiry date',
            startDate: 'Start date',
            status: 'Status',
            viewingCount: 'Viewing',
            weeklyValue: 'Weekly value',
          },
          noViewingCountText: 'Not booked',
        },
        emptyState: 'There are no enquiries.',
        enquiries: 'enquiries',
        enquiry: 'enquiry',
        routeTitle: 'Enquiries list',
        title: 'Enquiries',
      },
      Report: {
        ConversionRate: {
          DataLabels: {
            lost: 'Lost',
            open: 'Open',
            won: 'Won',
          },
          Filters: {
            Breakdown: {
              label: 'Breakdown',
            },
            EnquiryDate: {
              label: 'Enquiry date',
            },
          },
          Organization: {
            Table: {
              Header: {
                allEnquiries: 'All enquiries',
                lost: 'Lost',
                open: 'Open',
                site: 'Site',
                won: 'Won',
              },
            },
            description: 'This report divides enquiries by their current stage.',
            subtitle: 'Looking to see how many enquiries are converted in each setting? This report divides by their current stage. Filter enquiries by their create date and see their current conversion rate.',
            title: 'Enquiry conversion rate',
          },
          Table: {
            Header: {
              percent: '%',
              stage: 'Stage',
              value: '#',
            },
          },
          description: 'This report divides enquiries by their current stage.',
          subtitle: 'You can filter enquiries by their create date and see their current conversion rate. For more information visit our help center.',
          title: 'Enquiry conversion rate',
        },
        Performance: {
          DataLabels: {
            lost: 'Lost',
            open: 'Open',
            won: 'Won',
          },
          Filters: {
            Breakdown: {
              label: 'Breakdown',
            },
            DateRange: {
              label: 'Date range',
            },
            Site: {
              label: 'Site',
            },
          },
          Organization: {
            description: 'Get a weekly or monthly breakdown of enquiry performance.',
            title: 'Enquiry performance',
          },
          Table: {
            Header: {
              lost: 'Lost',
              month: 'Month',
              open: 'Open',
              total: 'Total',
              week: 'Week',
              won: 'Won',
            },
          },
          description: 'Get a weekly or monthly breakdown of enquiry performance.',
          title: 'Enquiry performance',
        },
        ViewingPerformance: {
          Filters: {
            Breakdown: {
              label: 'Breakdown',
            },
            Site: {
              label: 'Site',
            },
            ViewingDate: {
              label: 'Viewing date',
            },
          },
          Organization: {
            description: 'Monitor the viewing performance of staff members. Use this report to view how many viewings were successful or lost as a number or percentage.',
            title: 'Staff viewing performance',
          },
          Table: {
            Header: {
              staffName: 'Staff name',
              viewingsAttended: 'Viewings attended',
              viewingsThatLedToEnrollment: 'Viewings that led to enrollment',
              viewingsThatLedToLostEnquires: 'Viewings that led to lost enquires',
              viewingsWithOpenEnquiryStatus: 'Viewings with open enquiry status',
            },
          },
          description: 'Monitor the viewing performance of staff members. Use this report to view how many viewings were successful or lost as a number or percentage.',
          title: 'Staff viewing performance',
        },
        searchPlaceholder: 'Search enquiry reports',
        title: 'Enquiry reports',
      },
      Viewings: {
        Status: {
          past: 'Update outcome',
        },
        Table: {
          Header: {
            AssignedPerson: 'Visit taken by',
            Child: 'Child',
            ChildAge: 'Child age',
            Contact: 'Contact',
            Date: 'Date',
            Status: 'Status',
            Time: 'Time',
          },
        },
        emptyState: 'There are no viewings.',
        searchPlaceholder: 'Search by child, contact or staff name',
        title: 'Viewings',
        viewing: 'Viewing',
        viewings: 'Viewings',
      },
      title: 'Enquiries',
    },
    EnquiryPublicForm: {
      birthDate: 'Date of birth',
      childInformation: 'Child information',
      contactInformation: 'Contact Information',
      copyright: '© Copyright {{ year }} {{ company }}',
      desiredStartDate: 'Desired start date',
      email: 'Email',
      firstName: 'First name',
      gender: 'Gender',
      phoneNumber: 'Phone number',
      sendConfirmationEmail: 'Send me a confirmation email of these form details.',
      sendEnquiry: 'send enquiry',
      surname: 'Surname',
      title: 'New customer enquiry',
    },
    EnquiryPublicFormSuccess: {
      subtitleFirstLine: 'Thank you for your enquiry.',
      subtitleSecondLine: 'A staff member will get in touch with you soon.',
      title: 'Enquiry form submitted!',
    },
    Finance: {
      Deposits: {
        Form: {
          Snackbar: {
            Action: {
              created: 'created',
              deleted: 'deleted',
              updated: 'updated',
            },
            message: '{{ type }} was successfully {{ action }}.',
          },
          Title: {
            add: 'Add deposit',
            edit: 'Deposit',
            refund: 'Deposit refund',
          },
          Type: {
            deposit: 'deposit',
            depositRefund: 'deposit refund',
          },
          addDeposit: 'Add deposit',
          addDepositToNextInvoice: 'Add deposit to next invoice',
          addDepositTooltip: 'Already invoiced or refunded deposits can not be changed',
          deleteConfirm: 'Are you sure you want to delete this {{ type }}?',
          depositDate: 'Deposit date',
          descriptionTemplate: 'Deposit {{ number }}',
          emptyState: 'Please select a child above.',
          invoiceDescription: 'Invoice description',
          invoiceStatus: 'Invoice status',
          markAsPaid: 'Mark as paid',
          originalDeposit: 'Original deposit',
          pendingInvoice: 'Pending invoice',
          refund: 'Refund',
          refundDate: 'Refund date',
          refundTooltip: 'Only paid deposits can be refunded',
          saveChanges: 'Save changes',
        },
        List: {
          StatisticsOptions: {
            held: 'Held deposits',
            pendingDeposits: 'Pending deposits',
            pendingRefunds: 'Pending refunds',
            raised: 'Deposits raised',
            refunded: 'Refunded',
          },
          Table: {
            Column: {
              InvoiceStatus: {
                creditNoted: 'Credit noted',
                draftInvoice: 'Draft invoice',
                invoiced: 'Invoiced',
                markedAsPaid: 'Marked as paid',
                markedAsRefunded: 'Marked as refunded',
                originalDepositCreditNoted: 'Original deposit credit noted',
                paid: 'Paid',
                pendingInvoice: 'Pending invoice',
                unpaid: 'Unpaid',
              },
            },
            Header: {
              amount: 'Amount',
              child: 'Child',
              date: 'Date',
              invoiceStatus: 'Invoice status',
              type: 'Type',
            },
          },
          addDeposit: 'Add deposit',
          deposit: 'deposit',
          deposits: 'deposits',
          emptyStateText: 'Deposits not found',
        },
        title: 'Deposits',
      },
      Funding: {
        Constants: {
          FundingAllocationLabels: {
            automatic: 'Automatic',
            manual: 'Manual',
          },
          FundingStatusOptions: {
            allocationNeeded: 'Allocation needed',
            fundingAllocated: 'Funding allocated',
            noFunding: 'No funding',
          },
        },
        DetailTable: {
          Header: {
            currentFunding: 'Current funding',
            fundingAllocation: 'Funding allocation',
            fundingPeriod: 'Funding period',
          },
        },
        Table: {
          Header: {
            age: 'Age',
            child: 'Child',
            currentFunding: 'Current funding',
          },
          allocateButtonLabel: 'Allocate',
          numberOfFundingTypesLabel: '{{ totalFundingTypes }} funding types',
        },
        allAgePlaceholder: 'All age',
        allChildrenPlaceholder: 'All children',
        allFundingPlaceholder: 'All funding',
        allFundingTypesPlaceholder: 'All funding types',
        allRoomsPlaceholder: 'All rooms',
        archiveChildFundingWaitMessage: 'Please wait archiving...',
        archiveFundingTypeLabel: 'Archive funding type',
        assignFundingTypeLabel: 'Assign funding type',
        childFundingAutoAllocationMessage: 'Funding will automatically be allocated.',
        childFundingManualAllocationMessage: 'Do you want to allocate funding hours now?',
        createFundingTypeButtonLabel: 'Create funding type',
        emptyState1: 'No results found.',
        emptyState2: 'Try adjusting your filters.',
        fundingStatusPlaceholder: 'All statuses',
        noChildrenEmptyState1: 'This nursery has no children yet.',
        noChildrenEmptyState2: 'Please add children.',
        noFundingTypesEmptyState1: 'There are no funding types to select to view a report.',
        noFundingTypesEmptyState2: 'You can create funding types in the funding settings.',
        title: 'Funding',
        totalFundingFooterLabel: 'Total funding amount',
      },
      GenerateInvoices: {
        Form: {
          selectChildren: 'Please select at least one child to generate invoices',
        },
        Preview: {
          breadcrumbsTitle: 'Bulk preview',
        },
        breadcrumbsTitle: 'Bulk',
        generatedBatchInvoice: 'Generated batch invoice',
        markAsSentPopupText: 'Are you sure you want to mark the selected generated invoices as sent?',
        mostRecentInvoices: 'Most recent invoices',
        noChildrenWithGeneratedInvoices: 'No children with generated invoices.',
        saveAndSendPopupConfirmButtonLabel: 'Send invoices',
        saveAsDraftInvoicesCopy: 'Are you sure you want to save the selected generated invoices as draft?',
        sentPopupText: 'Are you sure you want to send the selected generated invoices?',
        title: 'Generate invoices',
        updatingBulkInvoicesCopy: 'Please wait, updating bulk invoices...',
      },
      InvoiceSendHandler: {
        MissingPaymentEmailPopup: {
          label: 'Assign contact',
          text: "A primary contact has not been selected to send invoices to. Please assign a contact in the child's account.",
        },
      },
      Invoices: {
        title: 'Invoices',
      },
      OneOffBookings: {
        BookingTypes: {
          extraItem: 'Extra item',
          extraSession: 'Extra session',
          oneOffDiscount: 'One-off discount',
          oneOffFunding: 'One-off funding',
        },
        EmptyState: {
          addButtonLabel: 'Add one-off booking',
          text1: 'Add your one-off booking to allocate them to children and parent invoices.',
        },
        Filters: {
          Date: {
            label: 'Booking date',
          },
          InvoiceStatus: {
            label: 'Invoice status',
          },
          Search: {
            label: 'Search by child name or booking description',
          },
          Status: {
            label: 'Booking status',
          },
        },
        Form: {
          Discount: {
            otherName: 'Other discount name',
            value: 'Discount value',
          },
          Funding: {
            banner1Text: 'This funding type will appear as a lump-sum on the revenue report and does not get deducted from the parents invoice.',
            banner2Text: 'This funding type will take a lump-sum of funding off the childs invoice on a specific day and can for example be used for EYPP funding.',
            deductFromParentInvoice: 'Does this funding deduct from the parents invoice?',
            valueLabel: 'Funding value',
          },
          Title: {
            add: 'Add one-off booking',
            edit: 'Edit one-off booking',
          },
          addBooking: 'Add booking',
          archiveConfirm: 'Are you sure you want to {{ action }} this one-off booking?',
          emptyState: 'Please select a child above.',
          includeConsumables: 'Include consumables',
          saveChanges: 'Save changes',
          snackBarMessage: 'Booking was successfully {{ action }}.',
        },
        InvoiceStatus: {
          nonDeductible: 'Non deductible',
        },
        LinkedToRequestedExtraSession: {
          banner: 'This one-off booking is linked to a request made by a child contact.',
        },
        PeriodCalculator: {
          appliedDiscountLabel: 'Applied discounts',
          valueAfterDiscountLabel: 'Value after discounts',
        },
        title: 'One-off bookings',
      },
      Payments: {
        Details: {
          amount: 'Amount',
          comment: 'Comment',
          mobileTitle: 'Mobile payment',
          paymentDetails: 'Payment details',
          paymentMethod: 'Payment method',
          paymentStatus: 'Payment status',
          paymentTimeline: 'Payment timeline',
          reference: 'Reference',
          title: 'Payment',
          transactionId: 'Transaction ID',
          viaParentApp: 'via Parent App',
          voucherName: 'Voucher name',
        },
        Export: {
          title: 'Export your payment report',
        },
        Remove: {
          confirm: 'Are you sure you want to delete this payment? This will remove the payments on invoices in order from the newest invoice first, based on the invoice date.',
          failureAlert: 'Payment cannot be removed.',
          successAlert: 'Your payment has been removed!',
        },
        Resend: {
          confirm: 'Are you sure you want to resend this receipt?',
          failureAlert: 'Something went wrong whilst communicating with the server, please try again later.',
          missingContact: 'The invoice cannot be resent because {{ childName }} has no primary contact for invoicing.',
          noRecipients_1: 'Cannot send payment receipt',
          noRecipients_2: 'The child has no invoice recipients or the contact who made this payment was removed.',
          successAlert: 'Your payment receipt has been sent!',
        },
        emptyState: 'There are no payments for the selected filter.',
        parentApp: 'Parent App',
        payment: 'payment',
        paymentMethod: 'Payment method',
        payments: 'payments',
        receipt: 'Receipt',
        title: 'Payments',
        type: 'Type',
        viewDetails: 'View details',
      },
      Payouts: {
        Detail: {
          Export: {
            title: 'Export payout transactions',
          },
          arrival: 'Arrival',
          payoutDetails: 'Payout details',
          routeTitle: 'Payout detail',
          stripeFees: 'Stripe fees',
          transactions: 'Transactions',
        },
        arrival: 'Arrival',
        emptyState: 'Not found any payouts records',
        fees: 'Stripe fees',
        numberOfPayouts: '{{ payouts }} payouts',
        payouts: '{{ currency }} payouts',
        title: 'Payouts',
      },
      RegularBookings: {
        List: {
          confirmRemove: 'Are you sure you want to remove this regular booking?',
          createFirstRegularBooking: 'Create first regular booking',
          discounts: 'Discounts',
          endAgeInMonths: 'End age in months',
          funding: 'Funding',
          fundingType: 'Funding type',
          items: 'Items',
          notFound: 'Not found any regular bookings',
          notFoundChildContext: '{{ childName }} does not have regular bookings',
          planActiveOn: 'Plan active on',
          scheduleBookingPatternChange: 'Schedule booking pattern change',
          sessions: 'Sessions',
          startAgeInMonths: 'Start age in months',
          untilChildLeaves: 'until child leaves',
          week: 'Week {{ index }}',
        },
        title: 'Regular bookings',
      },
      Reports: {
        ActiveRecurringPayment: {
          Export: {
            title: 'Export active recurring payments',
          },
          Filters: {
            PaymentMethod: {
              label: 'Payment method',
            },
            Site: {
              label: 'Site',
            },
          },
          Table: {
            Header: {
              AccountHolder: {
                label: 'Account holder',
              },
              Balance: {
                label: 'Balance',
              },
              EstimatedCompletionDate: {
                label: 'Estimated completion date',
                tooltip: 'This is just an estimate. BACS runs typically take around 3 business days to complete and around 6 business days for the first run of a new mandate. Recurring card payments are typically completed immediately on the same day.',
              },
              NextRunDate: {
                label: 'Next run date',
              },
              PaymentMethod: {
                label: 'Payment method',
              },
              SetupType: {
                label: 'Setup type',
              },
              Site: {
                label: 'Site',
              },
            },
          },
          description: 'This report provides the recurring payments status of all children.',
          title: 'Active recurring payments',
        },
        AgedDebt: {
          EmptyState: {
            text1: 'Woohoo!',
            text2: 'Your invoices are all paid.',
          },
          Filters: {
            Child: {
              label: 'Child',
            },
            Date: {
              label: 'Date',
            },
            Rooms: {
              label: 'Rooms',
              placeholder: 'All rooms',
            },
          },
          Organization: {
            description: 'This report provides a detailed list of parents whose account are overdue broken down over time periods.',
            title: 'Aged debt report',
          },
          Table: {
            Header: {
              '0-30': '0-30 days',
              '120+': '120+ days',
              '31-60': '31-60 days',
              '61-90': '61-90 days',
              '91-120': '91-120 days',
            },
          },
          chartTooltipTitle: 'Aged debt',
          description: 'This report provides a detailed list of parents whose account are overdue broken down over time periods.',
          subtitle: 'This report provides a detailed list of accounts that are overdue broken down over time periods. Select a number in the table below to view the specific invoices.',
          title: 'Aged debt report',
        },
        AnnualRevenue: {
          description: 'This report provides an overview of total income including fees and funding.',
          reportTitle: 'This report provides a 12 month overview of total invoiced and projected income.',
          sendPopupTitle: 'Send your annual revenue report',
          tableFirstColumnHeader: 'Keys',
          title: 'Annual revenue report',
        },
        BadDebt: {
          DateTypeOptions: {
            dateMarked: 'Date marked',
            invoiceDate: 'Invoice date',
          },
          Export: {
            description: 'Select a manager or administrator to send the export to',
            title: 'Export your bad debt report',
          },
          Filters: {
            Date: {
              label: 'Date',
            },
            DateType: {
              label: 'Date type',
              placeholder: 'Date type',
            },
            Rooms: {
              label: 'Rooms',
            },
          },
          Organization: {
            Statistics: {
              totalBadDebtAmount: 'Total bad debt amount',
              totalInvoices: 'Total invoices',
            },
            Table: {
              Header: {
                badDebtAmount: 'Bad debt amount',
                invoices: 'Invoices',
              },
            },
            description: 'This report provides a detailed list of invoices that have been marked as bad debt.',
            title: 'Bad debt',
          },
          Table: {
            Header: {
              badDebtAmount: 'Bad debt amount',
              dateMarked: 'Date marked',
              invoiceAmount: 'Invoice amount',
              invoiceDate: 'Invoice date',
              invoiceNumber: 'Invoice number',
              reason: 'Reason',
            },
          },
          description: 'This report provides a detailed list of invoices that have been marked as bad debt.',
          footerLabel: 'Total bad debt amount',
          title: 'Bad debt',
        },
        Balances: {
          Filters: {
            Date: {
              label: 'Date',
            },
          },
          Organization: {
            description: 'This report provides a detailed list of balances.',
            title: 'Balances',
          },
          Table: {
            Header: {
              balanceAdjustments: 'Balance adjustments',
              closingBalance: 'Closing balance',
              creditNotes: 'Credit notes',
              invoices: 'Invoices',
              openingBalance: 'Opening balance',
              payments: 'Payments',
            },
          },
          description: 'This report provides a detailed list of balances.',
          title: 'Balances',
        },
        CreditNotes: {
          Export: {
            description: 'Select a manager or administrator to send the export to',
            title: 'Export credit notes report',
          },
          Filters: {
            CreatedBy: {
              label: 'Created by',
              placeholder: 'Created by',
            },
            Date: {
              label: 'Date',
            },
          },
          Organization: {
            Statistics: {
              totalCreditNoteAmount: 'Total credit note amount',
              totalCreditNotes: 'Total credit notes',
            },
            Table: {
              Header: {
                creditNotes: 'Credit notes',
                creditNotesAmount: 'Credit notes amount',
              },
            },
            description: 'This report provides a list of credit notes issued.',
            title: 'Credit notes report',
          },
          Table: {
            Header: {
              createdBy: 'Created by',
              createdDate: 'Created date',
              creditNoteNumber: 'Credit note number',
              creditNoteReason: 'Credit note reason',
              invoiceLinked: 'Invoice linked',
            },
          },
          description: 'This report provides a list of credit notes issued.',
          emptyStateText1: 'There are no credit notes.',
          footerLabel: 'Total credit note amount',
          title: 'Credit notes report',
        },
        Deposits: {
          Filters: {
            DepositRefundDate: {
              label: 'Deposit / refund date',
            },
          },
          Organization: {
            Statistics: {
              totalHeld: 'Held deposits',
              totalPending: 'Pending deposits',
              totalPendingRefunds: 'Pending refunds',
              totalRaised: 'Deposits raised',
              totalRefunded: 'Refunded',
            },
            Table: {
              Header: {
                held: 'Held deposits',
                pending: 'Pending deposits',
                pendingRefunds: 'Pending refunds',
                raised: 'Deposits raised',
                refunded: 'Refunded',
              },
            },
            description: 'This report provides a list of deposits.',
            title: 'Deposits',
          },
          description: 'This report provides a list of deposits.',
          title: 'Deposits',
        },
        DetailedRevenue: {
          description: 'This report provides an overview of income from fees.',
          emptyStateText: 'This report only shows revenue from invoices that have been sent in past.',
          title: 'Detailed revenue report',
        },
        FailedRecurringPayment: {
          Export: {
            title: 'Export failed recurring payment runs',
          },
          Filters: {
            PaymentMethod: {
              label: 'Payment method',
            },
            Site: {
              label: 'Site',
            },
          },
          Table: {
            Header: {
              AccountHolder: {
                label: 'Account holder',
              },
              FailedReason: {
                label: 'Failed reason',
              },
              PaymentMethod: {
                label: 'Payment method',
              },
              PaymentRunDate: {
                label: 'Payment run date',
              },
              Site: {
                label: 'Site',
              },
            },
          },
          description: 'This report provides a list of failed recurring payment runs to follow up with bill payers.',
          title: 'Failed recurring payment runs',
        },
        Forecasting: {
          Chart: {
            forecastLabel: 'Forecast',
            fundingIncomeLabel: 'Funding income',
            totalInvoicedLabel: 'Fee income',
          },
          description: 'This is where you can view reports of future fees forecasts.',
          reportTitle: 'This report provides a monthly overview of future fees forecasted over a selected year.',
          sendPopupTitle: 'Send your forecasting report',
          site: 'Site',
          tableTitle: 'Select a month to view a breakdown per child.',
          title: 'Forecasting',
        },
        Funding: {
          Export: {
            description: 'Select a manager or administrator to send the export to',
            title: 'Export funding report',
          },
          Filters: {
            Age: {
              label: 'Age',
            },
            Allocation: {
              Options: {
                noFunding: 'No funding',
                overFunded: 'Over funded',
                underFunded: 'Under funded',
              },
              label: 'Allocation',
              placeholder: 'Select allocation',
            },
            Child: {
              label: 'Child',
            },
            FundingTypes: {
              label: 'Funding types',
              placeholder: 'Funding types',
            },
            Rooms: {
              label: 'Rooms',
            },
            Site: {
              label: 'Site',
            },
            Status: {
              label: 'Status',
            },
          },
          Organization: {
            Table: {
              Header: {
                totalFundingAmount: 'Total funding amount',
              },
            },
            description: 'This report provides a detailed list of funding amounts and hours that been allocated to children.',
            title: 'Funding report',
          },
          Table: {
            Header: {
              deductedFromInvoice: 'Deducted from invoice',
              fundingAllocationFor: 'Funding allocation for',
              fundingIncomeAllocated: 'Funding income allocated',
              fundingInvoiced: 'Funding invoiced',
              fundingName: 'Funding name',
              fundingType: 'Funding type',
              hourlyRate: 'Hourly rate',
              period: 'Period',
              totalFundingAllocated: 'Total funding allocated',
              totalFundingDeductedFromInvoice: 'Total funding deducted from invoice',
              totalHours: 'Total hours',
            },
          },
          description: 'This report provides a detailed list of funding amounts and hours that been allocated to children.',
          title: 'Funding report',
        },
        RevenuePerAge: {
          Filters: {
            Date: {
              label: 'Date',
            },
          },
          Organization: {
            description: 'This report provides a detailed list of revenue per age group.',
            title: 'Revenue per age group',
          },
          Statistics: {
            aboveFiveYears: '5+ years',
            threeFiveYears: '3-5 years',
            twoYears: '2 years',
            underTwoYears: 'Under 2 years',
          },
          Table: {
            Header: {
              ageGroup: 'Age group',
              revenue: 'Revenue',
            },
          },
          description: 'This report provides a detailed list of revenue per age group.',
          title: 'Revenue per age group',
        },
        RevenuePerRoom: {
          Filters: {
            Date: {
              label: 'Date',
            },
          },
          Organization: {
            description: 'This report provides a detailed list of revenue per room.',
            title: 'Revenue per room',
          },
          Table: {
            Header: {
              balanceAdjustments: 'Balance adjustments',
              closingBalance: 'Closing balance',
              creditNotes: 'Credit notes',
              invoices: 'Invoices',
              openingBalance: 'Opening balance',
              payments: 'Payments',
            },
          },
          description: 'This report provides a detailed list of revenue per room.',
          title: 'Revenue per room',
        },
        searchPlaceholder: 'Search financial reports',
        subtitle: 'This is where you can generate and download reports on your financial accounts for an overview of your business.',
        title: 'Financial reports',
      },
      title: 'Finance',
    },
    HomeObservation: {
      Details: {
        makeFullObservation: 'Make full observation',
        media: 'Media',
        noCommentAdded: 'No comment added.',
        parentComment: 'Parent comment',
      },
      List: {
        P: 'P',
        addedAnObservationFromHome: ' added an observation from home',
        observationFromHome: 'Observation from home',
        viewFullObservation: 'View full observation',
      },
    },
    Injury: {
      Add: {
        addChildrenButtonLabel: 'Add children',
        addTitle: 'Log accident or incident',
        childPickerEmptyStateText: 'No children found. Please add children or adjust your search.',
        collectSignaturePopupCopy: 'Collect signature',
        deletePopupCopy: 'Are you sure you want to delete this {{ type }} record?',
        editTitle: 'Edit {{ type }} record',
        noChildrenErrorCopy: 'Accident or incident record should contain at least one child.',
        removeSignatureChildContactWarning: 'Editing this will remove any existing signatures and will have to be re-signed after updating.',
        saveAndApproveButtonLabel: 'Save & approve',
        saveAndRequestButtonLabel: 'Save & request for approval',
        saveAsDraftButtonLabel: 'Save as draft',
        sendPopupCopy: 'Are you sure you want to send this {{ type }} record for approval?',
        signatureWarningOnEdit: 'Editing accident or incidents will remove any existing signature added.',
        titleLabel: 'Title',
        updateDraftButtonLabel: 'Update draft',
      },
      Common: {
        accident: 'Accident',
        accidentDetails: 'Accident details',
        approve: 'Approve',
        incident: 'Incident',
        incidentDetails: 'Incident details',
      },
      Constants: {
        SignatureCollectingLabels: {
          digitally: 'Digitally',
          onPaper: 'On paper',
        },
        SignatureStaffMemberLabels: {
          senior: 'Senior in charge',
          supervisor: 'Supervising staff',
        },
        Status: {
          approvedAndSigned: 'Approved & signed',
          draft: 'Draft',
          pendingForApproval: 'Pending approval',
          signatureNeeded: 'Signatures needed',
        },
        Type: {
          accidents: 'Accidents',
          incidents: 'Incidents',
        },
      },
      Fields: {
        AttachedMedia: {
          label: 'Attached media',
        },
        Details: {
          AccidentDetails: {
            label: 'Accident details',
          },
          IncidentDetails: {
            label: 'Incident details',
          },
          placeholder: 'Explain fully the events leading up to and including the {{ type }}.',
        },
        Location: {
          label: 'Location',
          placeholder: 'Location',
        },
        OtherSeniorIncharge: {
          label: 'Other senior in charge',
          placeholder: 'Other senior in charge',
        },
        OtherStaffSupervising: {
          label: 'Other staff supervising',
          placeholder: 'Other staff supervising',
        },
        OtherWitnessedBy: {
          label: 'Other witnessed by',
          placeholder: 'Other witnessed by',
        },
        RiskAssessment: {
          label: 'Risk assessment & outcomes',
          placeholder: 'Enter risks and outcomes',
        },
        SeniorIncharge: {
          label: 'Senior in charge',
          placeholder: 'Senior in charge',
        },
        StaffSupervising: {
          label: 'Staff supervising',
          placeholder: 'Staff supervising',
        },
        WitnessedBy: {
          label: 'Witnessed by',
          placeholder: 'Witnessed by',
        },
        firstAidBy: {
          label: 'First aid by',
          placeholder: 'First aid by',
        },
        otherFirstAidBy: {
          label: 'Other first aid by',
          placeholder: 'Other first aid by',
        },
      },
      Filter: {
        dateRange: 'Date range',
        injuries: 'Injuries',
        room: 'Room',
        supervisor: 'Supervisor',
        type: 'Type',
      },
      List: {
        emptyStateText1: 'There are no records.',
        emptyStateText2: 'Log an accident or incident record.',
        itemSignatureTitle: 'Signatures',
        supervisorPlaceholder: 'Supervisor',
        title: 'Accidents & Incidents',
        typePlaceholder: 'Type',
      },
      Placeholder: {
        AccidentIncidentDescription: 'Explain the {{ type }} and the events leading to it.',
        parent: 'Parent',
        ristOutcomes: 'Enter risks and outcomes',
        treatmentProvided: 'What treatment was provided to the child?',
      },
      Preview: {
        Details: {
          accidentDetailsLabel: 'Accident Details',
          attachedMediaLabel: 'Attached media',
          dateLabel: 'Date of {{ type }}',
          dateTimeLabel: 'Date & Time of accident or incident',
          firstAidByLabel: 'First aid by',
          incidentDetailsLabel: 'Incident details',
          locationLabel: 'Location',
          noticeLabel: 'Notice',
          riskAssessmentLabel: 'Risk assessment & outcomes',
          seniorInChargeLabel: 'Senior in charge',
          staffSupervisingLabel: 'Staff supervising',
          statusLabel: 'Status',
          timeLabel: 'Time of {{ type }}',
          title: 'Details',
          treatment: 'Treatment',
          treatmentDetailsLabel: 'Treatment Details',
          witnessedByLabel: 'Witnessed by',
        },
        Signatures: {
          CollectingOption: {
            changeLinkLabel: 'Change',
            digitalLabel: 'Collect signatures digitally',
            onPaperLabel: 'Collect signatures on paper',
            outOfLabel: 'of {{ all }} signed',
            subtitle: 'How do you want to collect signatures?',
            title: 'Collecting signatures',
          },
          Digital: {
            addButtonLabel: 'Add signature',
            clearSignatureButtonLabel: 'Clear signature',
            contactEmptySearchNoOptionsMessage: 'Please add a contact with parental authority for this child.',
            contactPlaceholder: 'Select contact',
            parentAddContactLabel: 'Add contact for {{ name }}',
            removeContactButtonLabel: 'Remove contact',
            removeSignatureCopy: 'Removing this contact will also remove the signature.',
            signature: 'Signature',
          },
          OnPaper: {
            markAllAsNotSigned: 'Mark all as not signed',
            markAllAsSigned: 'Mark all as signed',
            notSignedLabel: 'Not signed',
            signedLabel: 'Signed',
            uploadDocumentTitle: 'Upload signed documents',
            uploadImageButtonLabel: 'Attach files',
            uploadImageButtonSubLabel1: 'Supported file types: PDF,JPEG,PNG',
            uploadImageButtonSubLabel2: 'Max file size: 25MB',
          },
          approvalTooltip: 'Management approval needed to add parent signatures',
          carerLabel: 'Contact for {{ childFirstName }}',
          title: 'Signatures',
          titleTooltip: 'Signatures cannot be added for draft accidents and incidents.',
          titleWithCount: 'Signatures ({{ signed }}/{{ all }})',
        },
        accidentDetailsLabel: 'Accident details',
        accidentRecordTitle: 'Accident record',
        approvePopupCopy: 'Are you sure you want to approve this {{ type }} record?',
        approveRecordLabel: 'Approve record',
        attachedMediaLabel: 'Attached media',
        dateLabel: 'Date of {{ type }}',
        emptyStateText: 'Not found injury',
        exportTitle: 'Export {{ type }} record',
        exportUserLabel: 'Select a manager or administrator to send the PDFs to',
        firstAidByLabel: 'First aid by',
        guardianContactedLabel: 'Guardian/Contact has been contacted',
        incidentDetailsLabel: 'Incident details',
        incidentRecordTitle: 'Incident record',
        pendingPopupCopy: 'Are you sure you want to send this record for approval?',
        requestForApprovalLabel: 'Request for approval',
        requireFollowingField: 'Please enter the following fields to approve the {{ type }} record.',
        riskAssessmentLabel: 'Risk assessment & outcomes',
        seniorInChargeLabel: 'Senior in charge',
        staffSupervisingLabel: 'Staff supervising',
        timeLabel: 'Time of {{ type }}',
      },
      Routing: {
        Add: {
          title: 'Log accident or incident',
        },
        Edit: {
          title: 'Edit accident or incident',
        },
        title: 'Accidents & Incidents',
      },
    },
    Learning: {
      CohortTracking: {
        CohortTrackingList: {
          area: 'Area',
          areaOfLearning: 'Area of learning',
          comparisonReports: 'Comparison Reports',
          noRecords: "No formative reports have been created, to generate progress tracker and comparison reports. Please go to child's learning  journey to create a formative report.",
          progressTracker: 'Progress tracker',
          term: 'Term',
          title: 'Cohort tracking',
        },
        ComparisonReport: {
          comparisonChart: {
            Boys: 'Boys',
            EYPP: 'EYPP',
            Girls: 'Girls',
            footerDescription: "Select a chart to view a breakdown of each child's progress in",
            nonEYPP: 'Non - EYPP',
            nonSummerBorn: 'Non - Summer born',
            notFound: 'There are no {{ label }}{{ childrenText }} with {{ term }} formative reports',
            notFoundChildren: ' children',
            summerBorn: 'Summer born',
          },
          comparisonReportType: 'Comparison report',
          comparisonTable: {
            completed: 'Completed',
            noStatementsFound: 'No statements found in this formative report',
            totalChildren: 'Total children',
            workingOn: 'Working on',
          },
          confirmRemove: 'Are you sure you want to delete this report?',
          title: 'Comparison report',
        },
        ComparisonReportGenerator: {
          comparisonReportType: 'Comparison report',
          noFrameworksList: 'To use comparison records tracker, activate a curriculum in the settings that is compatible with it.',
          selectComparisonReport: 'Select comparison report',
          title: 'Comparison report',
        },
        ProgressTrackerGenerator: {
          noFrameworksList: 'To use the progress tracker, activate a curriculum in the settings that is compatible with it.',
          pleaseSelectReportToCreate: 'Please select a report to create',
          title: 'Progress tracker',
          trackerType: 'Tracker type',
        },
        ProgressTrackerReport: {
          ProgressTrackerTable: {
            ageMonths: 'Age (months)',
            na: 'N/A',
            name: 'Name',
            noReport: 'No report',
          },
          areaOfLearning: 'Area of Learning',
          confirmRemove: 'Are you sure you want to delete this report?',
          description: 'Please note these assessments are drawn from formative reports',
          search: "Search child's name",
          term: 'Term',
          title: 'Progress tracker',
        },
        components: {
          ActionPlan: {
            actionPlan: 'Action plan',
            addActionPlan: 'Add action plan',
            deleteActionPlan: 'Delete action plan',
            placeholder: 'Enter action plan here',
          },
          ReportGeneratorFilters: {
            ethnicity: 'Ethnicity',
            gender: 'Gender',
            selectFilters: 'Select filters to view a specific group',
          },
        },
        global: {
          actionPlan: 'Action plan',
          areaOfLearning: 'Area of learning',
          description: 'Please note these assessments are drawn from formative reports.',
          framework: 'Framework',
          goToSettings: 'Go to settings',
          invalidQueryParams: 'Used invalid params, please generate report again.',
          nothingFound: 'There are no children that match your search',
          progressTracker: 'Progress tracker',
          selectTerm: 'Select term',
          startingPoint: 'Starting point',
        },
        title: 'Cohort tracking',
      },
      FormativeReports: {
        FormativeReportsCreate: {
          Form: {
            createReport: 'Create Report',
            enterCustomAssessmentPeriod: 'Enter custom assessment period',
            enterCustomTerm: 'Enter custom term',
            reportPeriod: 'Report period',
            selectAssessmentPeriod: 'Select assessment period',
            selectTerm: 'Select term',
            typeOfReport: 'Type of report',
          },
          subtitle: {
            part1: 'Select the date range for your formative report. It will include the development statements marked in the',
            part2: 'framework',
            part3: 'between the dates selected.',
          },
          title: 'Create a report',
        },
        FormativeReportsList: {
          emptyState: 'There are no records.',
          searchBarPlaceholder: 'Search for a child, key person or creator',
          subtitle: 'To create a formative report you will be redirected to the child’s framework page.',
        },
        FormativeReportsPreview: {
          COEL: {
            title: 'COEL',
          },
          ChildOverview: {
            title: 'Child overview',
          },
          Comments: {
            placeholder: 'Enter comment',
            title: 'Comments',
          },
          CompletedStatements: {
            emptyStateText: 'There are no statements in the selected period.',
            title: 'Completed statements',
          },
          NextStepsForHome: {
            placeholder: 'Enter next steps',
            title: 'Next step(s) for home',
          },
          StatementsBeingWorkedOn: {
            emptyStateText: 'There are no statements in the selected period.',
            title: 'Statements being worked on',
          },
          ageGroup: 'Age group',
          alert: 'Please remember to save your changes before exiting.',
          messageOnDelete: 'Are you sure you want to remove this formative report?',
          messageOnSave: 'Formative report has been successfully updated.',
          progressLevel: 'Progress level',
          shareOnParentApp: 'Share on parent app',
          title: 'Formative report preview',
        },
        ReportTypes: {
          '2YearCheck': '2 year check',
          '2YearProgressCheck': '2 year progress check',
          formativeReport: 'Formative report',
          transitionReport: 'Transition report',
        },
        assessmentPeriod: 'Assessment period',
        reportType: 'Report type',
        term: 'Term',
        title: 'Formative reports',
      },
      NextSteps: {
        NextStepsList: {
          areas: 'Areas',
          by: 'by',
          dateAchieved: 'Date achieved',
          dateChanged: 'Date achieved has been changed.',
          eyfsKey: 'EYFS Key',
          itemReset: 'Next step has been reset.',
          makeObservation: 'Make observation',
          markAsAchieved: 'Mark as Achieved',
          markAsAchievedSuccess: 'Record has been marked as achieved.',
          notFound: 'No next steps found',
          title: 'Next steps',
          typePlaceholder: 'All next steps',
          viewDetails: 'View details',
          viewFollowUpObservation: 'View follow up observation',
        },
        title: 'Next steps',
      },
      ObservationTracker: {
        EmptyState: {
          goToSettings: 'Go to settings',
          noCurriculums: 'To use the observation tracker, activate a curriculum in the settings that is compatible with it.',
          noRecords: 'There are no children matching your search criteria. Please amend your filters.',
        },
        ageMonths: 'Age (months)',
        name: 'Name',
        title: 'Observation tracker',
        totalObservations: 'Total observations',
      },
      Observations: {
        ObservationFrameworks: {
          bannerInfo: 'How children learn is as important as what children learn. You may want to reference the Characteristics of Effective Learning.',
          emptyState: 'To make observation links, activate a curriculum in the settings that is compatible with it.',
          frameworks: 'Frameworks',
          progress: 'Progress',
          progressUpdated: 'Progress has been updated',
          returnToObservation: 'Return to observation',
          showCompletedStatements: 'Show completed statements',
          showSuggestedLinks: 'Only show suggested links',
          statementsInfo: 'If this is switched off, all statements previously marked as secure will be hidden.',
          title: 'Observation links',
        },
        ObservationNextSteps: {
          addNextStep: 'Add next step',
          area: 'Area',
          detailsPlaceholder: 'Think about how you can adapt the environment, consider the child’s interests and what support you can provide. Think about how children learn rather than what they learn. Next steps should not be based on statements. You may want to reference guidance materials.',
          montessori: 'Montessori',
          nextActivities: 'Next activities',
          nextStepUpdated: 'Next step has been updated',
          nextStepsDetails: 'Next steps details',
          recommendedActivity: 'Recommended activity',
          recordRemoved: 'Record has been successfully removed',
          removeContent: 'Do you want to delete this next step record?',
          title: 'Next steps',
        },
        ObservationsEdit: {
          additionalObservations: 'Additional observations',
          beingUpload: 'Files are being uploaded. This action will stop further upload.',
          observation: 'Observation',
          review: 'Review',
          selectChildren: 'Select children',
          title: 'Make observation',
        },
        ObservationsFeedback: {
          Improvements: {
            linksToFramework: 'Links to framework',
            nextSteps: 'Next steps',
            observationDetails: 'Observation details',
            spellingAndGrammar: 'Spelling and grammar',
          },
          addFeedback: 'Add feedback',
          comments: 'Comments',
          enterComments: 'Enter comments',
          feedbackBy: 'Feedback by',
          improvements: 'Improvements required',
          observationBy: 'Observation by',
          sendForApproval: 'Send for approval',
          statusChangesMade: 'Changes made',
          statusChangesRequested: 'Changes requested',
          title: 'Feedback history',
          updatedBy: 'Updated by',
        },
        ObservationsList: {
          P: 'P',
          emptyState: 'There are no observations matching your criteria.',
          observation: 'observation',
          observations: 'observations',
          observationsFromHome: 'Observations from home',
        },
        ObservationsReview: {
          MissingGoldenMoment: {
            1: 'This observation has not been marked as a',
            2: 'golden moment',
            3: 'If you wish to share this observation with parents, please click cancel and select share on the parent app.',
          },
          ShowGoldenMoment: {
            1: 'This observation has been marked as a',
            2: 'golden moment',
            3: 'If you do not wish to share this observation with parents, please click cancel and unselect share on the parent app.',
          },
          approveObservationButtonLabel: 'Approve observation',
          area: 'Area',
          confirmRemoveObservation: 'Are you sure you want to remove this observation?',
          emptyStateMessage: 'No data to show.',
          media: 'Media',
          observationAdditionalSummaryTitle: 'Additional observation summary',
          observationSummaryTitle: 'Observation summary',
          reviewFailMessage: 'You have not added a child to this observation. Please add a child so the observation can be approved.',
          sendForApprovalButtonLabel: 'Send for approval',
          title: 'Review observation',
        },
        title: 'Observations',
      },
      routing: {
        cohortTracking: 'Cohort tracking',
        comparisonReport: 'Comparison report',
        learning: 'Learning',
        preview: 'Preview',
        progressTracker: 'Progress tracker',
      },
    },
    LikesAndComments: {
      authorDeactivated: 'Deactivated user',
      comments: 'Comments',
      featureDeactivated: 'The nursery deactivated the likes and comments feature.',
      like: '1 like',
      likes: '{{ amount }} likes',
      notFound: 'No comments added yet',
      peopleWhoLiked: 'People who liked',
      post: 'Post',
      writeNewComment: 'Write new comment...',
    },
    Management: {
      AbsenceReasons: {
        dropdownPlaceHolder: 'Select reason',
      },
      AttendancePeriods: {
        Add: {
          Form: {
            Name: {
              label: 'Name',
              placeholder: 'E.g. All year round or Term time',
            },
            Period: {
              label: 'Period',
            },
          },
          editTitle: 'Edit attendance period',
          snackbarLabel: 'Attendance period {{ mode }}.',
          termDateAddSubmitLabel: 'Save & set dates',
          termDateEditSubmitLabel: 'Update & set dates',
          title: 'Add attendance period',
        },
        PeriodOptions: {
          AllYearRound: {
            label: 'All year round',
            tooltip: 'The attendance period will generally be applied all year round.',
          },
          TermDates: {
            label: 'Term dates',
            tooltip: 'Choose specific dates for the attendance period.',
          },
        },
        SetTermDates: {
          closureDateLegendLabel: 'Closure date',
          editInfoBanner: 'Editing existing dates may impact invoicing',
          routeTitle: 'Set term dates for Term Time',
          snackbarLabel: 'Terms dates updated.',
          termTimeLegendLabel: 'Term time',
          title: 'Set term dates for {{ periodName }}',
        },
        Table: {
          Header: {
            name: 'Name',
            period: 'Period',
          },
          actionLabel: 'Set term dates',
        },
        archivePopupCopy: '"{{ periodType }}" will be archived. It will still be used on existing session sets but can not be selected for new ones.',
        emptyState: 'No attendance periods',
        missingDatesLabel: 'Missing dates',
        planFutureDatesLabel: 'Plan future term dates',
        subtitle: 'Attendance periods can be all year round or term time that are applied to children’s booking patterns. The dates determine when children can attend and are used to calculate invoices.',
        title: 'Attendance periods',
        unarchivePopupCopy: '"{{ periodType }}" will be unarchived. It can be selected on new session sets.',
      },
      ClosureDays: {
        ClosureDates: {
          Add: {
            Form: {
              AcademicYear: {
                label: 'Academic year',
              },
              ClosureDayType: {
                label: 'Closure day type',
              },
              Dates: {
                label: 'Dates',
                placeholder: 'Start date - End date',
              },
              Description: {
                label: 'Description',
                placeholder: 'e.g. Bank Holiday',
              },
            },
            addDatesItemLabel: 'Add dates',
            deleteText: 'This will delete all closure dates for the academic year {{ academicYear }}.',
            editTitle: 'Edit nursery closure dates',
            emptyClosureDateValidationError: 'No closure dates have been selected.',
            snackbarLabel: 'Closure dates {{ mode }}.',
            title: 'Add nursery closure dates',
            updateText: 'Any changes will affect uninvoiced sessions. You may also need to reallocate funding.',
          },
          Preview: {
            Table: {
              Header: {
                closureDates: 'Closure dates',
                closureDayType: 'Closure day type',
                endDate: 'End date',
                startDate: 'Start date',
              },
            },
          },
          Table: {
            Header: {
              academicYear: 'Academic year',
            },
          },
          emptyState: 'No closure dates',
          title: 'Closure dates',
        },
        ClosureDayTypes: {
          Add: {
            Form: {
              ChargeFor: {
                label: 'Charge for',
              },
              Name: {
                label: 'Name',
                placeholder: 'Name',
              },
              chargeForValidationMessage: 'One of the charge for should be selected',
            },
            archivePopupCopy: 'Are you sure, Do you want to archive this closure type?',
            editTitle: 'Edit closure day type',
            title: 'Create closure day type',
            unarchivePopupCopy: 'Are you sure, Do you want to unarchive this closure type?',
          },
          List: {
            Table: {
              Header: {
                Chargeable: {
                  title: 'Chargeable',
                },
                Name: {
                  title: 'Name',
                },
              },
            },
            emptyState: 'No closure day types found',
          },
          title: 'Closure day types',
        },
        subtitle: 'Here you can set your nursery closure days',
        title: 'Closure days',
      },
      Enquiries: {
        EnquiryForm: {
          FormSubmissionPage: {
            CustomLink: {
              label: 'Custom form submission page URL',
              placeholder: 'Enter custom form submission page URL',
            },
            RedirectLink: {
              label: 'Form completion redirect link (optional)',
              placeholder: 'Enter redirect link',
            },
            ThankYouPageOptions: {
              Custom: {
                label: "Use custom 'thank you' page",
                tooltip: 'By linking the enquiry form to your own form submission page, you can track the conversation for your website using analytics tool such as Google Analytics.',
              },
              Default: {
                label: "Use default 'thank you' page",
                tooltip: 'The parent will be redirected to the system pre-built from submission page. If you also provide a redirect link, they can return back there after (e.g. back to your nursery website homepage).',
              },
            },
            subtitle: "Once the enquiry form is submitted it will redirect to 'thank you' page.",
            title: 'Form submission page',
          },
          copyLink: 'copy link',
          formLink: 'Form link',
          previewForm: 'preview form',
          subtitle: 'If you want parents to fill out an enquiry form that adds the information straight to your enquiries list please share the link below with interested parents or embed it to your website.',
          title: 'Enquiry form',
          tooltipTitle: 'This is the link that the parent will be redirected to after completing the enquiry form process (e.g. back to your nursery website homepage).',
        },
        EnquiryPipeline: {
          Add: {
            Form: {
              Name: {
                label: 'Enquiry stage',
                placeholder: 'Enter the enquiry stage',
              },
            },
            addTitle: 'Add enquiry stage',
            createSuccessMessage: 'Enquiry stage created',
            deleteSuccessMessage: "Enquiry stage '{{ name }}' deleted",
            editTitle: 'Edit enquiry stage',
            migrateSuccessMessagePlural: '{{ enquiriesCount }} enquiries successfully migrated',
            migrateSuccessMessageSingular: '{{ enquiriesCount }} enquiry successfully migrated',
            updateSuccessMessage: 'Enquiry stage updated',
          },
          Table: {
            Header: {
              order: 'Order',
              stage: 'Stage',
            },
          },
          deleteMessage1: 'Are you sure you want to remove this enquiry stage?',
          deleteMessage2: 'You may need to migrate existing enquiries in the stage to new one.',
          orderUpdateMessage: 'Enquiry stage order updated',
          title: 'Enquiry pipeline',
          tooltip: 'This enquiry stage is pre-built in the system.',
        },
        EnquiryReason: {
          Add: {
            Form: {
              Name: {
                label: 'Reason',
                placeholder: 'Enter the reason',
              },
            },
            addTitle: 'Add enquiry reason',
            createSuccessMessage: 'Enquiry reason created',
            deleteSuccessMessage: 'Enquiry reason deleted',
            editTitle: 'Edit enquiry reason',
            updateSuccessMessage: 'Enquiry reason updated',
          },
          Table: {
            Header: {
              reason: 'Reason',
            },
          },
          deleteMessage1: 'Are you sure you want to remove this enquiry reason?',
          deleteMessage2: 'Already created enquiries with this enquiry reason will not be affected.',
          plural: 'Enquiry reasons',
          singular: 'Enquiry reason',
          title: 'Enquiry reason',
          tooltip: 'This enquiry reason is pre-built in the system.',
        },
        EnquirySource: {
          Add: {
            Form: {
              Name: {
                label: 'Source',
                placeholder: 'Enter the source',
              },
            },
            addTitle: 'Add enquiry source',
            createSuccessMessage: 'Enquiry source created',
            deleteSuccessMessage: 'Enquiry source deleted',
            editTitle: 'Edit enquiry source',
            updateSuccessMessage: 'Enquiry source updated',
          },
          Table: {
            Header: {
              source: 'Source',
            },
          },
          deleteMessage1: 'Are you sure you want to remove this enquiry source?',
          deleteMessage2: 'Already created enquiries with this source will not be affected.',
          plural: 'Sources',
          singular: 'Source',
          title: 'Enquiry source',
          tooltip: 'This enquiry source is pre-built in the system.',
        },
        LostReason: {
          Add: {
            Form: {
              Name: {
                label: 'Lost reason',
                placeholder: 'Enter the lost reason',
              },
            },
            addTitle: 'Add lost reason',
            createSuccessMessage: 'Lost reason created',
            deleteSuccessMessage: 'Lost reason deleted',
            editTitle: 'Edit lost reason',
            updateSuccessMessage: 'Lost reason updated',
          },
          Table: {
            Header: {
              lostReason: 'Lost reason',
            },
          },
          deleteMessage1: 'Are you sure you want to remove this enquiry lost reason?',
          deleteMessage2: 'Already created enquiries with this enquiry lost reason will not be affected.',
          plural: 'Lost reasons',
          singular: 'Lost reason',
          title: 'Lost reason',
          tooltip: 'This lost reason is pre-built in the system.',
        },
        shortTitle: 'Enquiries',
        title: 'Enquiries settings',
      },
      Finance: {
        AccountCodes: {
          ItemCategories: {
            consumables: 'Consumables',
            consumablesAddedToSessions: 'Consumables added to sessions',
            deposits: 'Deposits',
            discounts: 'Fee discounts & refunds',
            extraItems: 'Extra items',
            extraSessions: 'Extra sessions',
            funding: 'Funding',
            fundingDeducted: 'Funding deducted',
            items: 'Items',
            other: 'Other fees',
            packages: 'Packages',
            regularItems: 'Regular items',
            regularSessions: 'Regular sessions',
            sessions: 'Sessions',
          },
          TableHeaders: {
            accountCode: 'Account / Nominal codes',
            itemCategory: 'Item categories',
          },
          accountCodePlaceholder: 'Account code',
          emptyState: 'There are no nominal codes defined at the moment.',
          snackbarMessage: '{{ name }} account code has been updated.',
          subtitle: 'Here you can define your nominal codes.',
          title: 'Account codes',
        },
        Accounting: {
          title: 'Accounting',
        },
        Annualised: {
          Edit: {
            Form: {
              AllowOverwrite: {
                label: 'Allow overwrites on child level',
              },
              Months: {
                label: 'Months',
                placeholder: 'Months',
              },
              UseOrganizationSetting: {
                label: 'Use default organization setting',
              },
              Weeks: {
                label: 'Weeks',
                placeholder: 'Weeks',
              },
              duplicateMonthError: 'This month is already selected',
            },
          },
          components: {
            ExcludedMonths: {
              title: 'Excluded months for invoicing',
            },
          },
          subtitle: 'Default week and months used to calculate annualised invoices, weekly packaged price or monthly packaged prices',
          title: 'Annualised and packaged invoices',
        },
        Consumables: {
          Add: {
            InvoiceLineItemDisplay: {
              IncludeInSession: {
                label: 'Combine the consumable cost into the session fee',
                tooltip: 'Combine the consumable cost into the session fee',
              },
              SeparatelyFromSession: {
                label: 'Show consumable line items separately to session fee',
                tooltip: 'Show consumable line items separately to session fee',
              },
            },
            title: 'Add a consumable',
          },
          Edit: {
            title: 'Edit a consumable',
          },
          Form: {
            archiveItem: 'Are you sure you want to archive this consumable? Please note: past invoices showing this consumable will not be affected.',
            submitConfirmContent: 'Are you sure you to update the consumables?\n Please note: removing any consumables will only affect uninvoiced sessions.',
            unarchiveItem: 'Are you sure you want to unarchive this consumable? You can archive it again at any time.',
          },
          emptyState1: 'There are no consumables created.',
          emptyState2: 'Add consumables to show up when adding them to sessions.',
          subtitle: 'This is where you can set the consumables that can be added to sessions.',
          title: 'Consumables',
        },
        Discounts: {
          Form: {
            BeforeAfterFunding: {
              label: 'Apply discount before or after funding has been deducted from regular session price?',
            },
          },
          add: {
            title: 'Add a discount',
          },
          archivedText: 'Are you sure you want to {{ label }} this discount? Please note: this discount already allocated to children will not be affected.',
          discountAmount: 'Discount amount',
          discountEmptyState: 'Add discounts here to show up on invoices.',
          discountName: 'Discount name',
          discountPercentage: 'Discount percentage',
          discountType: 'Discount type',
          edit: {
            title: 'Edit a discount',
          },
          enableOverwriting: 'Enable overwriting the discount value on child level',
          fixedAmountDiscount: 'Fixed discount amount',
          fixedAmountDiscountInfoSubTitle: 'However, the amount being subtracted cannot be more than the invoice total and must be manually edited on the invoice.',
          fixedAmountDiscountInfoTitle: 'The discount entered will be deducted from the invoice total.',
          listTitle: 'These are the discounts for your nursery. You can allocate them to children from the child profile.',
          percentageDiscount: 'Percentage discount',
          title: 'Discounts',
          unArchivedText: 'Are you sure you want to unarchive this discount ? You can archive it again at any time.',
          yourDiscounts: 'Your discounts',
        },
        ExtraItems: {
          Add: {
            title: 'Add an item',
          },
          Edit: {
            title: 'Edit a item',
          },
          title: 'Extra items',
        },
        Funding: {
          Add: {
            InvoiceDisplayOptions: {
              invoiceLineItemDeductionLabel: 'Funding deduction on invoices',
              invoiceLineItemDisplayLabel: 'Funding line item on invoices',
              previewLineItem: 'Preview line items',
              title: 'Invoice display options',
            },
            addExclusionPeriod: 'Add exclusion period',
            annualizedOrPackageInvoiceBanner: 'Annualised or packaged invoices will revert back to calendar monthly invoices, if there are any mid-month price changes. We recommend scheduling price changes on the first of each month.',
            archiveText1: 'Are you sure you want to {{ label }} this funding type?',
            archiveText2: 'You can unarchive it at any time.',
            bookingPlanEndsMidWeek: 'Booking plan ends mid-week',
            changeRedistributionRule: 'You will need to re-apply funding to existing booking patterns for the changes to apply',
            chargeFundingDeficit: 'Charge funding deficit',
            chargeFundingDeficitName: 'Funding deficit invoice line item name',
            closureDaysSessionChargeable: 'Closure days (sessions chargeable)',
            closureDaysSessionChargeableApplyHint: 'On chargeable closure days the session hourly rate will be deducted from the invoice.',
            closureDaysSessionNotChargeable: 'Closure days (sessions not chargeable)',
            closureDaysSessionNotChargeableApplyHint: 'On not chargeable closure days the Local Authority funding hourly rate will be deducted from the invoice.',
            customLocalAuthorityBanner: 'For any children with custom local authority funding hourly rates on the booking pattern the price changes will not apply for the period of the booking pattern.',
            deductFromParentInvoice: 'Does this funding deduct from the parent’s invoice?',
            exclusionPeriod: 'Exclusion period',
            fundedHoursPerWeek: 'Funded hours per week',
            fundingExclusionPeriods: 'Funding exclusion periods',
            fundingExclusionPeriodsSubtitle: 'Funded hours will not be automatically allocated during these periods.',
            fundingInvoiceDeduction: 'Funding invoice deduction',
            fundingPeriod: 'Funding period',
            fundingPeriodInfoText: 'This information is required for the Funding Loop export.',
            fundingType: 'Funding type',
            fundingTypeName: 'Funding type name',
            fundingValue: 'Funding value',
            hourlyRate: 'Hourly rate',
            localAuthorityHourlyRate: 'Local authority hourly rate',
            maxHoursPerDay: 'Max hours per day',
            ongoing: 'Ongoing',
            redistributionRules: 'Redistribution rules for funded hours on untypical weeks',
            redistributionRules2: 'These rules define how the funding should be applied on untypical days. For more information please visit our help centre.',
            scheduleHourlyRateChange: 'Schedule hourly rate change',
            showItemOnInvoice: 'Show line item on invoice without a value.',
            stretchedWeeks: 'Stretched weeks',
            termTimeHolidays: 'Term time holidays',
            termTimeHolidaysApplyHint: 'On not chargeable closure days the Local Authority funding hourly rate will be deducted from the invoice.',
            title: 'Create funding type',
          },
          Edit: {
            title: 'Edit funding type',
          },
          List: {
            deducted: 'Deducted',
            fundingName: 'Funding name',
            fundingValue: 'Funding value',
            hourlyRate: 'Hourly rate',
            invoice: 'Invoice',
            notDeducted: 'Not deducted',
            notFound: 'There are no funding types created.',
            oneOffFunding: 'One-off funding',
            regularFunding: 'Regular funding',
            type: 'Type',
            weeklyHours: 'Weekly hours',
          },
          title: 'Funding',
        },
        Invoice: {
          BankSettings: {
            accountName: 'Account name',
            accountNumber: 'Account number',
            bank: 'Bank',
            notes: 'Notes',
            sortCode: 'Sort code',
            subtitle: 'The bank will appear on invoices under payment options.',
            title: 'Invoice bank details',
          },
          InvoiceNumberSettings: {
            subtitle: 'This is where you can set the automated number sequencing to generate invoice receipt and credit note numbers.',
            title: 'Invoice number sequencing',
          },
          description: 'This is where you can set your invoice settings for calculations and additional notes on invoices.',
          title: 'Invoice settings',
        },
        InvoiceNumber: {
          Edit: {
            title: 'Edit invoice number sequencing',
          },
          title: 'Invoice number sequencing',
        },
        Invoicing: {
          title: 'Invoicing',
        },
        Item: {
          Add: {
            archiveText1: 'Are you sure you want to {{ label }} this item?',
            archiveText2: 'You can unarchive it at any time.',
            fee: 'Fee',
            fees: 'Fees',
            itemName: 'Item name',
            ongoing: 'Ongoing',
            schedulePriceChange: 'Schedule price change',
            title: 'Add a Item',
          },
          Edit: {
            title: 'Edit a Item',
          },
          List: {
            cost: 'Cost',
            items: 'Items',
            notFound: 'Add items here to show up on invoices.',
          },
          legacyTitle: 'Extra items',
          title: 'Items',
        },
        LineItems: {
          title: 'Line items',
        },
        NewFinance: {
          activateOrInactivateSnackbar: {
            text: 'New finance 3 option {{ status }}',
          },
          body: {
            isOrganisationBody: {
              li: {
                fifthLine: 'Easier funding allocation',
                firstLine: 'Packages',
                fourthLine: 'Scheduled price changes for session, items & funding',
                secondLine: 'Booking patterns for alternating weeks',
                sixthLine: 'Session discounts before and after the funding was allocated',
                thirdLine: 'Annualised invoicing.',
              },
              notes: {
                firstLi: 'When you activate the new finance suite, it will be activated for nurseries within your group.',
                secondLi: 'We will make a backup of all your booking pattern and financial data in blossom. If you decide to go back to our old finance version all booking pattern and financial data added since the backup will be lost.',
              },
              subtitleFirstLine: 'Test our new and amazing finance suite.',
              subtitleSecondLine: 'To read more about click here',
            },
            li: {
              firstLine: 'Packages',
              secondLine: 'Alternative weeks',
              thirdLine: 'Session, item, funding price changes',
            },
            newFinanceSwitchLabel: 'Activate new finance 3',
            notes: {
              subtitleFirstLine: 'Copy about migration and backup we make and that it is a one way migration.',
              title: 'Important',
            },
            subtitleFirstLine: 'Marketing copy (will be finalised later)',
            subtitleSecondLine: 'Test our new and amazing finance suite. It will have the following features.',
          },
          subMenuTitle: 'New finance suite',
          title: 'New Blossom Finance',
        },
        Payment: {
          title: 'Payment',
        },
        PaymentGateway: {
          americanExpress: 'American Express',
          bacsMustBeDisabledAsFirst: 'To deactivate card payments you need to deactivate BACS DirectDebit first.',
          cannotDisconnectStripeModal: {
            1: 'There are currently transactions and payouts still processing.',
            2: 'To disconnect your stripe account',
            3: 'Turn off all payment methods so no new transactions can be added.',
            4: 'Wait until the current transactions are completed and all payouts are paid out.',
            title: 'Cannot disconnect Stripe',
          },
          cardPaymentMustBeEnabledAsFirst: 'To use BACS Direct Debit you need to activate card payments first.',
          changeBACSPaymentDate: 'Change Direct Debit run start date?',
          changeCardPaymentDate: 'Change card recurring payment date?',
          changePaymentDateBACS: 'This will change the run start date to the {{ day }} of each month. Runs can typically take around 3 days to complete.',
          changePaymentDate_1: 'This will change the day bill players are charged to the {{ day }} of each month.',
          changePaymentDate_2: 'You may want to let bill payers know beforehand via the Newsletter feature.',
          connectWithStripe: 'Connect with Stripe',
          connectWithStripeDesc: 'Securely connect with Stripe to allow easy online payments from the Parent App.',
          connectedToStripe: 'Connected to Stripe',
          continueOnboarding: 'Continue onboarding',
          creditCard: 'Card payments',
          currentlyProcessingBACS: 'Currently processing Direct Debit runs will not be affected by any changes.',
          directDebit: 'Direct Debit (BACS)',
          directDebitDateChanged: 'Direct Debit payment date changed.',
          disconnectFromStripe: 'Disconnect from stripe',
          disconnectStripeModal: {
            1: 'Impact on the system',
            2: 'Payment options will be removed from the Parent App.',
            3: 'Active Direct Debits will be cancelled.',
            4: 'You may want to let bill payers know beforehand via the Newsletter feature.',
            disconnect: 'Disconnect',
            title: 'Disconnect Stripe',
          },
          disconnectSuccess: 'Your Stripe account has been successfully disconnected.',
          enableOrDisableModal: {
            BACS: {
              disable_1: 'This will cancel any active Direct Debit mandates and remove the Direct Debit option for bill payers on the Parent App.',
              disable_2: 'Any Direct Debit runs already initiated will still be processed.',
              enable_1: 'This will allow bill payers to set up Direct Debit mandates for their children on the Parent App.',
              title: 'BACS Direct Debit',
            },
            Card: {
              disable_1: 'This will remove the option for bill payers to pay by card on the Parent App.',
              enable_1: 'This will allow bill payers to pay by card on the Parent App.',
              title: 'card payments',
            },
            Disable: 'Disable',
            Enable: 'Enable',
            newsletter: 'You may want to let bill payers know beforehand via the Newsletter feature.',
          },
          enableOrDisableSnackbar: {
            capabilities: {
              american_express: 'American express',
              bacs_debit_payments: 'Direct Debit (BACS)',
              card_payments: 'Card payments',
              sepa_debit_payments: 'Single Euro Payments Area',
            },
            disabled: 'disabled',
            enabled: 'enabled',
            error: '',
            text: '{{ type }} option {{ status }}',
          },
          getPaidFaster: 'Get paid faster with Blossom.',
          learnMore: '<0>Learn more</0> about connecting with Stripe.',
          missingInformation: 'There are some missing information in your stripe account. Fill the required data to be able to enable this payment method.',
          missingInformationBanner: 'Your Stripe account is missing information and some functionality or payment methods might not work. Please view your stripe account and update the required information.',
          missingInformationBannerSecond: 'Please refresh the page once the missing information is filled out.',
          monthlyPaymentDate: 'Monthly payment date',
          nextDirectDebit: 'Next 3 Direct Debit run dates',
          nextRecurringPayments: 'Next 3 recurring payment run dates',
          paymentSettings: 'Payment settings',
          receiveAutomaticPayments: 'Receive automatic payments',
          receiveOneOffAndAutomaticPayments: 'Receive one-off and automatic recurring payments',
          recurringPayments: 'Recurring Payments',
          sepaDateChanged: 'Single Euro Payments Area payment date changed.',
          startMonthlyDirectDebitRunOn: 'Start monthly Direct Debit run on',
          stripeStatuses: {
            completed: 'Completed',
            enabled: 'Enabled',
            not_onboarded: 'Not onboarded',
            pending: 'Pending',
            rejected: 'Rejected',
            restricted: 'Restricted',
            restricted_soon: 'Restricted soon',
          },
          title: 'Blossom payment gateway',
          viewStripeAccount: 'View stripe account',
        },
        ReferenceCodeGeneration: {
          BannerInfo: {
            text1: 'Any changes will only apply for new children added going forward.',
          },
          Tooltip: {
            text1: 'If checked, then all child reference codes will show the specified prefix too.',
            text2: 'You can set any number based on your preference, eg.: 1001. The next child reference code generated will start from the number specified.',
          },
          codeAutomaticGeneration: 'Code automatic generation',
          codePrefix: 'Code prefix',
          leavePopupMessage: 'You have unsaved changes. Do you want to discard changes or continue editing?',
          nextNumbersInSequenceFrom: 'Next numbers in sequence from',
          noPrefix: 'No prefix',
          randomisedBySystem: 'Randomised by system',
          sequentialNumbers: 'Sequential numbers',
          subtitle: 'Set how the child reference codes are automatically generated when adding new children.',
          title: 'Child reference code generation',
        },
        ReferenceCodes: {
          errorMessage: 'This number is taken. The next available number is: {{ nextNumber }}',
          searchBarPlaceholder: 'Search for child or reference code',
          snackbarMessage: '{{ name }} reference code has been updated.',
        },
        Sessions: {
          Add: {
            Consumables: {
              Form: {
                Chargeable: {
                  label: 'Chargeable',
                  placeholder: 'Chargeable',
                },
                Consumable: {
                  label: 'Consumable',
                  placeholder: 'Consumable',
                },
                Price: {
                  label: 'Price',
                  placeholder: 'Price',
                },
              },
              Options: {
                PerHour: {
                  label: 'Per hour',
                },
                PerSession: {
                  label: 'Per session',
                },
              },
              addButtonLabel: 'Add consumable',
              organizationInheritBanner: 'Sessions created on the organisation level can not have consumables. Please add separate sessions to your nursery, if you want to use consumables.',
              title: 'Consumable linked to this session',
              tooltip: 'Consumable linked to this session',
            },
            Fees: {
              Form: {
                ThreeToFiveYearOld: {
                  label: "3-5 year old's",
                },
                TwoYearOld: {
                  label: "2 year old's",
                },
                Under2s: {
                  label: 'Under 2s',
                },
              },
              addButtonLabel: 'Add fees',
              title: 'Enter session fees',
              tooltip: 'Fees will be calculated based on children\'s ages. When a child turns 2 or 3 years old they will automatically move up an age-band for the following month\'s invoice fees.',
            },
            Form: {
              Banner: {
                label: 'After creating a session, you are unable to edit whether it is an hourly session or not.',
              },
              FinishTime: {
                label: 'Finish time',
              },
              Hourly: {
                label: 'Hourly session',
                tooltip: 'Hourly rates allow you to allocate fees on an hourly basis.',
              },
              SessionName: {
                label: 'Session name',
                placeholder: 'Session name',
              },
              SessionType: {
                Options: {
                  Fixed: {
                    label: 'Fixed session time',
                  },
                  Hourly: {
                    label: 'Flexible hourly session',
                  },
                },
                label: 'Session type',
              },
              StartTime: {
                label: 'Start time',
              },
            },
            addTitle: 'Add a session',
            archivePopupCopy: 'Are you sure you want to archive this session? Please note: this session already allocated to children will not be affected.',
            editTitle: 'Edit a session',
            fundingPopupCopy: 'Are you sure you want to edit these sessions? Please note: any changes will affect uninvoiced sessions. You may also need to reallocate funding.',
            organizationInheritBanner1: 'This session has been created by an organisation member.',
            organizationInheritBanner2: 'Contact your nursery administrator to edit this session.',
            title: 'Add a session',
            unarchivePopupCopy: 'Are you sure you want to unarchive this session? You can archive it again at any time.',
          },
          Edit: {
            title: 'Edit a session',
          },
          InformationMessage: {
            default: 'This is where you can set your sessions for your nursery. Your sessions are listed in table below. Add a new session by tapping the button above.',
            financeAutomation: 'This is where you can set your sessions and fees for your nursery. Your sessions are listed in table below. Add a new session by tapping the button above.',
          },
          Table: {
            Finish: {
              label: 'Finish',
            },
            Hourly: {
              label: 'Hourly',
            },
            Session: {
              label: 'Session',
            },
            Start: {
              label: 'Start',
            },
            ThreeToFiveYearOld: {
              label: "3-5 year old's",
            },
            TwoYearOld: {
              label: "2 year old's",
            },
            Under2s: {
              label: 'Under 2s',
            },
          },
          addButtonLabel: 'Add new session',
          emptyStateText: 'Add your sessions and costs to allocate them to children and parent invoices.',
          title: 'Sessions',
        },
        SessionsV3: {
          Add: {
            Consumables: {
              Form: {
                Chargeable: {
                  label: 'Chargeable',
                  placeholder: 'Chargeable',
                },
                Consumable: {
                  label: 'Consumable',
                  placeholder: 'Consumable',
                },
              },
              Options: {
                PerHour: {
                  label: 'Per hour',
                },
                PerSession: {
                  label: 'Per session',
                },
              },
              addButtonLabel: 'Add consumable',
              organizationInheritBanner: 'Sessions created on the organisation level can not have consumables. Please add separate sessions to your nursery, if you want to use consumables.',
              title: 'Consumable linked to this session',
            },
            Fees: {
              Form: {
                PriceGroups: {
                  label: '{{ startAge }}-{{ endAge }} months',
                  labelEnd: '{{ startAge }}+ months',
                  placeholder: '0',
                },
              },
              addButtonLabel: 'Add fees',
              title: 'Fees',
              tooltip: "Fees will be calculated based on children's ages. When a child turns 2 or 3 years old they will automatically move up an age-band for the following month's invoice fees.",
            },
            Form: {
              Banner: {
                label: 'After creating a session, you are unable to edit whether it is an hourly session or not.',
              },
              FinishTime: {
                label: 'Finish time',
              },
              Hourly: {
                label: 'Hourly session',
                tooltip: 'Hourly rates allow you to allocate fees on an hourly basis.',
              },
              SessionName: {
                label: 'Session name',
                placeholder: 'Session name',
              },
              SessionType: {
                OptionLabels: {
                  fixedSessionTime: 'Fixed session time',
                  flexibleHourlySession: 'Flexible hourly session',
                },
                label: 'Session type',
              },
              StartTime: {
                label: 'Start time',
              },
            },
            addTitle: 'Add a session',
            editTitle: 'Edit a session',
            organizationInheritBanner1: 'This session has been created by an organisation member.',
            organizationInheritBanner2: 'Contact your nursery administrator to edit this session.',
          },
          InformationMessage: {
            default: 'This is where you can set your sessions for your nursery. Your sessions are listed in table below. Add a new session by tapping the button above.',
            financeAutomation: 'This is where you can set your sessions and fees for your nursery. Your sessions are listed in table below. Add a new session by tapping the button above.',
          },
          Table: {
            Finish: {
              label: 'Finish',
            },
            Hourly: {
              label: 'Hourly',
            },
            Session: {
              label: 'Session',
            },
            Start: {
              label: 'Start',
            },
            ThreeToFiveYearOld: {
              label: "3-5 year old's",
            },
            TwoYearOld: {
              label: "2 year old's",
            },
            Under2s: {
              label: 'Under 2s',
            },
          },
          addButtonLabel: 'Add new session',
          archiveEmptyStateText: 'No archived sessions.',
          emptyStateText: 'Add your sessions and costs to allocate them to children and parent invoices.',
          sessionsFor: 'Sessions for {{ name }}',
          title: 'Session',
        },
        subtitle: 'These are the various finance sections to set up.',
        title: 'Finance',
      },
      FormBuilder: {
        agreementSectionEmpty: 'The Agreement section is currently empty. Please fill in the required details before sending the registration form.',
        backToFormBuilder: 'Back to form builder',
        enquiryForm: 'Enquiry form',
        enrollmentDetails: 'Enrolment details',
        fields: {
          agreement: {
            description: 'In this section, you have to provide comprehensive details about: Data Security, Accuracy of Information, Nursery Policies and Procedures, Confirmation and Digital Signature. This information is essential to build trust with parents and ensure them that their data is secure and well-managed. Completing this section is mandatory for the registration form.',
            label: 'Agreement',
          },
          bookingPattern: {
            label: 'Include booking pattern in the registration form',
            tooltip: 'This is for informational purposes only, without the ability for parents to edit.',
          },
          enrollmentDetails: {
            label: 'Include enrolment details in the registration form',
            tooltip: 'For parents to see start date, end date, room to start and key person.',
          },
          numberOfParents: {
            label: 'Maximum guardians user can add',
          },
          termsAndConditions: {
            description1: 'Choose one of the following options to add your Terms & Conditions:',
            description2: 'Provide a URL:',
            description3: 'If your T&C are already hosted online, select this option and paste the URL.',
            description4: 'Enter Text Directly:',
            description5: 'If you prefer to include your T&C directly, select this option and use our text editor to input the text.',
            description6: 'A clickable link will be generated in your final form to display the content.',
            label: 'Terms and Conditions',
            text: 'Text',
            url: 'URL',
            yourUrl: 'Your URL',
          },
        },
        preview: 'Preview',
        registrationForm: 'Registration form',
        success: 'Field settings have been updated successfully',
        termsAndConditionsSectionEmpty: 'Terms and Conditions section is currently empty. Please fill in the required details before sending the registration form.',
        thisFieldIsMandatory: 'This field is mandatory for system operations and cannot be hidden.',
        title: 'Form builder',
      },
      General: {
        LearningTrackingReporting: {
          ShowChildOverViewOnFormativeReports: {
            title: 'Show child overview section on formative reports',
          },
          UseOnlySecureToMarkProgress: {
            subTitle: 'Applies to EYFS 2012, Maltese learning outcomes & Dev matters 2021',
            title: "Only use 'Secure' to mark progress on observation",
          },
          title: 'Learning, tracking & reporting',
        },
        LikesAndComments: {
          AccessToLikesAndComments: {
            title: 'Access to likes and comments',
          },
          EnableLikesAndComments: {
            subtitle: 'Enabling this feature allows child contacts with parental authority and authorised staff members to like and post comments.',
            title: 'Enable likes and comments',
          },
          title: 'Likes and comments',
        },
        Messaging: {
          InstantMessenger: {
            EnableInstantMessenger: {
              subtitle: 'Enabling messaging allows child contacts with parental authority and parent app access to send messages to the nursery.',
              title: 'Enable instant messenger for parents',
            },
            info: 'Enabling messaging allows child contacts with parental authority and parent app access to send messages to the nursery.',
          },
          StaffAssignedToRooms: {
            noStaffAssigned: 'No staff members assigned',
            notFoundAnyRooms: 'This nursery has no rooms',
            staffMembersAssigned: 'Staff members assigned',
            subTitle: 'Staff members added to the room will receive notifications for messages and comments',
            title: 'Staff notifications',
          },
          title: 'Messaging',
        },
        RotaAndOccupancy: {
          EditingStaffRota: {
            Options: {
              PastWeekCanEdited: {
                label: 'Past weeks can be edited',
              },
              PastWeekCannotEdited: {
                label: 'Past weeks cannot be edited',
              },
            },
            title: 'Editing staff rota',
          },
          RoundingRules: {
            text: 'Round staff required decimal number down until {{ value }}',
            title: 'Rounding rules',
          },
          StaffChildRatios: {
            AgeGroups: {
              AgeFrom: {
                placeholder: 'Start age',
              },
              AgeTo: {
                placeholder: 'Finish age',
              },
              label: 'Age groups (months)',
            },
            Ratio: {
              label: 'Ratio',
              placeholder: 'Ratio',
            },
            UsedForExpert: {
              label: 'Use for 1:13 ratio',
              tooltip: 'Blossom allows staff members with the 1:13 qualification to take care of more children from a specific age band.',
            },
            addAgeGroup: 'Add age group',
            title: 'Staff:child ratios',
          },
          StaffRequired: {
            Options: {
              PerAgeGroup: {
                Tooltip: {
                  1: 'This is a cautious calculation that usually leads to a higher number of staff required.',
                  2: 'Calculation steps:',
                  3: '1. Rounds the staff required per age group up.',
                  4: '2. Sums the staff required per age group up at the end.',
                },
                label: 'Round staff required per age group.',
              },
              TotalAtTheEnd: {
                Tooltip: {
                  1: 'This is a calculation that usually leads to a lower number of staff required to save costs.',
                  2: 'Calculation steps:',
                  3: '1. Sums the decimal values for staff required per age group.',
                  4: '2. Rounds the total staff required at the end.',
                },
                label: 'Round total staff required at the end.',
              },
            },
            title: 'Calculation for staff required',
          },
          title: 'Staff rota',
        },
        SharingWithParents: {
          Diary: {
            Automatic: 'Automatic',
            Manual: 'Manual',
            subtitle: 'Choose between <0>Automatic</0>, to send diaries daily when the child is signed in, or <0>Manual</0>, where you will manually send the diary each day.',
            title: 'Diary',
          },
          ShareObservationWithParents: {
            subtitle: 'This will automatically tick the box for sharing with parents when creating new observations.',
            title: 'Share all observations with parents',
          },
          title: 'Sharing with parents',
        },
        aiWritingAssistant: 'AI writing assistant',
        aiWritingAssistantTooltip: 'When enabled there is the option to use AI to quickly enhance your writing, adjust tone and correct spelling and grammar. It can be used when writing observations and diary activities.',
        off: 'Off',
        on: 'On',
        subtitle: 'These are general preferences you may want to specify.',
        title: 'General',
      },
      GettingStarted: {
        Basic: {
          AttendancePeriods: {
            title: 'Attendance periods',
            tooltip: 'Set your attendance periods to determine which dates children can attend your nursery. These periods are also used to calculate invoices.',
          },
          Child: {
            title: 'Add a child',
            tooltip: 'You may have had your children uploaded by Blossom. If so, you will need to fill out all other details. For example, there all about me information, dietary and medical requirements. If you are creating a child from scratch, simply follow the 6 step process.',
          },
          Curriculum: {
            title: 'Select curriculums',
            tooltip: "Select the curriculum you want to use for tracking children's development.",
          },
          Nursery: {
            title: 'Nursery information and opening times',
            tooltip: 'Set your nursery’s open and closing times. This will link to your register.',
          },
          NurseryClosureDates: {
            title: 'Nursery closure dates',
            tooltip: 'Set your nursery closure dates for when your nursery is not open.',
          },
          Parent: {
            title: 'Add a parent',
            tooltip: 'You may have had your children uploaded by Blossom. If so, you will have their contacts uploaded! You may want to add childminders & grandparents too. If you are creating a contact from scratch, you have the ability to search for an existing contact or create a new one!',
          },
          Rooms: {
            title: 'Rooms',
            tooltip: 'Add your Rooms! This will be inclusive of age bands, capacity & staff requirements.',
          },
          Sessions: {
            title: 'Sessions',
            tooltip: 'Add your nursery sessions. These are bespoke for your nursery and can include consumables, price and time differences.',
          },
          Staff: {
            title: 'Add a staff member',
            tooltip: 'Add all of your staff members and decide which access level you would like them to have. Check your permissions guide to help decide what role you would like to set them up as!',
          },
          title: 'Basic setup',
        },
        Finance: {
          Consumables: {
            title: 'Consumables',
            tooltip: 'These can be added to your sessions.',
          },
          Funding: {
            title: 'Funding',
            tooltip: 'You can create your own funding grants for every type of funding! Simply apply to the children once you have set up each funding type.',
          },
          Invoice: {
            title: 'Invoicing settings',
            tooltip: 'This will help to create your billing cycle.',
          },
          InvoiceNumber: {
            title: 'Invoice number sequence',
            tooltip: 'Here you can set up your number sequence for invoices to start from.',
          },
          title: 'Finance set up',
        },
        Operation: {
          AuthorisedDevices: {
            title: 'Authorised devices',
            tooltip: 'We advise someone with a ‘Manager’ approval level to ‘Self Authorise’ all devices prior to the use of Blossom. You can authorise devices remotely by using the Blossom Pin. Please note that on an authorised device, staff do NOT need a pin to log in.',
          },
          ConfirmRoomMove: {
            title: 'Confirm a room move',
            tooltip: 'By confirming room moves, you are finalising when each child will move. They will then appear on the register accordingly. If room moves are not confirmed, they will still create an occupancy forecast but this will be an estimate until room moves confirmed.',
          },
          DefaultRoomMoves: {
            title: 'Default room moves',
            tooltip: 'Here you will choose the parameters to decide when your children move to the next room.',
          },
          title: 'Operations',
        },
        headerTitle1: 'Welcome to Blossom. Let’s get started.',
        headerTitle2: 'Carefully follow the setup steps to begin using Blossom.',
        progressCopy: '{{ width }}% completed',
        title: 'Getting started',
        topTipCopy1: 'Complete the steps from the basic setup and',
        topTipCopy2: 'you’ll be well on your way to becoming efficient.',
        topTipTitle1: 'TOP',
        topTipTitle2: 'TIP',
      },
      Learning: {
        Curriculums: {
          ConfirmModal: {
            1: 'This curriculum will be deactivated.',
            2: 'All curriculum links and data will be hidden across the child development features.',
          },
          setAsDefault: 'Set as default',
          subtitle: 'Activate the curriculums to use at your nursery.',
          title: 'Curriculums',
        },
        General: {
          title: 'General learning settings',
        },
        Title: {
          long: 'Learning, tracking & reporting',
          short: 'Learning',
        },
      },
      LeaveTypes: {
        Child: {
          Add: {
            subtitle: 'Create an absence reason to use when adding child absences.',
            title: 'Add child absence reason',
          },
          Edit: {
            Modal: {
              archive: 'This absence reason will be archived. Past absences with this reason will not be affected.',
              unarchive: 'This absence reason will be unarchived.',
            },
            banner: 'Editing the absence reason will update all past entries of this type.',
            title: 'Edit child absence reason',
          },
          Table: {
            tooltip: 'This absence reason is pre-built in the system.',
          },
          absenceReason: 'Absence reason',
          title: 'Child absence reasons',
        },
        Staff: {
          Add: {
            archiveModalTitle: 'This will archive this leave type. Previously allocated leave will not be affected.',
            fieldTitle: 'Leave type name',
            subtitle: 'Create a leave type to use when adding staff leave.',
            title: 'Create leave type',
          },
          Edit: {
            subtitle: 'Edit this leave type to use when adding staff leave.',
            title: 'Edit leave type',
            tooltip: 'Editing the leave type name will update all past leave entries of this type',
          },
          addLeaveTypeButtonTitle: 'Add leave type',
          allLeaveTypes: 'All leave types',
          emptyStateTitle: 'Add leave type here to show up on leave types',
          subtitle: 'Set up your leave types to select when adding leave for staff members.',
          tableTitle: 'Leave type',
          title: 'Staff leave types',
          tooltip: 'This leave type is pre-built in the system.',
        },
        title: 'Leave types',
      },
      ManagementBlossomboard: {
        editionDescription: 'Enable, disable and organise your widgets below.',
        errorMinNumberOfWidgets: 'The minimum number of enabled widgets is {{ minNumberOfWidgets }}.',
        pageDescription: 'This is where you can add and organise widgets for the dashboard.',
        title: 'Customisable Blossomboard',
        widgetSettingsSuccessfullyUpdated: 'Widget settings has been successfully updated',
        yourWidgets: 'Your widgets',
      },
      ManagementPaymentTypes: {
        archiveModalTitle: 'Are you sure you want to archive this payment method?',
        emptyStateTitle: 'Add payment method here to show up on payment methods',
        paymentMethodPreBuilt: 'This payment method is pre-built into the system',
        routeAddTitle: 'Add a payment method',
        routeEditTitle: 'Edit a payment method',
        tableTitle: 'Payment method',
        title: 'Payment methods',
        unarchiveModalTitle: 'Are you sure you want to unarchive this payment method?',
      },
      ManagementRouting: {
        Blossomboard: 'Blossomboard',
        Finance: {
          Funding: {
            add: 'Create funding type',
            edit: 'Edit funding type',
            view: 'Funding type',
          },
        },
      },
      ManagementSessions: {
        Add: {
          Consumables: {
            Form: {
              Chargeable: {
                label: 'Chargeable',
                placeholder: 'Chargeable',
              },
              Consumable: {
                label: 'Consumable',
                placeholder: 'Consumable',
              },
              Price: {
                label: 'Price',
                placeholder: 'Price',
              },
            },
            Options: {
              PerHour: {
                label: 'Per hour',
              },
              PerSession: {
                label: 'Per session',
              },
            },
            addButtonLabel: 'Add consumable',
            organizationInheritBanner: 'Sessions created on the organisation level can not have consumables. Please add separate sessions to your nursery, if you want to use consumables.',
            title: 'Consumable linked to this session',
            tooltip: 'Consumable linked to this session',
          },
          Fees: {
            Form: {
              ThreeToFiveYearOld: {
                label: "3-5 year old's",
              },
              TwoYearOld: {
                label: "2 year old's",
              },
              Under2s: {
                label: 'Under 2s',
              },
            },
            addButtonLabel: 'Add fees',
            title: 'Enter session fees',
            tooltip: "Fees will be calculated based on children's ages. When a child turns 2 or 3 years old they will automatically move up an age-band for the following month's invoice fees.",
          },
          Form: {
            Banner: {
              label: 'After creating a session, you are unable to edit whether it is an hourly session or not.',
            },
            FinishTime: {
              label: 'Finish time',
            },
            Hourly: {
              label: 'Hourly session',
              tooltip: 'Hourly rates allow you to allocate fees on an hourly basis.',
            },
            SessionName: {
              label: 'Session name',
              placeholder: 'Session name',
            },
            SessionType: {
              Options: {
                Fixed: {
                  label: 'Fixed session time',
                },
                Hourly: {
                  label: 'Flexible hourly session',
                },
              },
              label: 'Session type',
            },
            StartTime: {
              label: 'Start time',
            },
          },
          addTitle: 'Add a session',
          editTitle: 'Edit a session',
          organizationInheritBanner1: 'This session has been created by an organisation member.',
          organizationInheritBanner2: 'Contact your nursery administrator to edit this session.',
        },
        InformationMessage: {
          default: 'This is where you can set your sessions for your nursery. Your sessions are listed in table below. Add a new session by tapping the button above.',
          financeAutomation: 'This is where you can set your sessions and fees for your nursery. Your sessions are listed in table below. Add a new session by tapping the button above.',
        },
        Table: {
          Finish: {
            label: 'Finish',
          },
          Hourly: {
            label: 'Hourly',
          },
          Session: {
            label: 'Session',
          },
          Start: {
            label: 'Start',
          },
          ThreeToFiveYearOld: {
            label: "3-5 year old's",
          },
          TwoYearOld: {
            label: "2 year old's",
          },
          Under2s: {
            label: 'Under 2s',
          },
        },
        addButtonLabel: 'Add new session',
        emptyStateText: 'Add your sessions and costs to allocate them to children and parent invoices.',
        title: 'Session',
      },
      ManagementSessionsV3: {
        Add: {
          Consumables: {
            Form: {
              Chargeable: {
                label: 'Chargeable',
                placeholder: 'Chargeable',
              },
              Consumable: {
                label: 'Consumable',
                placeholder: 'Consumable',
              },
            },
            Options: {
              PerHour: {
                label: 'Per hour',
              },
              PerSession: {
                label: 'Per session',
              },
            },
            addButtonLabel: 'Add consumable',
            organizationInheritBanner: 'Sessions created on the organisation level can not have consumables. Please add separate sessions to your nursery, if you want to use consumables.',
            title: 'Consumable linked to this session',
          },
          Fees: {
            Form: {
              PriceGroups: {
                label: '{{ startAge }}-{{ endAge }} months',
              },
            },
            addButtonLabel: 'Add fees',
            title: 'Fees',
            tooltip: "Fees will be calculated based on children's ages. When a child turns 2 or 3 years old they will automatically move up an age-band for the following month's invoice fees.",
          },
          Form: {
            Banner: {
              label: 'After creating a session, you are unable to edit whether it is an hourly session or not.',
            },
            FinishTime: {
              label: 'Finish time',
            },
            Hourly: {
              label: 'Hourly session',
              tooltip: 'Hourly rates allow you to allocate fees on an hourly basis.',
            },
            SessionName: {
              label: 'Session name',
              placeholder: 'Session name',
            },
            SessionType: {
              OptionLabels: {
                fixedSessionTime: 'Fixed session time',
                flexibleHourlySession: 'Flexible hourly session',
              },
              label: 'Session type',
            },
            StartTime: {
              label: 'Start time',
            },
          },
          addTitle: 'Add a session',
          editTitle: 'Edit a session',
          organizationInheritBanner1: 'This session has been created by an organisation member.',
          organizationInheritBanner2: 'Contact your nursery administrator to edit this session.',
        },
      },
      ManagementWrapper: {
        Blossomboard: 'Blossomboard',
      },
      MenuItems: {
        Meals: {
          Form: {
            archiveBanner: 'You cannot edit meal items that are already used on a diary entry. You can create a new one if needed.',
            banner: 'You cannot edit meal items that are already used on a diary entry. You can archive it and create a new one if needed.',
            itemLabel: 'Meal item name',
            title: '{{ action }} meal item',
          },
          Modal: {
            pastEntries: 'Past diary entries will not be affected.',
            plural: 'All selected meal items will be {{ action }}.',
            singular: '"{{ name }}" will be {{ action }}.',
          },
          Pagination: {
            plural: 'meal items',
            singular: 'meal item',
          },
          Snackbar: {
            plural: 'Selected meal items have been {{ action }}.',
            singular: 'Meal item has been {{ action }}.',
          },
          addItemLabel: 'Add meal item',
          archiveItem: '{{ action }} item',
          emptyState: 'No meal items.',
          menuItemTitle: 'Meal item',
          searchBarPlaceholder: 'Search meal items',
          subtitle: 'Set up your meal items that are selectable on the diary.',
          title: 'Meal items',
        },
        Snacks: {
          Form: {
            archiveBanner: 'You cannot edit meal items that are already used on a diary entry. You can create a new one if needed.',
            banner: 'You cannot edit snack items that are already used on a diary entry. You can archive it and create a new one if needed.',
            itemLabel: 'Snack item name',
            title: '{{ action }} snack item',
          },
          Modal: {
            pastEntries: 'Past diary entries will not be affected.',
            plural: 'All selected snack items will be {{ action }}.',
            singular: '"{{ name }}" will be {{ action }}.',
          },
          Pagination: {
            plural: 'snack items',
            singular: 'snack item',
          },
          Snackbar: {
            plural: 'Selected snack items have been {{ action }}.',
            singular: 'Snack item has been {{ action }}.',
          },
          addItemLabel: 'Add snack item',
          archiveItem: '{{ action }} item',
          emptyState: 'No snack items.',
          menuItemTitle: 'Snack item',
          searchBarPlaceholder: 'Search snack items',
          subtitle: 'Set up your snack items that are selectable on the diary.',
          title: 'Snack items',
        },
        title: 'Menu items',
      },
      Nursery: {
        address: 'Address',
        applyToAll: 'Apply to all',
        emailAddress: 'Email address',
        logo: 'Logo',
        montessori: 'Montessori',
        nurseryInfo: 'Nursery info',
        nurseryName: 'Nursery name',
        ofstedIdentifier: 'Ofsted identifier',
        openingTimes: 'Opening times',
        postcode: 'Postcode',
        primaryManager: 'Manager (System Owner)',
        startWeekFrom: 'Start week from',
        subdomain: 'Subdomain',
        subtitle: 'This is where you can modify your nursery information.',
        telephone: 'Telephone',
        title: 'Nursery information',
        totalOpenWeeks: 'Total open weeks',
        totalOpenWeeksTooltip: 'This is used as a base to calculate FTE on starters and leavers reports.',
      },
      ParentApp: {
        BookingAbsence: {
          AllowParentBookingAbsence: {
            title: 'Allow parents to log absences and holidays through the parent app',
          },
          title: "Children's absences and holidays",
        },
        ParentCommunication: {
          title: 'Parent communication',
        },
        RequestableExtraSessions: {
          Banner: {
            ReDisabled: {
              1: 'Existing requests will still be listed in the',
              2: 'Parent Inbox',
              3: 'and can be responded to.',
              4: 'You may want to inform parents that they will no longer be able to request from the Parent App.',
            },
            reEnabled: 'You may want to review all settings. The same settings as when previously enabled have been applied.',
          },
          CorePreferences: {
            Approval: {
              automatic: 'Automatic approval',
              label: 'Approval',
              manual: 'Manual approval',
            },
            MaxAdvanceRequests: {
              label: 'Max. advance requests',
              tooltip: 'This restricts the days the parent can select when requesting extra sessions.',
            },
            MinRequestNotice: {
              label: 'Min. request notice',
              tooltip: 'This restricts the days the parent can select when requesting extra sessions.',
            },
            ParentsCanOnly: {
              label: 'Prevent parents from requesting sessions that require additional staff members.',
              tooltip: "Parents will only see sessions they can request if they don't need additional staff in the room.",
            },
            additionalPreferences: 'Additional preferences',
            banner: 'Parents can only request available extra sessions. Below you can select additional restrictions.',
            includeChildrensHolidays: "Include children's holidays and sick leave as available spaces.",
            requestableSessions: 'Requestable sessions',
            title: 'Core preferences',
          },
          UnavailableTimes: {
            ClosureDates: {
              text: 'Nursery closure dates are already excluded from available times for all children.',
              title: 'Nursery closure dates',
            },
            Exceptional: {
              addTime: 'Add time',
              deleteModal: 'This entry for unavailable times will be deleted.',
              emptyState: 'No exceptional unavailable times added.',
              title: 'Exceptional unavailable times',
              tooltip: 'Block availability for parents on a specific one-off date and time. If you block out a specific time, the full session that overlaps with it will not be requestable by parents.',
            },
            Regular: {
              DaysOfWeekAbbr: {
                friday: 'FRI',
                monday: 'MON',
                saturday: 'SAT',
                sunday: 'SUN',
                thursday: 'THU',
                tuesday: 'TUE',
                wednesday: 'WED',
              },
              setTimes: 'Set times',
              title: 'Regular unavailable times',
              tooltip: 'Block availability for parents on a regular time on a day every week. If you block out a specific time, the full session that overlaps with it will not be requestable by parents.',
            },
            TermTimes: {
              text: 'If you are a term time only nursery, parents cannot request extra sessions outside of term time if you either add nursery closure dates or exceptional unavailable times below.',
              title: 'Term times',
            },
            title: 'Unavailable times',
          },
          subtitle: 'Request extra sessions from the Parent App.',
          title: 'Requestable extra sessions',
        },
        Title: {
          long: 'Parent app settings',
          short: 'Parent app',
        },
      },
      Security: {
        AccessLogsList: {
          attemptToLoginWithEmail: 'Attempt to login with email address {{ email }}',
          log: 'Log',
          loggedInOnAnUnapprovedDevice: '{{ name }} ({{ email }}) logged in on an unapproved device.',
          loggedInOnDevice: "{{ name }} ({{ email }}) logged in on device '{{ device }}'.",
          nothingFound: 'There are no access logs recorded at present.',
          title: 'Access logs',
        },
        AuthorisedDevices: {
          AddDevice: {
            approveThisDevice: 'Approve this device',
            generatePin: 'Generate pin',
            title: 'Authorise new device',
          },
          AuthorisedDevicesList: {
            authorisationMethod: 'Authorisation method',
            authorisedBy: 'Authorised by',
            dateAuthorised: 'Date authorised',
            device: 'device',
            deviceName: 'Device name',
            devices: 'devices',
            nothingFound: 'There are no devices registered at present.',
            pinAuthorised: 'Pin authorised',
            pinExpired: 'Pin expired',
            searchDevice: 'Search authorised devices',
            selfAuthorised: 'Self authorised',
            thisDevice: 'this device',
            title: 'Authorised devices',
            validPin: 'Valid pin',
          },
          DeviceDetails: {
            title: 'Device details',
          },
          EditDevice: {
            authorisationPin: 'Authorisation pin',
            dateAuthorised: 'Date authorised',
            generateANewPin: 'Generate a new pin for this device',
            pinAuthorised: 'Pin authorised',
            pinExpired: 'Pin expired',
            pinNotAuthorised: 'Pin not authorised',
            regeneratePin: 'Regenerate pin',
            removeDevice: 'Are you sure you want to remove this device?',
            staffMember: 'Staff member',
            title: 'Edit device',
            updateDevice: 'Update device',
          },
          components: {
            PinBox: {
              backToDevices: 'Back to devices',
              pin: 'Pin',
              pinExpireDate: 'This pin will expire <0>{{ date }}</0> and has been emailed to the staff member.',
            },
          },
          global: {
            description: 'Please add a device name and staff member responsible for authorising this device',
            name: 'Device name',
            staffMember: 'Staff member',
          },
        },
        GeneralSecuritySettings: {
          SessionTimeout: {
            label: 'Session timeout',
            minutesLabel: 'Timeout after',
            timeoutLabelPrefix: 'After',
            timeoutLabelSuffix: 'minutes of inactivity',
            tooltip: 'This setting controls how long you can be inactive on the platform before you are automatically logged out.',
          },
          organizationInheritBanner: 'The security settings have been set by an organisation user and cannot be edited by the nursery.',
          title: 'General security settings',
        },
        PractitionerChildAccess: {
          AccessViewOptions: {
            allChildren: 'All children',
            onlyOwnRooms: 'View children only for their own rooms',
          },
          Rooms: {
            subtitle: 'Practitioner can only see children that are in rooms they assigned to.',
          },
          subtitle: 'Practitioner, Senior practitioner and Room leader view access',
          title: 'Practitioner child access',
        },
        title: 'Security',
      },
      Sessions: {
        Add: {
          archivePopupCopy: 'Are you sure you want to archive this session? Please note: this session already allocated to children will not be affected.',
          fundingPopupCopy: 'Are you sure you want to edit these sessions? Please note: any changes will affect uninvoiced sessions. You may also need to reallocate funding.',
          title: 'Add a session',
          unarchivePopupCopy: 'Are you sure you want to unarchive this session? You can archive it again at any time.',
        },
        Edit: {
          title: 'Edit a session',
        },
        title: 'Sessions',
      },
      TermDates: {
        Add: {
          addAnotherHolidayDateText: 'Add another holiday',
          addAnotherTermDateText: 'Add another term',
          addTermsDatesSectionSubtitle: 'This is where you set your term dates for your nursery per academic year.',
          addTermsDatesSectionTitle: 'Add your term dates',
          chargeableTooltipText: 'Making the holiday chargeable is only relevant if invoicing is based on ‘actuals’. When invoicing is based on ‘averages’, you are able to select the number of weeks to average over',
          deletePopupCopy: 'Are you sure you want to remove this term?',
          editTermsDatesSectionTitle: 'Edit your term dates',
          fundingPopupCopy: 'Are you sure you want to edit the nursery closure dates? Please note: any changes will affect uninvoiced sessions. You may also need to reallocate funding.',
          nurseryDatesSectionTitle: 'Nursery closure dates',
          termsDatesSectionTitle: 'Term dates',
        },
        title: 'Term dates',
      },
    },
    Messaging: {
      Channel: {
        newMessage: 'New message',
        you: 'You',
      },
      ChannelList: {
        notFound: 'No active conversations.',
        search: 'Search for children',
        title: 'Messenger',
      },
      MessagingList: {
        archivedChild: 'You cannot send messages because {{ child }} is an archived child.',
        cannotAccess: 'You cannot send messages anymore because the nursery only allows people with parental authority to be messaged directly.',
        channelLeave: 'You have left this conversation. You only see conversation history.',
        components: {
          ChildSelect: {
            noContacts: 'No contacts with messaging access',
            notFound: 'No matches found',
            placeholder: 'Type the child’s name',
          },
          Editor: {
            maxCharactersError: 'Your message is {{ characters }} characters too long.',
            placeholder: 'Type a message',
          },
          Message: {
            edited: 'edited',
            retry: 'Retry',
          },
        },
        confirmLeaveConversation: 'Are you sure you want to leave this conversation?',
        conversationMembers: 'Conversation members',
        infoAboutMessages: 'Messages to this chat are stored and can be seen by all nursery staff and contacts for {{ firstName }} with parental authority.',
        leaveConversation: 'Leave conversation',
        messagingDisabled: 'You cannot send messages because the messaging feature was deactivated by the nursery.',
        noParentAccess: 'There are no contacts for {{ child }} with parental responsibility and parent app access to message directly.',
      },
    },
    Modals: {
      AccessToLikesAndCommentsModal: {
        noStaffMembersFound: 'No staff members found',
        search: 'Search for a colleague',
        staffMember: 'Staff member',
        title: 'Assign staff members',
      },
      ActivitiesStatistics: {
        title: 'Activities statistics',
      },
      AddNewRecipientsModal: {
        subTitle: 'Select the contacts you would like to share this newsletter with.',
        title: 'Add new recipients',
      },
      ChildLeave: {
        ConfirmOverride: {
          dateRangeText: 'Adding leave from {{ startDate }} to {{ endDate }} will override any overlapping dates for the following entries:',
          override: 'Override',
          singleDateText: 'Adding leave on {{ date }} will override the overlapping date for the following entries:',
          title: 'Override existing leave?',
        },
        dateRangeValidation: 'Maximum date range cannot exceed 60 days.',
        title: '{{ action }} child leave',
      },
      ChildrenExport: {
        allChildren: 'All children',
        archivedChildren: 'Include archived children',
        sendTo: 'Send to',
        startDateBetween: 'Start date between',
        title: 'Export Children',
      },
      DailyDiary: {
        Pagination: {
          plural: 'daily diaries',
          singular: 'daily diary',
        },
        TableHeaders: {
          child: 'Child',
          lastSentOn: 'Last sent on',
          send: 'Send',
          sent: 'Sent',
        },
        approveDiary: 'Approve diary',
        emptyState: 'There are no daily diaries matching your criteria.',
        infoAutomatic: 'The diary is scheduled to be sent automatically. <0>Go to settings</0>',
        infoManual: 'You can schedule diaries to be sent automatically. <0>Go to settings</0>',
        successAlert: 'Daily diaries have been successfully sent.',
      },
      DailyDiaryRecordModal: {
        addActivity: 'Add activity record',
        addBottle: 'Add bottle feed record',
        addChildren: 'Add children',
        addNappy: 'Add nappy change record',
        addSleep: 'Add sleep record',
        addToiletTraining: 'Add toilet training',
        confirmDiscard: 'Do you want to discard this activity?',
      },
      DepositRefund: {
        addRefundToNextInvoice: 'Add refund to next invoice',
        markAsRefunded: 'Mark as refunded',
        refund: 'Refund',
        title: 'Refund deposit',
      },
      DepositsExport: {
        Form: {
          Dates: {
            label: 'Deposit/Refund date',
          },
          Membership: {
            label: 'Send to',
            placeholder: 'Select manager',
          },
          Status: {
            label: 'Deposit status',
            placeholder: 'Deposit status',
          },
        },
        StatusOptions: {
          all: 'All deposits and refunds',
          held: 'Held deposits',
        },
        title: 'Export deposits',
      },
      DietaryReportExportModal: {
        ReportType: {
          Options: {
            allergiesAndDietary: 'Allergies and dietary preferences',
            allergiesOnly: 'Allergies only',
          },
          label: 'Report type',
        },
        ShowAllOrSomeChildren: {
          Options: {
            showAll: 'Show all children',
            showSome: 'Only children with allergies or preferences',
          },
          label: 'Show',
        },
        title: 'Export your dietary preferences & allergies report',
      },
      DownloadRegister: {
        additionalRowsLabel: 'Include additional rows for an additional sign in/out',
        allSessions: 'All sessions',
        banner: 'Please note: if you are downloading the register record for a past date that includes multiple sign ins, the extra rows will be included by default.',
        dateRangeLabel: 'Select the date range for which you would like to download the register',
        includeCommentsLabel: 'Include comments',
        roomsLabel: 'Select all or individual rooms',
        sessionsLabel: 'Select all or a specific session',
        title: 'Download register',
      },
      EditRoomMoveModal: {
        AssignNewKeyPerson: {
          label: 'Assign new key person',
          placeholder: 'Assign new key person',
        },
        MoveFrom: {
          label: 'Move from',
        },
        MoveOn: {
          label: 'Move on',
          placeholder: 'Move on',
        },
        MoveTo: {
          label: 'Move to',
          placeholder: 'Move to',
        },
        Ratio: {
          label: 'Ratio',
        },
        TypicalAge: {
          label: 'Typical age',
          value: '{{ startAge }}-{{ endAge }} months',
        },
        errorMessage: 'Editing room move date will unconfirm and recalculate future confirmed room moves',
        title: 'Edit room moves',
      },
      EmergencyContacts: {
        parentalResponsibility: 'Parental responsibility',
        selectAllOrSpecific: 'Select all or a group of children',
        title: 'Export your emergency contacts list',
      },
      Enquiry: {
        EnrolChild: {
          enrolLabel: 'Enrol',
          enrolMessage: 'Are you sure you want to enrol {{ childName }}?',
          markAsEnrolledLabel: 'Mark as enrolled',
          title: 'Enrol child',
        },
        Export: {
          Enquiry: {
            Form: {
              Dates: {
                label: 'Enquiry dates',
              },
              Membership: {
                label: 'Send to',
                placeholder: 'Manager or nursery admin',
              },
            },
            title: 'Export enquiry',
          },
          Viewing: {
            Form: {
              Dates: {
                label: 'Viewing dates',
              },
              Membership: {
                label: 'Send to',
                placeholder: 'Manager or nursery admin',
              },
            },
            title: 'Export viewings',
          },
        },
        StatusChange: {
          Form: {
            AdditionalInformation: {
              label: 'Additional information',
              placeholder: 'Enter details',
            },
            LostReason: {
              label: 'Lost reason',
              placeholder: 'Select reason',
            },
          },
          lostEnquiryTitle: 'Lost enquiry',
          lostReasonSettingLinkMessage1: 'Manage lost reason in',
          lostReasonSettingLinkMessage2: 'nursery settings',
          noSpaceTitle: 'No space available',
          saveLabel: 'Save status',
        },
        StatusTypeMigration: {
          Form: {
            SourceLabel: {
              subtitle: 'Before migration',
              title: 'Current stage',
            },
            TargetLabel: {
              subtitle: 'After migration',
              title: 'New stage',
            },
            TargetStatusType: {
              placeholder: 'Status type',
            },
            sameTypeValidationMessage: 'Current and new stage value cannot be same.',
          },
          confirmationTitle: 'Confirmation',
          previewSubtitle: '{{ enquiriesCount }} {{ enquiryLabel }} will be migrated.',
          subtitle1: "After deleting the enquiry stage '{{ statusName }}'",
          subtitle2Plural: 'need to be migrated to a new stage.',
          subtitle2Singular: 'needs to be migrated to a new stage.',
          title: 'Migrate',
        },
        ViewingEdit: {
          title: 'Edit viewing',
        },
      },
      EnterStaffRegisterModal: {
        dontShowLabel: "Don't show me again",
        subtitle: 'Click ‘Continue’ to access register mode. This will then log you out of the main nursery app for security reasons. ',
        title: 'Enter staff register',
      },
      ExportReportModal: {
        KeyWorker: {
          checkboxLabel: 'All Key Person',
          label: 'Download list for',
          placeholder: 'Select key person',
        },
        User: {
          Label: {
            export: 'Select a manager or administrator to send the export to',
            pdf: 'Select a manager or administrator to send the PDFs to',
          },
          placeholder: 'Select a manager',
        },
        alert: 'Your report has been sent to {{email}}. This may take a few minutes.',
        selectRoom: 'Select all or individual rooms',
      },
      FileDetailsModal: {
        enterDescription: 'Enter description',
        fileName: 'File name',
        title: 'Edit file details',
      },
      FormativeReportsExportModal: {
        Form: {
          SelectFormativeReports: {
            label: 'Select all or individual formative reports to download',
            placeholder: 'Select formative reports',
          },
          note: 'NOTE: Only approved Formative Reports can be generated into PDFs.',
          validationMessage: 'At least one of the fields should be selected.',
        },
        alert: 'Your formative reports have been sent to your manager’s email address. This may take a few minutes.',
        title: 'Export formative reports',
      },
      FormativeReportsSendModal: {
        Date: {
          from: 'Date from',
          to: 'Date to',
        },
        Form: {
          SendToParents: {
            label: 'Send to parents',
            placeholder: 'Select parents',
          },
          SendToStaff: {
            label: 'Send to staff',
            placeholder: 'Select staff',
          },
          validationMessage: 'Please select at least one parent or staff member.',
        },
        alert: 'Your formative report has been sent.',
        title: 'Send formative report',
      },
      FrameworkSelectProgressModal: {
        by: 'by',
        deleteModalContent: 'This professional opinion will be deleted.',
        deleteModalContent2: 'Previously created formative reports will not be affected.',
        lastProgress: 'Last progress',
        markAsNone: 'Progress was marked as none',
        nextSteps: 'Next steps',
        none: 'None',
        observation: 'Observation',
        observationSummary: 'Observation summary',
        professionalOpinion: 'Professional Opinion',
        progressHistory: 'Progress history',
        stayOnPage: 'Stay on page',
        title: 'Select progress',
        viewModalContent: 'You will be navigated away from this page and lose your progress.',
      },
      FundingLoopExportModal: {
        Form: {
          FundingPeriod: {
            label: 'Funding period',
          },
          HeadCountWeek: {
            error: 'Head count week should be within the funding period',
            label: 'Head count week',
          },
          title: 'Funding loop export',
        },
        generalExport: 'General export',
      },
      Help: {
        HelpDesk: {
          SupportPersonNames: {
            abbie: 'Abbie',
            adam: 'Adam',
            hannah: 'Hannah',
            natalie: 'Natalie',
            priya: 'Priya',
            rebecca: 'Rebecca',
          },
          buttonLabel: 'Log a ticket',
          description1: 'For any assistance with Blossom, please call customer care on ',
          description2: 'Or fill in a short form and we’ll get in touch.',
          title: 'Contact support',
        },
        KnowledgeBase: {
          buttonLabel: 'Help centre',
          description: 'Search the online Help Centre for answers through helpful guides and tutorials.',
          imageAlt: 'Help centre',
          title: 'Online support',
        },
        title: 'Need help from our customer care team?',
      },
      InjurySignature: {
        ChildPreview: {
          title: '{{ type }} report',
        },
        Info: {
          contentText1: 'Hand the device over to the signing person',
          contentText2: 'He or she can read and sign the record',
          contentText3: 'Take back your device',
          subtitle: 'In three simple steps',
          title: 'Add signature',
        },
        Signature: {
          addingSignature: 'Adding signature',
          confirmationText: 'I hereby confirm that I read and acknowledge the ',
          returnToSignatures: 'Return to signatures',
          signHere: 'Sign here',
          successSubtitle: 'Please hand the device back to the nursery staff',
          successTitle: 'Successfully signed',
        },
      },
      Invoice: {
        AddInvoiceItemModal: {
          Form: {
            Amount: {
              label: 'Amount',
              placeholder: '0.00',
            },
            Cost: {
              label: 'Cost',
              placeholder: '0.00',
            },
            Deposit: {
              label: 'Select deposit',
              placeholder: 'Select deposit',
            },
            Description: {
              label: 'Description',
              placeholder: 'eg. AM session',
            },
            Discount: {
              label: 'Select discount',
              placeholder: 'Select discount',
            },
            ExtraItem: {
              label: 'Extra item',
              placeholder: 'Extra item',
            },
            ExtraSession: {
              label: 'Extra session',
              placeholder: 'Extra session',
            },
            Funding: {
              label: 'Funding',
              placeholder: 'Funding',
            },
            HourlyRate: {
              label: 'Hourly rate',
              placeholder: '0.00',
            },
            ItemType: {
              label: 'Item type',
              placeholder: 'Item type',
            },
            Quantity: {
              label: 'Quantity',
              placeholder: 'e.g. 5',
            },
            RefundDeposit: {
              label: 'Select refund deposit',
              placeholder: 'Select refund deposit',
            },
            TotalCost: {
              label: 'Total cost',
              placeholder: '0.00',
            },
            TotalHours: {
              label: 'Total hours',
              placeholder: 'e.g. 5',
            },
            deductionInfoText: 'The value entered will be deducted from the invoice total.',
            feesItemBanner: 'The value entered will be deducted from the invoice total.',
            fundingTotalErrorText: 'The total value here can not exceed the amount of funding remaining.',
            negativeCostErrorText: 'The invoice item value can not be negative.',
          },
          addTitle: 'Add invoice item',
          deleteItemPopupText: 'Are you sure you want to delete this line item?',
          editTitle: 'Edit invoice item',
          readOnlyBannerText: 'Auto generated line items can not be edited.',
        },
      },
      InvoiceDetailPreview: {
        subTitle: 'Options {{ number }}: {{ label }}',
        title: 'Preview invoice detail display',
      },
      InvoicesExport: {
        Customers: {
          label: 'Customers',
        },
        DateRange: {
          error: 'Maximum allowed date range is 365 days.',
          label: 'Date range',
        },
        Export: {
          creditNotes: 'Credit notes',
          error: 'You must choose at least one of the options.',
          invoices: 'Invoices',
        },
        ExportFor: {
          general: 'General (all data)',
          label: 'Export for',
          quickbooks: 'Quickbooks',
          sage: 'Sage50',
          xero: 'Xero',
        },
        LinkToInvoicesSettings: {
          link: 'accounting settings',
          text: 'Please ensure you have set up your',
        },
        SendTo: {
          label: 'Send to',
        },
        sendExport: 'Send export',
        title: 'Export invoices',
      },
      MediaTagModal: {
        Media: 'Media',
        PreviewIsNotAvailable: 'Preview is not available',
        PreviewUnavailable: {
          textPart1: 'Preview currently unavailable for this video format',
          textPart2: 'Please tag children and continue.',
          textPart3: 'You can review the video later when it is uploaded and converted.',
        },
        fileName: 'File name',
        secondTitle: 'File details',
        tagChildren: 'Tag children',
        title: 'Tagging children',
      },
      Messaging: {
        AssignStaffMembers: {
          description: 'Select the staff members to be available for messages in this room.',
          noStaffMembersFound: 'No staff members found',
          search: 'Search for a colleague',
          staffMember: 'Staff member',
          title: 'Assign staff members',
        },
        ConversationMembers: {
          childContacts: 'Child contacts',
          childContactsDetails: 'Only contacts with parental responsibility.',
          searchPlaceholder: 'Search for child contacts or staff members',
          staffMembers: 'Staff members',
          staffMembersDetails: 'Anyone assigned to the room of this child or who joined individually.',
          title: 'Conversation members',
        },
      },
      PaymentsImport: {
        Duplicates: {
          Duplicates: {
            text: 'The following payments seem to be duplicates in your CSV file. Please return to your CSV file and validate the potential duplicate payments. If these are not duplicates you can proceed to import anyway.',
            title: 'There may be duplicate entries in your CSV',
          },
          ExistingPayments: {
            text: 'The following payments seem to already exist in Blossom. Please return to your CSV file and validate the potential duplicate payments. If these are not duplicates you can proceed to import anyway.',
            title: 'Payments may already exist in Blossom',
          },
          importAnyway: 'Continue importing',
          subtitle: 'We did not import your file yet. Please check the potential duplicate entries in your CSV file below and either update and reimport or import the file anyway.',
          title: 'Check duplicate payments',
        },
        Errors: {
          AmountNegative: {
            text: 'Please go back to your CSV file and make sure the amounts are not negative values.',
            title: 'Amount cannot be negative',
          },
          AmountWrongFormat: {
            text: 'Blossom assumes amounts in the format using commas as separators: e.g. 1,000.00 Please go back to your CSV file and make sure the data is in the correct format.',
            title: 'Amount is in the wrong format',
          },
          BillPayer: {
            text: 'We cannot send the payment receipts for these payments. Please add a billing contact for the associated children on the platform.',
            title: 'Bill payer missing',
          },
          ChildReference: {
            text: 'These children do not exist in Blossom. Please return to your CSV file and match the child reference code with the correct ones in Blossom or add a new child into Blossom.',
            title: 'Child reference invalid',
          },
          FieldNames: {
            amount: 'Amount',
            childRef: 'Child reference code',
            paymentDate: 'Payment date',
            paymentType: 'Payment method',
            sendReceipt: 'Send receipt',
          },
          MandatoryField: {
            text: 'These mandatory fields are missing on the following payments. Please go back to your CSV and add them.',
            title: 'Mandatory field missing',
          },
          PaymentDate: {
            text: 'Blossom assumes English UK dates in the following format: dd.mm.yyyy, dd-mm-yyyy or dd/mm/yyyy e.g. 31.12.2020. Please go back to your CSV file and make sure the dates are in the correct format.',
            title: 'Payment date is in the wrong format',
          },
          PaymentMethod: {
            text: 'These payment methods do not exist in Blossom. Please return to your CSV file and match the payment methods with the correct ones in Blossom.',
            title: 'Payment method invalid',
          },
          TableHeaders: {
            text: 'The CSV does not have the correct table headers to be imported into Blossom. Please make sure to use our CSV template.',
            title: 'Table headers do not match',
          },
          returnToCsvUpload: 'Return to CSV upload',
          subtitle: 'We could not import your file. Please fix the errors below in your CSV file and try again.',
          title: 'Something is wrong',
        },
        Intro: {
          Section1: {
            link: 'Download example CSV',
            text: 'Start by downloading our payments csv template. This file has the correct column headings Blossom needs to import your payments.',
            title: 'Download the Blossom CSV template',
          },
          Section2: {
            Important: {
              List: {
                1: 'Do not change the column headings provided in the Blossom template. These need to be unchanged for the import to work.',
                2: 'Dates are assumed to be in English UK format (dd.mm.yyyy, dd-mm-yyyy or dd/mm/yyyy). Example: 25/12/2020 or 25.12.2020',
                3: 'Your CSV file cannot have more than 1000 rows.',
              },
              title: 'Important',
            },
            Text: {
              1: 'To add payments into Blossom they need to have the same fields Blossom uses on the platform.',
              2: 'Your CSV must contain all mandatory fields marked with an *.',
            },
            title: 'Add your payments to the CSV template',
          },
          Section3: {
            button: 'Select CSV file',
            noFile: 'No file selected',
            text: 'The file must be a CSV file (comma separated values). Your file name should end with .csv.',
            title: 'Upload your CSV',
          },
        },
        backToPayments: 'Back to payments',
        onSuccessMessage: '{{ number }} payments successfully imported.',
        row: 'Row',
        title: 'Import payments',
      },
      PremiumPlanModal: {
        additionalFeatures: 'Additional features',
        contact: {
          emailLabel: 'Email',
          phoneLabel: 'Phone',
          subtitle: 'Contact our Customer Support Team',
          title: 'Upgrade now',
        },
        finance: {
          bespokeInvoiceSettings: 'Bespoke Invoice Settings',
          detailedAccounts: 'Maintain Detailed Accounts',
          fundingGrants: 'Create Funding Grants',
          generateAndSendInvoices: 'Generate & Send Invoices',
          monitorTransactions: 'Monitor Transactions and Payments',
          reportingAndForecasting: 'Financial Reporting and Forecasting',
          title: 'Finance',
        },
        headerTitle: 'Upgrade your package',
        occupancy: {
          ftePercentages: 'FTE Percentages',
          nurserySpacesPlanner: 'Nursery Spaces Planner',
          occupancyForecast: 'Monthly & Yearly Occupancy Forecasts',
          roomMoves: 'Automatic & Suggested Room Moves',
          title: 'Occupancy',
          weeklyOccupancyReports: 'Weekly Occupancy Reports',
        },
        title: 'learning+ Business',
      },
      RequestableExtraSessions: {
        ExceptionalUnavailableTimes: {
          Title: {
            add: 'Add exceptional unavailable times',
            edit: 'Edit exceptional unavailable times',
          },
          teachingRoom: 'Teaching room',
        },
        RegularUnavailableTimes: {
          title: 'Set regular unavailable times',
        },
      },
      RequestedExtraSession: {
        ConfirmDeclineRequest: {
          Text: {
            1: "Declining an approved extra session will archive it in the child's booking pattern.",
            2: 'If it is already invoiced you may need to reissue the invoice.',
          },
          confirmButtonLabel: 'Decline request',
        },
        Label: {
          approve: 'Approval note',
          decline: 'Decline reason',
          willBeSentToParent: 'will be sent to the parent',
        },
        SubmitButtonLabel: {
          approve: 'Approve',
          decline: 'Decline',
        },
        Title: {
          approve: 'Approve request',
          decline: 'Decline request',
        },
        approved: 'approved',
        declined: 'declined',
        snackbarMessage: 'Extra session request has been {{ action }}.',
      },
      SendDraftInvoice: {
        DebitOrCredit: {
          creditTextPart1: '{{ childFirstName }} has credit of ',
          debitTextPart1: '{{ childFirstName }} has debit of ',
          textPart2: ' that will be applied to the invoice.',
          title: 'Debit or credit',
        },
        InvoiceNumber: {
          title: 'Invoice number',
        },
        Recipients: {
          subtitle: 'The invoice will be sent to all invoice recipients for {{ childFirstName }}.',
          title: 'Recipients',
        },
        confirmAndSendButtonLabel: 'Confirm and send',
        title: 'Send draft invoice',
      },
      SessionSetImpact: {
        addEditAcnHeader: 'Do you want to save your session set and start the correction process?',
        addEditHeader: 'Do you want to save your session set?',
        childImpactOnBannerText: '{{ childFirstName }}’s funding and invoices may be impacted.',
        deleteAcnHeader: 'Do you want to delete your session set and start the correction process?',
        deleteHeader: 'Do you want to delete your session set?',
        impactOnInvoiceAndFundingText: 'Impact on funding and invoices',
        impactOnSessionSetsText: 'Impact on session sets',
        impactedSessionSetsText: 'Impacted session sets',
        moreSessionSetItemsText: '+{{ count }} more impacted session sets',
        sessionSetBannerText: 'This session set will override or remove the overlapping periods of the session sets below.',
        sessionSetLabel: 'Session set',
        title: 'Session set impact',
      },
      SessionTimeout: {
        logoutButtonLabel: 'Log out',
        remainingTimeSuffix: 'seconds',
        stayLoggedInButtonLabel: 'Stay logged in',
        timeoutMessage: 'For security reasons you will be logged out in',
        title: 'Session timeout',
      },
      Staff: {
        Export: {
          Breakdown: {
            Payroll: {
              actuals: 'Payroll (actuals)',
              planned: 'Payroll (planned)',
            },
            daily: 'Daily',
            grouped: 'Grouped',
            label: 'Breakdown',
            total: 'Total',
            weekly: 'Weekly',
          },
          FileFormat: {
            label: 'File format',
          },
          ReportDates: {
            DayRange: {
              end: 'End day',
              label: 'Date range',
              start: 'Start day',
            },
            MonthRange: {
              end: 'End month',
              label: 'Month range',
              start: 'Start month',
            },
            WeekRange: {
              end: 'End week',
              label: 'Week range',
              start: 'Start week',
            },
            label: 'Report dates',
          },
          ReportType: {
            general: 'All leaves',
            label: 'Report type',
            sickness: 'Sickness report',
          },
          SendTo: {
            label: 'Send to',
            placeholder: 'Manager or nursery admin',
          },
          Shifts: {
            allStaffShifts: 'All staff shifts',
            individualShifts: 'Individual shifts to each staff member',
            label: 'Send',
          },
          StaffMember: {
            label: 'Staff member',
            placeholder: 'Staff member',
          },
          allStaffMembers: 'all staff members',
        },
        Leave: {
          Add: {
            addRow: 'Add row',
            copyToAll: 'Copy to all',
            editTitle: 'Edit leave',
            title: 'Add leave',
          },
          Export: {
            title: 'Export leaves',
          },
        },
        Rota: {
          ChildrenExpected: {
            childrenExpectedIn: 'Children expected in',
            notFound: 'There are no children expected in.',
            staffExpectedIn: 'Staff expected in',
            staffRequired: 'Staff required',
            title: 'Children expected',
          },
          Export: {
            title: 'Export weekly rota',
          },
        },
        Shift: {
          actual: 'Actual',
          actualHours: 'Actual hours',
          actualTypes: {
            break: 'Break',
            signin: 'Work',
          },
          addRow: 'Add row',
          assignShift: 'Assign shift',
          break: 'Break',
          breakBanner: 'Break allowance for {{ from }} to {{ to }} hours worked: {{ time }} min.',
          breakEndDate: 'Break end date',
          cannotAddToFutureDays: 'Cannot add time for future days.',
          changeLog: 'Change log',
          contractChanges: 'Contract changes',
          contractType: 'Contract type',
          copyToAll: 'Copy to all',
          copyToOtherWeeks: 'Copy to others weeks',
          editTitle: 'Edit weekly shifts',
          end: 'End',
          holiday: 'holiday',
          noContract: 'No contract',
          noShiftsPlanned: 'No shifts planned',
          noTimeLogged: 'No time logged',
          ongoing: 'Ongoing',
          planned: 'Planned',
          plannedHours: 'Planned hours',
          reason: 'Edit reason',
          reasonPlaceholder: 'Why did you make the change?',
          reasonSubtitle: 'only visible in change log',
          sickLeave: 'sick leave',
          staffChildRatio: 'Ratio',
          staffChildRatioTooltip: 'This staff member can take responsibility for more children of certain age groups (specified in the nursery settings). Setting a ratio between 1:8 and 1:13 will impact the default staff-child ratio and the staff required for this time and room.',
          title: 'Assign weekly shifts',
          workEndDate: 'Work end date',
          workTotal: 'Work total',
          workingHours: 'Working hours',
        },
        ShiftCopy: {
          copyRange: 'You will copy shifts from:',
          currentlyAllocatedHours: 'Currently allocated hours',
          replacedWarning: 'All working and break times of selected weeks will be replaced by the week being copied.',
          subtitle: 'Please select the weeks you want to copy this rota week.',
          title: 'Copy shifts to other weeks',
        },
        Worklog: {
          AddTime: {
            addActivity: 'Add activity',
            times: 'Times',
            title: 'Add time',
          },
          ChangeLog: {
            Type: {
              Break: {
                clockInTime: 'Break clock in time',
                clockOutTime: 'Break clock out time',
                location: 'Break location',
                time: 'Break time',
              },
              Work: {
                clockInTime: 'Work clock in time',
                clockOutTime: 'Work clock out time',
                location: 'Work location',
                time: 'Work time',
              },
              activityRemoved: 'Activity removed',
            },
            emptyState: 'There are no changes for this day.',
            newValue: 'New value',
            oldValue: 'Old value',
            removed: 'REMOVED',
            title: 'Workday change log',
          },
          EndTime: {
            Validation: {
              isEndTimeGreaterThanStartTime: 'Sign out time and date should not be before sign in time and date.',
            },
            end: 'End',
            endTime: 'End time',
            title: 'End activity',
          },
          Export: {
            title: 'Export staff worklog',
          },
        },
        global: {
          allStaffMembers: 'All nursery staff members',
        },
      },
      StripeDisconnectConditions: {
        cannotDisconnectStripe: 'Cannot disconnect Stripe',
        conditions: {
          allCapabilitiesDisabled: 'Turn off all payment methods so no new transactions can be added.',
          allPaymentsProcessed: 'All payments must be fully processed.',
          allPayoutsProcessed: 'All payout amounts must be paid out.',
        },
        toDisconnectYourStripeAccount: 'To disconnect your stripe account',
      },
      UnsavedChanges: {
        content: 'You have unsaved changes in this form. Would you like to save your progress before leaving?',
        leaveWithoutSaving: 'Leave without saving',
        title: 'Unsaved changes',
      },
      global: {
        selectAManagerOrAdministrator: 'Select a manager or administrator to send the export to',
      },
    },
    Newsletters: {
      Add: {
        attachmentsLabel: 'Attachments',
        authorLabel: 'Author',
        contentLabel: 'Content',
        contentPlaceholder: 'Content',
        createTitle: 'Create post',
        discardPost: 'Do you want to discard this post?',
        editTitle: 'Edit post',
        fromLabel: 'From',
        postTitleLabel: 'Post title',
        postTitlePlaceholder: 'Title',
        publishButtonLabel: 'Publish',
        saveAsDraftButtonLabel: 'Save as draft',
        toGroupLabel: 'To Group',
        toIndividualsLabel: 'To individuals',
        tooltipFirstLine: 'Max file size: 25MB.',
        tooltipSecondLine: 'Supported file types: PDF, JPEG, PNG, CSV, DOC, DOCX, DOT, PPT, PPTX, XLS, XLSX.',
        uploadImageButtonLabel: 'Attach files',
      },
      Common: {
        groupDropdownPlaceholder: 'Search for rooms or groups',
        individualDropdownPlaceholder: 'Search for specific children, contacts or staff',
        toLabel: 'To:',
      },
      Constants: {
        AllOptions: {
          allChildrenLabel: 'All children',
          allStaffLabel: 'All staff',
        },
        ErrorList: {
          individuals: 'At least one values should be selected from groups and individuals',
          title: 'This field is required.',
        },
        TypeOptions: {
          allPostLabel: 'All post',
          draftLabel: 'Draft',
          publishedLabel: 'Published',
        },
        allGroupOptionsHeader: 'ALL GROUPS',
        childrenOptionsHeader: 'CHILDREN',
        roomsOptionsHeader: 'ROOMS',
        staffOptionsHeader: 'STAFF',
      },
      List: {
        deleteText1: 'Are you sure you want to remove this post?',
        deleteText2: 'Please note: this action cannot be undone.',
        editPostButtonText: 'Continue draft',
        emptyStateText: 'There are no posts.',
        loadingItemText: 'Loading...',
        previewPostButtonText: 'View post',
        searchPlaceholder: 'Search news title',
        sharedWithPlaceholder: 'Shared with',
        title: 'News',
        typePlaceholder: 'Type options',
      },
      Preview: {
        Overview: {
          attachedMediaTitle: 'Attached media',
          authorLabel: 'Author ',
          fromLabel: 'From: ',
          published: 'Published',
          title: 'Overview',
        },
        Recipients: {
          Table: {
            lastSent: 'Last sent',
            recipients: 'Recipients ({{ total }})',
          },
          addButtonLabel: 'Add new recipients',
          noAccessToParentApp: 'No access to parent app and posts via email.',
          noReceiveViaEmail: 'This contact does not wish to receive news via email. You can update preferences in the contact profile.',
          resendLabel: 'Resend email',
          searchBarPlaceholder: 'Search by name',
          sentLabel: 'Sent',
          title: 'Recipients',
        },
        deleteRecipientText: 'This will remove the post for {{ name }}. If they are a parent, it will be removed from the parent app.',
        deleteText: 'This will remove the post from the parent app for all recipients. Please note: this action cannot be undone.',
        recipientAddSuccessText: 'Recipients successfully added.',
        titleSecond: '(Draft)',
      },
      Routing: {
        Add: {
          title: 'Newsletter add',
        },
        Edit: {
          title: 'Newsletter Edit',
        },
        Preview: {
          title: 'Newsletter Preview',
        },
        title: 'Newsletters',
      },
    },
    Notifications: {
      Action: {
        Clear: {
          label: 'Clear',
        },
        MarkAsRead: {
          label: 'Mark as read',
        },
        MarkAsUnRead: {
          label: 'Mark as unread',
        },
      },
      Actions: {
        ClearAll: {
          label: 'Clear all',
        },
        MarkAllAsRead: {
          label: 'Mark all as read',
        },
        MarkAllAsUnRead: {
          label: 'Mark all as unread',
        },
      },
      List: {
        Tabs: {
          All: {
            label: 'All',
          },
          Reminders: {
            label: 'Reminders',
          },
          Tasks: {
            label: 'Tasks',
          },
          Updates: {
            label: 'Updates',
          },
        },
        emptyState: 'You currently have no notifications',
        title: 'Notifications',
      },
    },
    Nurseries: {
      Add: {
        NurseryDetails: {
          Form: {
            Address: {
              label: 'Address',
            },
            Email: {
              label: 'Email',
            },
            Logo: {
              label: 'Logo',
              text1: 'Image should be on a transparent or white background.',
              text2: 'Square shaped images are optimal across the platform.',
            },
            Montessori: {
              label: 'Montessori',
            },
            Name: {
              error: 'This nursery name is already registered.',
              label: 'Name of nursery',
              placeholder: 'My Nursery',
            },
            Ofsted: {
              label: 'Ofsted identifier',
            },
            Postcode: {
              label: 'Postcode',
            },
            Subdomain: {
              error: 'This subdomain is already registered.',
              label: 'Nursery domain',
              placeholder: 'my-nursery',
            },
            Telephone: {
              label: 'Telephone',
            },
          },
          title: 'Nursery details',
        },
        PrimaryContactDetails: {
          Form: {
            ManagersDropdown: {
              placeholder: 'Select manager',
              text1: 'Select an existing staff member as the manager for this setting',
              text2: 'or add a nursery manager for this setting',
            },
          },
          title: 'Manager details',
        },
        RegistrationNotice: {
          text1: 'Registering this nursery will send',
          text2: 'the administrator',
          text3: 'an email to',
          text4: 'detailing the next steps they need to take to register and start using Blossom Educational.',
        },
        Review: {
          title: 'Review',
        },
        ServiceError: {
          text1: 'Something went wrong whilst communicating with the server, please try again later.',
          text2: 'There are one or more errors with form, please correct the errors and try again.',
        },
        title: 'Add a new nursery',
      },
      Edit: {
        Disable: {
          confirm: 'Are you sure you want to disable this nursery?',
          label: 'Disable nursery',
        },
        Enable: {
          confirm: 'Are you sure you want to enable this nursery?',
          label: 'Enable nursery',
        },
        Framework: {
          addSuccessMessage: 'Framework added successfully',
          removedSuccessMessage: 'Framework removed successfully',
        },
        OnFeatureFlagChange: {
          successMessage: '{{ label }} feature flag has been {{ action }}.',
        },
        Update: {
          label: 'Update nursery',
        },
        financeV3FlagIsDeactivated: 'Nursery belongs to the organisation. If you want to change the F3 feature flag you have to do it from the organisation level.',
        financeV3IsEnabled: 'You can not turn the FF of when the Finance V3 FF is turned on',
        mobilePaymentBACSFlagIsActivated: 'You can not turn the FF off when the nursery has active BACS Direct Debit Mandates',
        mobilePaymentBACSisTurnedOn: 'You can not turn the FF off when BACS DD is turned on in the nursery settings.',
        mobilePaymentFlagIsDeactivated: 'You must as first activate mobile payments feature flag.',
        stripeIsConnected: 'You can not turn the FF off when the nursery is connected to Stripe.',
        title: 'Edit nursery',
      },
      FeatureFlags: {
        ai: 'AI writing assistant',
        autoCreditNoting: 'Auto credit noting',
        cohortTracker: 'Cohort Tracker',
        deposits: 'Deposits',
        diaryAutoSend: 'Diary auto send',
        enquiries: 'Enquiries',
        filesManagement: 'Files management',
        finance: 'Finance',
        financeAutomation: 'Finance Automation',
        financeV3: 'Finance V3',
        forecastingEnabled: 'Forecasting',
        halfTermEnabled: 'Half Term',
        hasParentAppAccess: 'Parent App Access',
        injuriesEnabled: 'Injuries',
        likesAndComments: 'Likes and comments',
        ljReports: 'LJ Reports',
        medicationForms: 'Medication forms',
        messaging: 'Messaging',
        mobilePayments: 'Mobile payments',
        mobilePaymentsBacs: 'Mobile payments BACS Direct Debit',
        newsletterEnabled: 'Newsletter',
        occupancyEnabled: 'Occupancy',
        offlineMode: 'Register offline mode',
        paUpdateChild: 'Parent app update child',
        parentBookingChileLeaves: 'Parent booking child leaves',
        pdfAutomation: 'PDF Automation',
        practitionerChildAccess: 'Practitioner child access',
        registrationForms: 'Registration forms',
        requestingExtraSessions: 'Requesting extra sessions',
        staffRegister: 'Staff register',
        userflow: 'Userflow',
        videoEnabled: 'Video enabled',
      },
      FeesSection: {
        addCustomFee: 'Add custom fee',
        cap: 'Fixed fee',
        customFees: 'Custom fees',
        defaultFees: 'Default fees',
        deleteFee: 'Do you want to delete this fee?',
        maxAmount: 'Max amount',
        minAmount: 'Min amount',
        newFeeWasCreated: 'New custom fee has been successfully added',
        newFeeWasRemoved: 'Custom fee has been successfully removed',
        notFoundCustomFees: 'The  custom fees have not been set for this nursery',
        notFoundDefaultFees: 'The default fees have not been set',
        paymentType: 'Payment type',
        paymentTypes: {
          AMEX: 'AMEX',
          BACS: 'BACS',
          EUROPEAN: 'European',
          NON_EUROPEAN: 'Non european',
        },
        percentage: 'Percentage',
        updateFeeSuccess: 'Fee item has been successfully updated',
      },
      List: {
        EmptyState: {
          text1: 'There are no nurseries at present.',
          text2: 'Nurseries could not be retrieved at this time, please try again later.',
        },
        FeatureFlag: {
          placeholder: 'Feature flag',
        },
        NurseriesType: {
          placeholder: 'Nurseries type',
        },
        SearchBar: {
          placeholder: 'Search nurseries',
        },
        TableHeaders: {
          activeChildren: 'Active children ({{ month }})',
          children: 'Children',
          manager: 'Manager',
          nursery: 'Nursery',
          staff: 'Staff',
        },
        manageThisNursery: 'Manage this nursery',
      },
      OpenPeriod: {
        allYearRound: 'All year round',
        termTime: 'Term time',
      },
      Preview: {
        country: 'Country',
        currency: 'Currency',
        ofstedId: 'Ofsted identifier',
        organisation: 'Organisation',
        primaryManager: 'Manager (System Owner)',
        timezone: 'Timezone',
        title: 'Nursery details',
        viewSetting: 'View setting',
      },
      noPermissionToEdit: 'You do not have permission to edit this nursery.',
      title: 'Nurseries',
    },
    NurseryFiles: {
      title: 'Nursery files',
    },
    Occupancy: {
      Dashboard: {
        OccupancyPlanner: {
          description: 'This report provides gives you a planner of available spaces at the nursery.',
          title: 'Occupancy planner',
        },
        Report: {
          description: 'This report gives you a view of occupancy at the nursery on a weekly, monthly and yearly basis.',
          title: 'Occupancy Report',
        },
        subtitle: 'This is where you see an overview of occupancy and manage room moves for children.',
      },
      ReportGenerator: {
        OccupancyPlanner: {
          breadcrumbTitle: 'Occupancy planner',
        },
        Report: {
          breadcrumbTitle: 'Generate occupancy report',
        },
      },
    },
    Organisations: {
      Add: {
        FinanceV3FF: {
          activateAlertMessage: 'Activating F3',
          deactivateAlertMessage: 'Deactivating F3',
          deactivateConfirmButton: 'Deactivate F3',
          deactivateMessage: 'Are you sure you want to turn off finance 3? You will loose all bookings and invoices that were done while F3 was active.',
          errorMessage: 'Something went wrong, Please contact development team',
        },
        Form: {
          addNursery: 'Add nursery',
          country: 'Country',
          currency: 'Currency',
          currencyCannotBeChanged: 'Currency cannot be changed once any of your sites have transactions or are connected to the Blossom Payment Gateway',
          currencyCannotBeChangedIndividualNursery: 'Currency cannot be changed once you make your first transaction or connect the Blossom Payment Gateway.',
          independentNursery: 'Independent nursery',
          logo: 'Logo',
          name: 'Name',
          numberOfNurseries: 'Number of nurseries',
          nurseryHaveToOperateInTheSameCountry: 'Nurseries have to operate in the same country and with the same currency as the organisation they belong to. Create a separate organisation to run nurseries in another country',
          organisation: 'Organisation',
          subdomain: 'Subdomain',
          timezone: 'Timezone',
        },
        title: 'Create organisation',
      },
      Edit: {
        Disable: {
          confirm: 'Are you sure you want to disable this organisation?',
          label: 'Disable organisation',
        },
        Enable: {
          confirm: 'Are you sure you want to enable this organisation?',
          label: 'Enable organisation',
        },
        OnFeatureFlagChange: {
          successMessage: '{{ label }} feature flag has been {{ action }}.',
        },
        Update: {
          label: 'Update organisation',
        },
        title: 'Edit organisation',
      },
      GlobalNumberSettings: {
        AcrossOrganization: {
          label: 'Across organisation',
          tooltip: 'Invoice, receipt and credit note numbers are applied sequentially across the organisation.',
        },
        SeparatelyForEachNursery: {
          label: 'Separately for each nursery',
          tooltip: 'Invoice, receipt and credit note numbers are applied sequentially at an individual nursery level.',
        },
      },
      GlobalSettings: {
        ApplyCustomizable: {
          label: 'Yes - apply organization invoice settings to all nurseries but each nursery can customise settings',
        },
        ApplyNonCustomizable: {
          label: 'Yes - apply organization invoice settings to all nurseries which cannot be customised per nursery',
        },
        DoNotApply: {
          label: 'No - set settings for each nursery separately',
        },
      },
      List: {
        AddOrganisationButton: {
          label: 'Organisation',
        },
        EmptyState: {
          text1: 'There are no organisations at present.',
          text2: 'Organisations could not be retrieved at this time, please try again later.',
        },
        FeatureFlagsDropdown: {
          placeholder: 'Feature flag',
        },
        OrganisationsSearchBar: {
          placeholder: 'Search organisations',
        },
        TableHeaders: {
          domain: 'Domain',
          numberOfNurseries: 'Number of nurseries',
          organisation: 'Organisation',
        },
        manageThisOrganisation: 'Manage this organisation',
      },
      Preview: {
        title: 'Organisation details',
      },
      title: 'Organisations',
    },
    Organization: {
      Children: {
        TableHeaders: {
          childReference: 'Child reference',
          children: 'Children',
          nursery: 'Nursery',
        },
        searchPlaceholder: 'Search children',
        title: 'Children',
      },
      NurseryRota: {
        Nursery: {
          rotaButtonLabel: 'View rota',
          staffAttendanceButtonLabel: 'View staff attendance',
          staffMember: '{{ staffMembers }} staff members',
        },
        TableHeaders: {
          bank: 'Bank staff hours',
          breaks: 'Breaks',
          leave: 'Leave',
          overstaffed: 'Overstaffed',
          permanent: 'Permanent staff hours',
          understaffed: 'Understaffed',
        },
        breadcrumbTitle: 'Staff rotas',
        holiday: 'Holiday',
        sickLeave: 'Sick leave',
        withoutContractCopy: 'Working hours without contracts',
      },
      Reports: {
        AnnualRevenue: {
          description: 'This report provides an overview of total income including fees and funding from all of your sites.',
          reportTitle: 'This report provides a 12 month overview of total invoiced and projected income.',
          sendPopupTitle: 'Send your annual revenue report',
          title: 'Group annual revenue report',
        },
        Components: {
          Breakdown: {
            percentage: 'Percentage',
            placeholder: 'Breakdown',
            totals: 'Totals',
          },
        },
        Forecasting: {
          description: 'This report provides a monthly overview of future fees forecasted over a selected year.',
          sendPopupTitle: 'Send your forecasting report',
          title: 'Forecasting',
        },
        GroupRevenue: {
          dateTypeFilterPlaceholder: 'Date type',
          description: 'This report provides an overview of revenue across your sites.',
          nurseriesFilterPlaceholder: 'All sites',
          reportSubTitle: 'This report provides an overview of your total income across your sites (Total invoiced amounts plus funding income)',
          title: 'Group revenue report',
        },
        subtitle: 'This is where you can generate and download reports to obtain an overview of your business.',
        title: 'Reports',
      },
    },
    Parent: {
      HomeObservations: {
        AddFromHomeObservation: {
          title: 'Make observation',
        },
        HomeObservationsDetails: {
          title: 'Preview',
        },
        title: 'Home Observations',
      },
      RequestedSessions: {
        Details: {
          Actions: {
            approve: 'Approve',
            decline: 'Decline',
          },
          Banner: {
            archivedChild: 'This child has been archived.',
            archivedExtraSession: "This extra session has been archived in the child's booking pattern.",
            archivedRoom: 'This extra session is in an archived room.',
            archivedSession: 'This session has been archived in the nursery settings.',
            availabilityStaffRequirementsChanged: 'Your response was not submitted as the availability or staff requirements changed. Please review and respond again.',
            sessionDetailsChanged: 'The session details have changed in the nursery settings after it was requested.',
          },
          Label: {
            availability: 'Availability',
            cost: 'Cost',
            dateTime: 'Date & time',
            nurseryResponses: 'Nursery responses (sent to parent)',
            requestNote: 'Request note from contact',
            requestedBy: 'Requested by',
            room: 'Room',
            session: 'Session',
            staffMembers: '+{{ number }} staff members',
            staffRequired: 'Additional staff required',
            status: 'Status',
          },
          Response: {
            note: 'Note',
            reason: 'Reason',
          },
          StaffRequired: {
            zero: '0 additional staff required',
          },
          requested: 'requested',
          subtitle: 'Request details are from the time of the response.',
          title: 'Requested extra session',
          viewInChildProfile: 'View in child profile',
        },
        List: {
          columns: {
            availability: 'Availability',
            child: 'Child',
            cost: 'Cost',
            date: 'Date',
            requestDateTime: 'Request date & time',
            requestedBy: 'Requested by',
            session: 'Session',
            staffRequired: 'Staff required',
            status: 'Status',
          },
          emptyState: 'No requested extra sessions',
          filters: {
            sessions: {
              title: 'All sessions',
            },
            status: {
              approved: 'Approved',
              declined: 'Declined',
              pending: 'Pending',
              title: 'All statuses',
              total: 'Total',
            },
          },
          staffTooltip: {
            additionalStaffRequired: 'Additional staff required',
            staffMembers: '+{{ number }} staff members',
          },
          subtitle: 'Extra sessions requested by parents',
          timeResponse: 'At the time of response',
          title: 'Sessions Requested',
        },
      },
      Submenu: {
        homeObservations: 'Home Observations',
        requestedSessions: 'Sessions Requested',
      },
      title: 'Parent Inbox',
    },
    Register: {
      DropdownOptions: {
        DeleteAbsence: {
          label: 'Delete absence',
        },
        DeleteHoliday: {
          label: 'Delete holiday',
        },
        StaffLog: {
          label: 'Staff log',
        },
        TimeIn: {
          label: 'Add time in',
        },
      },
      Form: {
        AbsenceDate: {
          label: 'Absence date',
        },
        AbsenceType: {
          placeholder: 'Select absence type',
        },
        AbsencesReason: {
          label: 'Absence reason',
        },
        Comments: {
          label: 'Comments',
          placeholder: 'Write a comment',
        },
        HolidayDate: {
          label: 'Holiday date',
        },
      },
      Modal: {
        AbsenceBanner: {
          range: '{{ childFirstName }} was absent from {{ startDate }} to {{ endDate }}',
          single: '{{ childFirstName }} was absent on {{ date }}',
        },
        HolidayBanner: {
          range: '{{ childFirstName }} was on holiday from {{ startDate }} to {{ endDate }}',
          single: '{{ childFirstName }} was on holiday on {{ date }}',
        },
      },
      dateRangeValidation: 'The end date of this holiday cannot be before the start date',
      futureDateTimeInTooltip: 'Children cannot be timed in on future dates.',
      futureDateTimeOutTooltip: 'Children cannot be timed out on future dates.',
      searchPlaceholder: 'Search child or reference number',
      youCanNotAddSessionWhenOffline: 'You can not add extra sessions when offline',
      youCanNotDownloadTheRegisterWhenOffline: 'You can not download the register when offline',
    },
    RegistrationForm: {
      addAnotherParentGuardian: 'Add another parent/guardian',
      afterSent: 'Registration form has been successfully submitted.',
      afterSentDescription: 'Your registration form has been successfully submitted. A copy has been sent to your email for your records.',
      bookingPatternInfo: 'The following details are shown for reference. Any questions can still be discussed after submitting the form.',
      completed: 'Registration form link is no longer valid',
      completedDescription: 'We\'re sorry, but the registration form link you tried to access is no longer valid',
      drawYourSignature: 'Draw your signature',
      fields: {
        additionalNote: 'Additional note',
        address: 'Address',
        agreement: 'Agreement',
        allergies: 'Allergies',
        allergiesDetails: 'Allergies details',
        anyAdditionalDetails: 'any additional details',
        attendsOtherSetting: 'Attends another setting?',
        attendsOtherSettingPlaceholder: 'Does your child attend another setting?',
        bookingPattern: {
          datePeriod: 'Date period',
          discount: 'Discount',
          funds: 'Funding',
          noSessions: 'No sessions',
          preview: 'Date and attendance period',
          session: 'Session',
          title: 'Booking pattern',
          week: 'Week {{ weekNumber }}',
          weeklyTotal: 'Weekly total',
        },
        books: 'Books',
        booksPlaceholder: 'Favourite Books',
        canBePhotographed: 'Permission to share media with the child\'s family on Blossom',
        canBeTaggedInGroupPhotos: 'Permission to share media with the other children\'s families on Blossom',
        canConsumeFoodWithNutTraces: 'Has permission to consume food with nut traces',
        canGoToExternalOutgoings: 'Has permission to go on external outings',
        canReceiveMedicine: 'Has permission to have medicine administered (e.g. Calpol)',
        canTakeTheBus: 'Has permission to take a bus',
        closedSocialMediaPhotoSharingPermitted: 'Permission to share on closed social media channels',
        dailyRoutine: 'Daily routine',
        dailyRoutinePlaceholder: 'What is your child\'s normal routine?',
        dateOfBirth: 'Date of birth',
        dietaryPreference: 'Dietary preference',
        dietaryPreferencePlaceholder: 'Select dietary preference',
        displayName: 'Display name',
        drinkingFrom: 'Drinks from',
        email: 'Email address',
        englishAsAdditionalLanguage: 'English as additional language (EAL)',
        enrollmentDetails: 'Enrolment details',
        ethnicity: 'Ethnicity',
        facePaint: 'Has permission to have face painted',
        firstName: 'First name',
        food: 'Food',
        foodPlaceholder: 'Favourite Foods',
        fundingCode: 'Funding code',
        fussyEater: 'Fussy eater',
        gender: 'Gender',
        genderPlaceholder: 'Select gender',
        hasPermissionToBeTakenToAHospital: 'Has permission to be taken to a hospital',
        hasPermissionToHaveAdhesiveDressingsApplied: 'Has permission to have adhesive dressings applied',
        interests: 'Interests',
        isChildOfServingArmedForcesPersonnel: 'Child of serving armed forces personnel',
        languageAtHome: 'Language at home',
        languageAtHomePlaceholder: 'Select language',
        languageSkills: 'Language skills',
        languageSkillsPlaceholder: 'Do they have a lot of language? How much are they using words to engage? e.g. babbling, using a few words, using simple sentences, etc.',
        medicalInformation: 'Medical information',
        medicalInformationPlaceholder: 'Child\'s medical information, medication, etc',
        middleNames: 'Middle name',
        mobile: 'Mobile',
        nappyCream: 'Has permission to have nappy cream applied',
        occupation: 'Occupation',
        otherMarketingMaterialPhotoSharingPermitted: 'Permission to use child media as marketing material',
        parentsMaritalStatus: 'Parents\' marital status',
        parentsMaritalStatusPlaceholder: 'Select parents\' marital status',
        physicalSkills: 'Physical skills',
        physicalSkillsPlaceholder: 'What are their physical skills? Can they crawl, walk, run & jump?',
        positionInFamily: 'Position in family',
        postcode: 'Post code',
        profilePhoto: 'Profile photo',
        referenceCode: 'Reference code',
        relation: 'Relation',
        relationPlaceholder: 'Relation to child',
        religion: 'Religion',
        siblings: 'Siblings',
        sleepsDuringTheDay: 'Sleeps during the day',
        socialMediaPhotoSharingPermitted: 'Permission to share on open social media channels',
        socialSkills: 'Social skills',
        socialSkillsPlaceholder: 'How are they with other children and/or family members? Do they interact with others? Do they like sharing their things?',
        specialEducationalNeeds: 'Special educational needs (SEND)',
        sunCream: 'Has permission to have sun cream applied',
        surname: 'Surname',
        taxFreeChildcareCode: 'Tax Free Childcare code / reference',
        telephone: 'Phone number',
        termsAndConditions: 'Terms & conditions',
        title: 'Title',
        toileting: 'Toileting',
        toys: 'Toys',
        toysPlaceholder: 'Favourite Toys',
        useOnSiteMediaPermitted: 'Permission to use media on-site',
        workTelephone: 'Work number',
      },
      groups: {
        development: 'Development',
        familyInformation: 'Family information',
        generalDetails: 'General details',
        likesDislikes: 'Likes & dislikes',
        medicalDetails: 'Medical details',
        permissions: 'Permissions',
      },
      linkExpired: 'Registration form link has expired',
      linkExpiredDescription: 'We\'re sorry, but the registration link you tried to access has expired.',
      linkExpiredDescription2: 'To proceed, please contact your nursery and request a new link to continue the registration process.',
      mainCarerEmail: 'The email address cannot be changed as it is linked to the existing system contact. Please contact the nursery to update this information.',
      noChanges: 'No changes were made to the registration form',
      parentGuardian: 'Parent/Guardian',
      removeCarer: 'Are you sure you want to delete this contact?',
      roomToStart: 'Room to start',
      savedAsDraft: 'Registration form has been saved as a draft.',
      sections: {
        agreement: 'Agreement',
        bookingPattern: 'Booking pattern',
        childInformation: 'Child information',
        parentInformation: 'Parent information',
        termsAndConditions: 'Terms & conditions',
      },
      signature: 'Signature',
      subGroups: {
        address: 'Address',
        bookingPattern: 'Booking pattern',
        contactInformation: 'Contact information',
        diet: 'Diet',
        enrollmentDetails: 'Enrolment details',
        health: 'Health',
        media: 'Media',
        numberOfParents: 'Number of parents',
        permissions: 'Permissions',
        play: 'Play',
        routine: 'Routine',
        safety: 'Safety',
        skills: 'Skills',
        specificInformation: 'Specific information',
      },
      termsAndConditions: 'I {{ contactName }} agree to the <0>terms and conditions</0> of the Nursery.',
      title: 'Registration form',
    },
    Reports: {
      ChildrenLeaving: {
        Filters: {
          Age: {
            label: 'Age',
          },
          LeaveDate: {
            label: 'Leave date',
          },
          Rooms: {
            label: 'Rooms',
          },
        },
        Organization: {
          Table: {
            Header: {
              leavers: 'Leavers',
            },
          },
          description: 'Children leaving',
          title: 'Children leaving',
        },
        Statistics: {
          totalDepositPaid: 'Total deposit paid',
          totalDepositRefunded: 'Total deposit refunded',
          totalLeavers: 'Total Leavers',
        },
        description: 'Children leaving',
        title: 'Children leaving',
      },
      ChildrenSignedUp: {
        Filters: {
          Age: {
            label: 'Age',
          },
          RegistrationDate: {
            label: 'Registration date',
          },
          Rooms: {
            label: 'Rooms',
          },
        },
        Organization: {
          Table: {
            Header: {
              signups: 'Signups',
            },
          },
          description: 'Children signed up',
          title: 'Children signed up',
        },
        Statistics: {
          totalDepositPaid: 'Total deposit paid',
          totalSignups: 'Total signups',
        },
        description: 'Children signed up report',
        title: 'Children signed up',
      },
      ChildrenStarting: {
        Filters: {
          Age: {
            label: 'Age',
          },
          Rooms: {
            label: 'Rooms',
          },
          StartDate: {
            label: 'Start date',
          },
        },
        Organization: {
          Table: {
            Header: {
              starters: 'Starters',
            },
          },
          description: 'Children starting',
          title: 'Children starting',
        },
        Statistics: {
          totalDepositPaid: 'Total deposit paid',
          totalStarters: 'Total starters',
        },
        description: 'Children starting',
        title: 'Children starting',
      },
      Common: {
        depositPaid: 'Deposit paid',
        depositRefunded: 'Deposit refunded',
        totalFte: 'Total FTE',
        totalWeeklyFee: 'Total weekly fee',
        weeklyFee: 'Weekly Fee',
      },
      Dietary: {
        description: 'This report provides a detailed list of children’s dietary preferences and allergies.',
        title: 'dietary preferences & allergies',
      },
      EmergencyContact: {
        description: 'This report provides a detailed list of all contacts for every child.',
        title: 'Emergency contacts list',
      },
      KeyPerson: {
        description: 'This report provides a detailed list of all children assigned to a particular Key Person.',
        emptyStateText: 'There are no children assigned to this Key Person.',
        title: 'Key Person lists',
      },
      MonthlyFteChange: {
        Organization: {
          description: 'Monthly FTE change report',
          title: 'Monthly FTE change',
        },
        Table: {
          Header: {
            existingDecrease: 'Existing children (FTE Decrease)',
            existingIncrease: 'Existing children (FTE Increase)',
            leavers: 'Leavers (FTE)',
            monthlyTotal: 'Total monthly FTE',
            netChange: 'Net FTE change',
            starters: 'Starters (FTE)',
          },
        },
        description: 'Monthly FTE change report',
        title: 'Monthly FTE change',
      },
      NurseryMilk: {
        Export: {
          description: 'Select a manger or administrator to send the CSV to',
          title: 'Export your Nursery Milk report',
        },
        Filters: {
          UnitPrice: {
            label: 'Unit price',
            placeholder: 'Unit price',
          },
          UnitsPerChild: {
            label: 'Unit per child',
            placeholder: 'Unit per child',
          },
        },
        Statistics: {
          totalChildren: 'Total children in attendance ',
          totalCost: 'Total cost of milk',
          totalMilk: 'Total milk units',
        },
        Table: {
          Header: {
            children: 'Children in Attendance',
          },
        },
        description: 'This is where you can generate and download reports for your free milk claims based on the child register.',
        summaryDescription: 'This report provides the data required for free milk claims.',
        title: 'Nursery milk report',
      },
      PhotoPermissions: {
        TableHeaders: {
          closedSocialMediaPhotoSharingPermitted: 'Share on closed social media',
          groupPhotoPermission: 'Group photo permission',
          photoPermission: 'Photo permission',
          shareOnOtherMarketingMaterial: 'Share on other marketing material',
          shareOnSocialMedia: 'Share on open social media',
          useOnSiteMediaPermitted: 'Use media on-site',
        },
        description: "This report provides an overview of children's photo and media permissions.",
        title: 'photo permissions',
      },
      emptyStateText: 'There is no data matching your criteria.',
      exportReportTitle: 'Export your {{type}} report',
      reportTitle: '{{type}} report',
      searchPlaceholder: 'Search reports',
      subtitle: 'This is where you can generate and download reports for an overview of your staff and children.',
      title: 'Children reports',
    },
    Rooms: {
      RoomMoves: {
        roomMove: 'room move',
        roomMoves: 'room moves',
      },
      RoomTypes: {
        all: 'All room types',
        nonTeaching: 'Non teaching room',
        outside: 'Outdoor location',
        teaching: 'Teaching room',
      },
      Rooms: {
        room: 'room',
        rooms: 'rooms',
      },
      RoomsAdd: {
        Button: {
          addTime: 'Add time',
        },
        Confirm: {
          archive: 'Are yo sure you want to {{ action }} this room?',
          archiveForOccupancyFlag: "This will {{ action }} the room. Press 'Continue' to {{ action }} and manually update your children's room moves.",
          changeAgeBand: 'Are you sure you want to update the age band of the room? Please note: editing this will unconfirm and recalculate any confirmed room moves.',
        },
        Fields: {
          StaffingEnabled: {
            capacity: 'Child capacity',
            finishAge: 'Typical finish age',
            minStaff: 'Min. staff',
            minimumStaffRequired: 'Minimum staff required',
            ratio: 'Ratio',
            roomName: 'Name',
            roomType: 'Location type',
            startAge: 'Typical start age',
            weekday: 'Weekday',
          },
          capacity: 'Capacity',
          finishAge: 'Finish age',
          minStaff: 'Min. staff',
          minimumStaffRequired: 'Minimum staff required',
          ratio: 'Ratio',
          roomName: 'Room name',
          roomType: 'Room type',
          startAge: 'Start age',
          weekday: 'Weekday',
        },
        Subtitle: {
          create: 'Set up your room',
          edit: 'Edit your room',
        },
        Title: {
          create: 'Create room or location',
          edit: 'Edit room or location',
        },
        Tooltip: {
          archive: 'If you want to change the room type please archive this room and create a new one.',
          minStaffRequired: 'The minimum staff required in teaching rooms only takes effect if at least one child is expected in. Many nurseries use this setting to make sure they have at least two staff members in the room when one child is expected in to have a witness for any unforeseen event.',
        },
        ValidationErrors: {
          allAboveFields: 'All above fields are required.',
          atLeastOneRequirement: 'At least one requirement must be entered.',
        },
      },
      RoomsList: {
        emptyState: 'There are no rooms at present.',
      },
      TableHeaders: {
        ageRange: 'Typical child age',
        capacity: 'Capacity',
        minStaffRequired: 'Min. staff required',
        ratio: 'Ratio',
        roomName: 'Room name',
      },
    },
    Safeguarding: {
      Add: {
        addStaffMember: 'Add staff member',
        addTitle: 'New home accident',
        deletePopupCopy: 'Are you sure you want to delete this home accident?',
        editTitle: 'Edit home accident record',
        noChildrenError: 'Please select child name',
        signatureWarningOnEdit: 'Editing home incident will remove any existing signature added.',
      },
      Administration: {
        Add: {
          emergencyDoseButtonLabel: 'Emergency dose',
          scheduledDoseButtonLabel: 'Scheduled dose',
        },
        Filters: {
          administerType: {
            label: 'Administer type',
          },
          administrationDate: {
            label: 'Administration date',
          },
          status: {
            label: 'Status',
          },
        },
        List: {
          Table: {
            administeredBy: 'Administered by',
            administrationType: 'Type',
            frequency: 'Frequency',
            medication: 'Medication',
            parentSignatureButtonLabel: 'Parent signature',
          },
          emptyStateText1: 'There are no Administrations. A history of all administrations will be shown here.',
          exportSuccessMessage: 'Administered medication has been sent to {{email}}. This may take few minutes',
          exportTitle: 'Export administration',
          exportUserLabel: 'Select a manager or administrator to send the PDFs to',
          searchPlaceholder: 'Search by child name or medication',
          title: 'Administrations',
        },
        Preview: {
          Headers: {
            Signature: {
              administeredBy: 'Administered by',
              title: 'Signatures',
            },
            dose: 'Dose',
            medication: 'Medication (name, strength, form)',
            otherNotes: 'Other notes',
          },
          emergencyTitle: 'Emergency administration details',
          title: 'Administration details',
        },
        title: 'Administrations',
      },
      Common: {
        accident: 'Accident Details',
        witness: 'Witness',
      },
      Constants: {
        Type: {
          bruises: 'Bruises',
          burns: 'Burns',
          cuts: 'Cuts',
          headBump: 'Head bump',
          other: 'Other',
          scratches: 'Scratches',
        },
      },
      Fields: {
        AccidentDate: {
          label: 'Accident date',
        },
        AccidentDetails: {
          label: 'Accident details',
          placeholder: 'Description of what the injury looks like',
        },
        AccidentLocation: {
          label: 'Accident location',
          placeholder: 'Accident location',
        },
        AdditionalNotes: {
          label: 'Additional notes',
          placeholder: 'Additional notes',
        },
        AttachedMedia: {
          label: 'Attached media',
        },
        BodyMap: {
          hideBodyMap: 'Hide body map',
          label: 'Body map',
          note: 'Tap on any body part to highlight the affected area',
          showBodyMap: 'Show body map',
        },
        ChildName: {
          label: 'Child name',
          placeholder: 'Child name',
        },
        DateAccident: {
          label: 'Date of accident',
        },
        FirstAidProvided: {
          label: 'First aid provided / medical help provided',
          placeholder: 'What treatment was provided to the child?',
        },
        Injury: {
          label: 'Injury',
          placeholder: 'Select injury',
        },
        InjuryDescription: {
          label: 'Injury description',
          placeholder: 'Description of what the injury looks like',
        },
        InjuryDetails: {
          label: 'Injury details',
        },
        TimeAccident: {
          label: 'Time of accident',
        },
      },
      HomeAccidentExport: {
        allInjuriesExport: 'All injuries',
      },
      HomeAccidents: {
        title: 'Home accidents',
      },
      List: {
        createdBy: 'Created by',
        emptyStateText1: 'There are no home accidents reported.',
        emptyStateText2: 'A history of all home accidents will be shown here.',
        exportHomeAccidentForm: 'Export home accident form',
        injuryPlaceholder: 'Injury',
        itemSignatureTitle: 'Signatures',
        previewTitle: 'Home accident preview',
        title: 'Home accidents',
      },
      MedicationForm: {
        Add: {
          Form: {
            MedicationDetails: {
              AdministrationTime: {
                addButtonLabel: 'Add time',
                label: 'Time of adminstration',
                placeholder: '00:00',
              },
              BeforeAfterEating: {
                label: 'Before or after eating',
                placeholder: 'Please select',
              },
              BeforeAfterEatingTime: {
                label: 'How long before/after eating',
                placeholder: '00',
              },
              Dose: {
                label: 'Dose (amount and unit)',
                placeholder: 'Amount and unit',
              },
              ExpiryDate: {
                label: 'Medication expiry date',
              },
              Frequency: {
                label: 'Frequency',
              },
              Medication: {
                label: 'Medication (name, strength, form)',
                placeholder: 'Medication name, strength, form',
              },
              MethodOfAdministration: {
                label: 'Method of administration',
                placeholder: 'Method of administration',
              },
              OtherNotes: {
                label: 'Other notes',
              },
              ReasonForMedication: {
                label: 'Reason for medication',
                placeholder: 'Reason for medication',
              },
              SideEffects: {
                label: 'Known side effects',
              },
              title: 'Medication details',
            },
            ReviewDate: {
              label: 'Review date',
            },
            Signatures: {
              Parent: {
                label: 'Parent/Guardian',
                placeholder: 'Parent/Guardian',
              },
              ParentSignature: {
                label: 'Parent/Guardian signature',
              },
              StaffReceivingMedication: {
                label: 'Staff receiving medication',
                placeholder: 'Staff receiving medication',
              },
              StaffSignatures: {
                label: 'Staff signature',
              },
              bannerInfo: 'After the medication form has been signed no changes can be made. If the dose or amount changes, please end this medication form and create a new one.',
              draftSignatureInfo: 'When saving as draft, no signatures will be saved. Please sign when the form is finalised and click save.',
              infoText: 'Once parents and member of staff sign the medication form, you can start entering administered medication',
              parentConcent: 'I hereby give consent to {{ nurseryName }} Nursery Staff to administer the medication. I confirm that the medication is in the original container marked with the child’s name. I confirm that my child has already had one dose of this medication and has not suffered any adverse/unwanted reactions.',
              title: 'Signatures',
            },
            Stock: {
              StorageInstructions: {
                label: 'Storage instructions',
              },
              StoreMedicationOnSite: {
                label: 'Store medication on site',
              },
              title: 'Stock',
            },
          },
          deleteText: 'Are you sure you want to delete draft medicaiton form?',
          editTitle: 'Edit medication form',
          leavePopupMessage: 'You have unsaved changes. Do you want to discard changes or continue editing?',
          reviewDateRangeValidation: 'Review date must be between start and end date',
          title: 'New medication form',
        },
        Common: {
          administrationDetails: 'Administration details',
          medicationForm: 'Medication form',
        },
        Filters: {
          onSite: 'On site',
          providedByParents: 'Provided by parents',
          search: 'Search by child name or medication',
          storeOnSite: 'Store on site',
        },
        History: {
          routeTitle: 'History',
        },
        List: {
          Table: {
            expiryDate: 'Medication expiry date',
            frequency: 'Frequency',
            medication: 'Medication',
            reviewDate: 'Review date',
            startEndDate: 'Start-end date',
          },
          emptyStateChildContext: 'There are no medication forms. A history of all medications created for this child will show here.',
          emptyStateText1: 'There are no medication forms. A history of all medications created will be shown here.',
          exportSuccessMessage: 'Medication form has been sent to {{email}}. This may take few minutes',
          exportTitle: 'Export medication form',
          exportUserLabel: 'Select a manager or administrator to send the PDFs to',
          title: 'Medication forms',
        },
        Preview: {
          Headers: {
            MedicationDetails: {
              administrationTime: 'Time of administration',
              beforeAfterEating: 'Hungry or full',
              beforeAfterEatingTime: 'How long before/after eating',
              dose: 'Dose',
              expiryDate: 'Medication expiry date',
              frequency: 'Frequency',
              medication: 'Medication (name, strength, form)',
              methodOfAdministration: 'Method of administration',
              notes: 'Other notes',
              reason: 'Reason of medication',
              sideEffects: 'Known side effects',
              title: 'Medication details',
            },
            Signature: {
              Parent: {
                parent: 'Parent',
                title: 'Parent',
              },
              Staff: {
                administratedBy: 'Administrated by',
                title: 'Staff',
              },
              title: 'Signature',
            },
            Stock: {
              storageInstructions: 'Storage instructions',
              storeOnSite: 'Store medication on site',
              title: 'Stock',
            },
            reviewDate: 'Review date',
          },
          History: {
            emptyStateText: 'List of update history of medication form is empty',
            title: 'Medication form history',
            updatedMadeBy: 'Updated made by',
          },
          ReviewForm: {
            DateMedicationReturned: {
              label: 'Date medication returned',
            },
            MedicationEndDate: {
              label: 'Medication end date',
            },
            MedicationExpiryDate: {
              label: 'Medication expiry date',
            },
            MedicationFormEndDate: {
              label: 'Medication form end date',
            },
            MedicationMarkedAsStoredOnSite: {
              label: 'Medication marked as stored on site',
            },
            MedicationStoredOnSite: {
              label: 'Medication stored on site',
            },
            NextScheduledReviewDate: {
              label: 'Next scheduled review date',
            },
            ParentGuardian: {
              label: 'Parent/Guardian',
            },
            ParentGuardiansSignature: {
              label: "Parent/Guardian's signature",
            },
            ReviewDate: {
              label: 'Review date',
            },
            ReviewNotes: {
              label: 'Review notes',
            },
            StaffMember: {
              label: 'Staff member',
            },
            StaffSignature: {
              label: 'Staff signature',
            },
            reviewMedicationForm: 'Review medication form',
            title: 'Review',
            validationMessage: {
              NextReviewDate: {
                lessThenExpiry: 'Next review date should be before medication end date',
                lessThenReviewDate: 'Next review date should be after {{ reviewDate }} review date.',
              },
            },
          },
          expiryNotes: 'The medication can’t be administered because of past expiry date. You have to end current medication form and create a new one',
          title: 'Medication form details',
        },
        title: 'Medication forms',
      },
      Preview: {
        Details: {
          accidentDetailsLabel: 'Accident Details',
          attachedMediaLabel: 'Attached media',
          locationLabel: 'Location',
          statusLabel: 'Status',
          title: 'Details',
        },
        Signatures: {
          Digital: {
            removeStaffMemberButtonLabel: 'Remove staff member',
            staffMemberPlaceholder: 'Select staff member',
          },
          titleTooltip: 'Signatures cannot be added for draft home accidents.',
        },
        accidentDetailsLabel: 'Accident Details',
        accidentRecordTitle: 'Accident Record',
        approvePopupCopy: 'Are you sure you want to approve this home accidents record?',
        attachedMediaLabel: 'Attached media',
        emptyStateText: 'Not found home accident',
        exportTitle: 'Export home accident record',
        requireFollowingField: 'Please enter the following fields to approve the home accident record.',
      },
      Routing: {
        accidentsIncidents: 'Accidents & Incidents',
        homeAccidents: 'Home accidents',
        title: 'Safeguarding',
      },
    },
    Security: {
      AccessLogsList: {
        attemptToLoginWithEmail: 'Attempt to login with email address {{ email }}',
        log: 'Log',
        loggedInOnAnUnapprovedDevice: '{{ name }} ({{ email }}) logged in on an unapproved device.',
        loggedInOnDevice: "{{ name }} ({{ email }}) logged in on device '{{ device }}'.",
        nothingFound: 'There are no access logs recorded at present.',
        title: 'Access logs',
      },
      AuthorisedDevices: {
        AddDevice: {
          approveThisDevice: 'Approve this device',
          generatePin: 'Generate pin',
          title: 'Authorise new device',
        },
        AuthorisedDevicesList: {
          authorisationMethod: 'Authorisation method',
          authorisedBy: 'Authorised by',
          dateAuthorised: 'Date authorised',
          device: 'device',
          deviceName: 'Device name',
          devices: 'devices',
          nothingFound: 'There are no devices registered at present.',
          pinAuthorised: 'Pin authorised',
          pinExpired: 'Pin expired',
          searchDevice: 'Search authorised devices',
          selfAuthorised: 'Self authorised',
          thisDevice: 'this device',
          title: 'Authorised devices',
          validPin: 'Valid pin',
        },
        DeviceDetails: {
          title: 'Device details',
        },
        EditDevice: {
          authorisationPin: 'Authorisation pin',
          dateAuthorised: 'Date authorised',
          generateANewPin: 'Generate a new pin for this device',
          pinAuthorised: 'Pin authorised',
          pinExpired: 'Pin expired',
          pinNotAuthorised: 'Pin not authorised',
          regeneratePin: 'Regenerate pin',
          removeDevice: 'Are you sure you want to remove this device?',
          staffMember: 'Staff member',
          title: 'Edit device',
          updateDevice: 'Update device',
        },
        components: {
          PinBox: {
            backToDevices: 'Back to devices',
            pin: 'Pin',
            pinExpireDate: 'This pin will expire <0>{{ date }}</0> and has been emailed to the staff member.',
          },
        },
        global: {
          description: 'Please add a device name and staff member responsible for authorising this device',
          name: 'Device name',
          staffMember: 'Staff member',
        },
      },
    },
    Settings: {
      Common: {
        globalSettingsEditLabel: 'Use global settings',
      },
      Invoice: {
        Annualized: {
          title: 'Your annualised and packaged invoices ',
        },
        Global: {
          label: 'Use organization invoice settings',
        },
        InvoiceDetails: {
          description: 'This is where you can set your default settings and apply these to all of your nurseries. Bank details for individual nurseries can be added in the nursery’s settings.',
          nurseryTitle: 'Your invoice settings for',
          subtitle: 'This is where you can set your organization settings and apply these to all of your nurseries. Bank details for individual nurseries can be added in the nursery’s settings.',
          title: 'Your default invoice settings',
        },
        InvoiceNumber: {
          subtitle: 'This is where you can set the automated number sequencing to generate invoice, receipt and credit note numbers.',
          title: 'Invoice number sequencing',
        },
        subtitle: 'This is where you can set your organization and individual nursery invoice settings.',
      },
      Nursery: {
        subtitle: 'This is where you can modify each of your nurseries details.',
        title: 'Nursery information',
      },
      Security: {
        GlobalSettings: {
          AcrossOrganization: {
            label: 'Across organisation',
            tooltip: 'The security settings are applied across the organisation and are managed from the organisation level.',
          },
          SeparatelyForEachNursery: {
            label: 'Separately for each nursery',
            tooltip: 'The security settings are applied for each individual nursery separately.',
          },
          label: 'How would you like to apply security settings?',
        },
        Item: {
          routeTitle: 'Nursery settings',
          title: 'Security settings for',
        },
        NurseryList: {
          title: 'Security settings for individual nurseries',
        },
        SessionTimeout: {
          globalTitle: 'Security settings for all users',
          title: 'Security settings for group level users',
        },
        title: 'Security',
      },
      Sessions: {
        Add: {
          archivePopupCopy: 'Are you sure you want to archive this session? Please note: this session already allocated to children will not be affected.',
          fundingPopupCopy: 'Are you sure you want to edit these sessions? Please note: any changes will affect uninvoiced sessions. You may also need to reallocate funding.',
          unarchivePopupCopy: 'Are you sure you want to unarchive this session? You can archive it again at any time.',
        },
        List: {
          sessions: 'Sessions',
          sessionsFor: 'Sessions for {{ name }}',
        },
      },
    },
    Shell: {
      AlertBar: {
        learnMore: 'learn more',
      },
      AuthoriseDeviceContent: {
        authoriseDevice: 'Authorise device',
        content: 'This device is not authorised and cannot yet be used by staff members',
      },
      MaintenanceBar: {
        message: 'will be performed between 20/07/2024-21/07/2024. Our service may be impacted and temporarily unavailable at certain times during this period.',
        title: 'Scheduled maintenance',
      },
      NetworkConnectionBar: {
        dataIsSyncing: 'Data is syncing, please wait...',
        youAreOffline: 'You are offline',
        youAreOfflineAndCanOnlyUse: 'You are currently offline. You can only use the children\'s register',
      },
      UploadRoot: {
        Uploaded: 'Uploaded',
        filesUploading: 'Files uploading',
        noFilesUploading: 'No files uploading',
        types: {
          observationFor: 'Observation for',
        },
      },
      activeParentPay: 'Tired of late payments and constant reconciliation? Activate Parent Pay now and ',
      notSupportedBrowserMessagePart1: "Hi there, it looks like you are using a web browser that Blossom isn't currently fully optimised for.",
      notSupportedBrowserMessagePart2: 'We found there was no need to optimise Blossom for this as very few people across the globe use this! Therefore we recommend using one of Google Chrome or Safari. Please download them to get the best possible Blossom experience. If you wish you can still continue using this current browser.',
    },
    Staff: {
      AddStaff: {
        title: 'Add staff',
      },
      Roles: {
        deputyManager: 'Deputy Manager',
        nonTeaching: 'Register Only Staff',
        nurseryAdmin: 'Nursery Administrator',
        nurseryManager: 'Manager',
        organizationDirector: 'Director',
        organizationFinanceAdmin: 'Finance Administrator',
        organizationLineManager: 'Area Manager',
        organizationNationalAdmin: 'National Administrator',
        roomLeader: 'Room Leader',
        seniorTeacher: 'Senior Practitioner',
        superAdmin: 'Super Admin',
        teacher: 'Practitioner',
      },
      StaffAdd: {
        ChangePasswordSection: {
          title: 'Change password',
        },
        Errors: {
          confirmPassword: 'Retyped password did not match.',
          currentPassword: 'You need to provide current password in order to change your password.',
          dbsCertificateId: 'A DBS certificate is required.',
          dbsReviewBy: 'A valid reviewer should be specified if a DBS certificate id is given.',
          dbsReviewDate: 'A valid review date should be specified if a DBS certificate id is given.',
          password: 'Your password must be at least 8 characters.',
        },
        Fields: {
          Address: {
            label: 'Address',
          },
          Bio: {
            label: 'Bio for parents to view',
            placeholder: 'Bio description',
          },
          BirthDate: {
            label: 'Date of birth',
            placeholder: 'Date of birth',
          },
          ConfirmPassword: {
            label: 'Confirm password',
          },
          ContactNumber: {
            label: 'Contact number',
          },
          CurrentPassword: {
            label: 'Current password',
            resetPasswordLink: 'Forgotten your password?',
            text: 'Please enter your current password to make changes. If you have forgotten your password, contact your nursery manager to reset it for you.',
          },
          DbsCertificate: {
            label: 'DBS certificate',
          },
          DbsCertificateId: {
            placeholder: 'DBS certificate id',
          },
          DbsReviewBy: {
            placeholder: 'Reviewed by',
          },
          DbsReviewDate: {
            placeholder: 'Review date',
          },
          Email: {
            label: 'Email address',
            placeholder: 'Email',
          },
          FirstName: {
            placeholder: 'First name',
          },
          JobTitle: {
            label: 'Job title',
          },
          Mobile: {
            placeholder: 'Mobile number',
          },
          Name: {
            label: 'Name',
          },
          Nurseries: {
            label: 'Nurseries',
            text: 'Select the nurseries this staff member should have access to.',
            tooltip: 'Contact your supervisor to update the nurseries list.',
          },
          OneThirteenQualification: {
            label: '1:13 Staff child qualification',
          },
          Password: {
            label: 'Password',
            placeholder: 'New password',
            text: 'Please enter a new password and update your profile to save changes.',
          },
          PayrollNumber: {
            label: 'Payroll number',
          },
          Photo: {
            Text: {
              1: 'Image should be your face so that others can quickly recognise you.',
              2: 'Image should ideally be square to look best across the platform.',
            },
            label: 'Profile photo',
          },
          Postcode: {
            label: 'Postcode',
          },
          Qualification: {
            label: 'Qualification',
          },
          Role: {
            label: 'Role',
          },
          Surname: {
            placeholder: 'Surname',
          },
          Telephone: {
            placeholder: 'Home number',
          },
          Title: {
            placeholder: 'Title',
          },
          Username: {
            label: 'Username',
          },
        },
        Footer: {
          ArchiveButton: {
            label: '{{ action }} user',
          },
          ArchiveModal: {
            text: 'Are you sure you want to {{ action }} user:',
          },
          SubmitButton: {
            Create: {
              administrator: 'administrator',
              label: 'Create {{ user }}',
            },
            Update: {
              label: 'Update profile',
            },
          },
          creatingText: 'Registering this {{ user }} will send them an email detailing the next steps they need to take to register and start using Blossom Educational.',
        },
        OnSuccessfulCreation: {
          addContract: 'Add contract',
          addContractInfo: 'Do you want to add contract information?',
          staffMemberHasBeenAdded: '{{ name }} has been added.',
        },
        ResendInvitation: {
          confirmationMessage: 'Email Sent',
          error: 'We could not retrieve your request. Please try again or contact with your system administrator.',
          label: 'Resend invitation',
          text: 'This staff member has not accepted their invitation.',
        },
        SystemOwnerTooltip: {
          deactivateButton: 'The System Owner cannot be deactivated. To deactivate this user, change the System Owner in the nursery settings.',
          rolesDropdown: 'The System Owner can only be changed in the nursery settings.',
        },
        Title: {
          addOrganizationStaff: 'Add head office staff',
          addStaff: 'Add staff member',
          editOrganizationStaff: 'Edit head office staff',
          editProfile: 'Edit profile',
          editStaff: 'Edit staff member',
        },
        disabledRoleOptionTooltip: 'You don’t have the permission to add a {{ role }}.',
      },
      StaffAttendance: {
        actual: 'Actual',
        actualTypes: {
          break: 'Break',
          worked: 'Clocked in',
        },
        emptyState: 'Nothing found',
        ongoing: 'Ongoing',
        planned: 'Planned',
        searchAttendance: 'Search staff members',
        title: 'Staff attendance',
        variation: 'Variation',
        variationTypes: {
          break: 'Break',
          worked: 'Work',
        },
      },
      StaffContracts: {
        Add: {
          dateValidationError: 'Either choose end date or mark this contract as ongoing.',
          submitButton: 'Add contract',
          title: 'Add contract',
        },
        ContractType: {
          Permanent: {
            long: 'Permanent (salaried)',
            short: 'Permanent',
          },
          bankStaff: 'Bank staff',
        },
        DailyBreakAllowance: {
          addBreakAllowanceButtonLabel: 'Add break allowance',
          conditionText: 'for',
          label: 'Daily break allowance',
          workingTime: 'working time',
        },
        Edit: {
          removeContractConfirmation: 'This contract will be deleted.',
          submitButton: 'Update contract',
          title: 'Edit contract',
        },
        Labels: {
          ContractedHours: {
            long: 'Contracted hours per week',
            short: 'Contracted',
          },
          contractDate: 'Contract date',
          contractPeriod: 'Contract period',
          hourlySalary: 'Hourly rate',
          jobTitle: 'Job title',
          overtimeTreatment: 'Overtime treatment',
          salary: 'Salary',
          type: 'Contract type',
        },
        List: {
          EmptyState: {
            text1: 'No contracts.',
            text2: 'Add contracts for staffing and payroll.',
          },
          Pagination: {
            plural: 'contracts',
            singular: 'contract',
          },
          addContract: 'Add contract',
          title: 'Contracts list',
        },
        OvertimeTreatment: {
          notPaid: 'Not paid',
          paid: 'Paid',
          toil: 'TOIL',
        },
        Preview: {
          general: 'General',
          title: 'Preview contract',
        },
        Status: {
          current: 'Current',
          future: 'Future',
          past: 'Past',
        },
        title: 'Contracts',
      },
      StaffDetails: {
        ActivateUserModal: {
          text: 'Are you sure you want to {{ action }} user:',
        },
        MyDetailsText: {
          1: 'Your profile contains details that colleagues can use to contact you or your emergency contact, if these details are incorrect then why not',
          2: 'update your profile',
        },
        Title: {
          staffMemberDetails: 'Profile',
          yourBlossomProfile: 'Your Blossom Profile',
        },
        generalInformation: 'General Information',
      },
      StaffFileUploads: {
        fileDetailsHasBeenChanged: 'File details has been changed',
        fileRemoved: 'The file has been successfully removed',
        notFound: 'There are no files.',
      },
      StaffLeave: {
        addLeave: 'Add leave',
        deleteLeave: 'This will delete the leave for the dates',
        editLeave: 'Edit leave',
        goToRota: 'Go to rota',
        impactTheRota: 'The deleted leave might impact the rota.',
        leaveType: 'Leave type',
        notFound: 'No staff members with leave.',
        searchByName: 'Search by name',
        staffWithLeave: 'Show only staff with leaves',
        title: 'Staff leave',
      },
      StaffLeaveDetails: {
        LeaveNotes: {
          addNote: 'Add note',
          changeBy: 'Change by',
          comments: 'Comments',
          entitlement: 'Entitlement',
          entitlementChange: 'Entitlement change',
          entitlementHours: 'Entitlement hours',
          holidayPeriod: 'Holiday period',
          saveNote: 'Save note',
          title: 'Entitlement notes',
        },
        addLeave: 'Add leave',
        editLeave: 'Edit leave',
        holidays: 'Holidays',
        notFound: 'No leave found',
        otherLeave: 'Other leave',
        sickLeave: 'Sick leave',
        title: 'Leave',
      },
      StaffLists: {
        addAdministrator: 'Add administrator',
        addOrganizationStaff: 'Add head office staff',
        addStaffMember: 'Add staff member',
        administrators: 'Administrators',
        currentStaff: 'Current staff',
        disabledViewButtonTooltip: 'You don’t have the permission to view a {{ role }}.',
        exportReportStaffListTitle: 'Export your staff list',
        me: 'me',
        notFound: 'There are no users at present.',
        notSpecified: 'not specified',
        organisationUsersFilter: 'Show only head office staff',
        searchAdministrators: 'Search administrators',
        searchStaff: 'Search staff',
        staffList: 'Staff list',
        staffMember: 'staff member',
        staffMembers: 'staff members',
        title: 'Staff',
      },
      StaffRegister: {
        title: 'Register',
      },
      StaffRota: {
        addLeave: 'Add leave',
        addShift: 'Add shift',
        childrenExpected: 'Children expected',
        emptyState: 'There are no shifts planned in this room for this week. Please add staff shifts.',
        flags: 'flags',
        nurseryClosed: 'Nursery closed',
        nurseryClosureDate: 'Nursery closure date',
        overstaffed: 'Overstaffed',
        pastWeekBanner: 'This is a snapshot of a past rota. Shifts, leave and staffing flags are based on the last day of the week and do not change.',
        staffExpected: 'Staff expected',
        staffRequired: 'Staff required',
        staffingFlags: 'Staffing flags',
        times: 'Times',
        title: 'Staff rota',
        understaffed: 'Understaffed',
      },
      StaffWorklog: {
        nurseryClosed: 'Nursery closed',
        searchForYourself: 'Search for yourself or a colleague',
        staffEmptyResults: 'No staff members.',
        title: 'Staff worklog',
      },
      StaffWorklogPreview: {
        EmptyState: {
          default: 'There are no entries for this day.',
          notOngoingInBetweenDay: 'Entries cannot be added on this day as all hours are allocated.',
          notOngoingLastDay: 'There are no entries on this day. Edit from here or use the staff register to add times.',
          ongoingInBetweenDay: '{{ name }} is still clocked in. Entries cannot be added on this day as all hours are allocated.',
          ongoingLastDay: '{{ name }} is still clocked in. Please clock out to add or edit activities on this day.',
        },
        ShiftsBanner: {
          namePart: '{{ firstName }} has ',
          staffProfile: 'staff profile',
          suffixPart: ' on this date. You can edit leaves in the ',
          timeRangePart: ' ({{ timerRangeString }}) of ',
        },
        activity: 'Activity',
        addActivity: 'Add activity',
        break: 'Break',
        changeLog: 'Change log',
        commentPlaceholder: 'Why did you make the change?',
        commentSubLabel: 'only visible in change log',
        editTitle: 'Edit workday overview',
        endTime: 'End time',
        previousRecordBannerText: '{{ firstName }} already has {{ timeRangeString }} clocked in from',
        startTime: 'Start time',
        title: 'Workday overview',
        total: 'Total',
        totalTime: 'Total time',
        worked: 'Worked',
      },
      SubMenu: {
        about: 'About',
        contracts: 'Contracts',
        leave: 'Leave',
      },
    },
    StaffRegister: {
      Authentication: {
        staffMember: 'Staff member',
        title: 'Authentication',
      },
      ChangeLocation: {
        Title: {
          changeLocation: 'Change location',
          clockIn: 'Clock in',
          endBreak: 'End break',
          startBreak: 'Start break',
        },
        chooseYourLocation: 'Choose your location',
      },
      ChooseNewPin: {
        chooseNewPin: 'Choose new pin',
        confirmNewPin: 'Confirm new pin',
        pinNotMatch: 'Pin did not match.',
      },
      ChooseNewPinSuccess: {
        messageOne: 'Your pin has been successfully set',
        messageSecond: 'We have sent you an email verification.',
      },
      Credentials: {
        password: 'Password',
        title: 'Credentials',
        username: 'Username / Email',
      },
      Dashboard: {
        ButtonLabels: {
          changeLocation: 'Change location',
          clockIn: 'Clock in',
          clockOut: 'Clock out',
          endBreak: 'End break',
          startBreak: 'Start break',
        },
        clockedIn: 'clocked in',
        clockedOut: 'clocked out',
        onBreak: 'on break',
        youAreCurrently: 'You are currently',
      },
      StaffRegisterList: {
        SnackbarText: {
          breakInAt: 'break in at',
          breakOutAt: 'break out at',
          changeLocationAt: 'change location at',
          clockedInAt: 'clocked in at',
          clockedOutAt: 'clocked out at',
        },
        deviceTokenNotFound1: 'This device is unauthorised.',
        deviceTokenNotFound2: 'Please authorise it to access the staff register.',
        notFoundRecords: 'No staff members.',
        searchForYourself: 'Search for yourself or a colleague',
        title: 'Staff register',
      },
      global: {
        createPin: 'Create pin',
        forgotPin: 'Forgot pin',
        returnToEnterPin: 'Return to enter pin',
      },
    },
    Various: {
      AccessForbidden: {
        dashboardButtonText: 'Go back to dashboard',
        loginButtonText: 'Go back to login page',
        text: 'You are not allow to access this page.',
      },
      DiaryLinkExpired: {
        text_1: 'Your link has expired',
        text_2: 'For security reasons this link is only valid for 24 hours from when it is sent.',
        text_3: 'Please contact your nursery for a new link.',
      },
      Missing: {
        text: 'Sorry, the requested view was not found.',
      },
      NotFound: {
        text1: 'Oops!',
        text2: "Looks like you've entered your nursery's URL incorrectly. Please check for any spelling mistakes.",
        text3: 'If you are still having problems give us a call on ',
      },
    },
  },
  services: {
    Administration: {
      AdministrationStatus: {
        administered: 'Administered',
        missed: 'Missed',
        scheduled: 'Scheduled',
        signed: 'Signed',
      },
      AdministrationType: {
        emergency: 'Emergency',
        scheduled: 'Scheduled',
      },
    },
    Child: {
      changelogs: {
        madeByOptions: {
          nursery: 'Nursery',
          parents: 'Parents',
        },
      },
      dietary: {
        AdditionalRequirements: 'Additional requirements',
        Allergies: 'Allergies',
        EatsMeat: 'Eats meat',
        NotSpecified: 'Not specified',
        Vegan: 'Vegan',
        Vegetarian: 'Vegetarian',
      },
    },
    ChildSessions: {
      CalculationOptionLabels: {
        actualSessions: 'Actual sessions',
        averageCost: 'Average over {{ weeks }} weeks and {{ days }} days',
      },
    },
    ClosureDayTypes: {
      ChargeFor: {
        extraItems: 'Extra items',
        extraSession: 'Extra sessions',
        extraSessionConsumable: 'Extra consumables',
        fundingDeficit: 'Funding deficit',
        oneOfDiscount: 'Extra discounts',
        regularConsumables: 'Regular consumables',
        regularDiscount: 'Regular discounts',
        regularItems: 'Regular items',
        regularSession: 'Regular sessions',
      },
    },
    CohortTracking: {
      agesMap: {
        under2s: 'Under 2s',
        yearsOld: '{{ age }} years old',
      },
      childExtraFields: {
        childOfArmedForces: 'Child of armed forces',
        childOfArmedForcesShort: 'AFC',
        doesReceiveEyppFunding: 'Early years pupil premium',
        doesReceiveEyppFundingShort: 'EYPP',
        doesReceiveTwoYearFunding: '2 year funded children',
        doesReceiveTwoYearFundingShort: '2 year funded',
        englishAsAnAdditionalLanguage: 'English as an additional language',
        englishAsAnAdditionalLanguageShort: 'EAL',
        specialEducationalNeeds: 'Special educational needs',
        specialEducationalNeedsShort: 'SEN',
        summerBorn: 'Summer born children',
        summerBornShort: 'Summer born',
      },
      typesOfComparisonReport: {
        ethnicityComparison: 'Ethnicity comparison',
        eyppComparison: 'EYPP comparison',
        genderComparison: 'Gender comparison',
        summerBornComparison: 'Summer born comparison',
      },
      typesOfProgressTracker: {
        areaOfLearning: 'Area of learning',
        termlyProgress: 'Termly progress',
      },
    },
    Contacts: {
      BreakAllowanceLabels: {
        paidBreak: 'Paid break',
        unpaidBreak: 'Unpaid break',
      },
    },
    DailyDiary: {
      Filters: {
        Time: {
          CurrentlyTimedIn: {
            label: 'Currently timed in children',
          },
          TimedInForDay: {
            label: 'Children timed in for the day',
          },
        },
      },
    },
    DailyDiaryNappies: {
      nappyWasOptions: {
        Both: 'Both',
        Clean: 'Clean',
        Soiled: 'Soiled',
        Wet: 'Wet',
      },
      toiletTrainingOptions: {
        Potty: 'Potty',
        Toilet: 'Toilet',
      },
    },
    Deposits: {
      TypeOptions: {
        deposit: 'Deposit',
        depositRefund: 'Deposit refund',
      },
    },
    Enquiries: {
      EnquiryReasonTypes: {
        firstNursery: 'First nursery',
        movedFromAnotherChildcareSetting: 'Moved from another childcare setting',
        movedToTheArea: 'Moved to the area',
        newEmployment: 'New employment',
        other: 'Other',
        returnToWork: 'Return to work',
        siblingAtSetting: 'Sibling at setting',
      },
      SourceTypes: {
        bing: 'Search engine: Bing',
        blogPosts: 'Blog posts',
        brochures: 'Ads: Brochures',
        carAds: 'Ads: Car ads',
        existingParentOrCustomer: 'Existing parent / customer',
        google: 'Search engine: Google',
        letterLeafletPostcard: 'Ads: Letter, leaflet or postcard sent to my home',
        localAuthority: 'Local authority',
        newspaperAds: 'Ads: Newspaper ads',
        nurseryReviewWebsites: 'Nursery review websites',
        onlineAds: 'Ads: Online ads',
        openDayOrEvent: 'Open day / event',
        other: 'Other',
        otherSearchEngine: 'Search engine: Other',
        passingBy: 'Passing by',
        radioAds: 'Ads: Radio ads',
        socialMedia: 'Ads: Social media',
        streetAds: 'Ads: Street ads / Banner',
        tvAds: 'Ads: TV ads',
        wordOfMouth: 'Word of mouth',
      },
      ViewingStatusFilters: {
        booked: 'Booked',
        notBooked: 'Not booked',
      },
    },
    Files: {
      fileDetailsHasBeenChanged: 'File details has been changed',
      fileRemoved: 'The file has been successfully removed',
      fileSizeTooLarge: 'Upload error (file size too large)',
      notFound: 'There are no files.',
      title: 'Files',
    },
    FoodMenu: {
      foodCategory: {
        AM: 'AM',
        Breakfast: 'Breakfast',
        Lunch: 'Lunch',
        PM: 'PM',
        Tea: 'Tea',
      },
    },
    Frameworks: {
      Constants: {
        itemOptions: {
          developing: 'Developing',
          emerging: 'Emerging',
          secure: 'Secure',
          startingPoint: 'Starting point',
        },
      },
    },
    InvoicePayments: {
      paymentStatuses: {
        canceled: 'Canceled',
        completed: 'Completed',
        failed: 'Failed',
        manuallyAdded: 'Manually added',
        processing: 'Processing',
        refunded: 'Refunded',
      },
      type: {
        refund: 'Refund',
      },
    },
    Invoices: {
      Constants: {
        InvoiceDateOptionLabels: {
          createdDate: 'Created date',
          invoiceDate: 'Invoice date',
        },
        InvoiceTypesDropdownLabels: {
          creditNotes: 'Credit notes',
          invoices: 'Invoices',
        },
        LineItemsLabels: {
          deposit: 'Deposit',
          discount: 'Discount',
          extraConsumable: 'Extra consumable',
          extraItem: 'Extra item',
          extraSession: 'Extra session',
          fees: 'Fees',
          funding: 'Funding',
          oneOffDiscount: 'One-off Discount',
          oneOffFunding: 'One-off funding',
          other: 'Other',
          package: 'Package',
          refundDeposit: 'Deposit refund',
          regularConsumable: 'Regular consumable',
          regularDiscount: 'Regular discount',
          regularItem: 'Regular item',
          regularSession: 'Regular session',
        },
        LineSubItemsLabels: {
          consumable: 'Consumable',
        },
        SaveInvoiceAction: {
          saveAndMarkAsSent: 'Save and mark as sent',
          saveAndSend: 'Save and send',
          saveAsDraft: 'Save as draft',
        },
        SendInvoiceNumberOptionLabels: {
          automaticInvoiceNumber: 'Automatic invoice number',
          customInvoiceNumber: 'Custom invoice number',
        },
        StatusesLabels: {
          all: 'All',
          badDebt: 'Bad debt',
          cancelled: 'Cancelled',
          draft: 'Draft',
          overdue: 'Overdue',
          paid: 'Paid',
          partiallyPaid: 'Partially paid',
          sending: 'Sending',
          sent: 'Sent',
        },
      },
    },
    MedicationForm: {
      BeforeAfterEating: {
        afterEating: 'After eating (full stomach)',
        beforeEating: 'Before eating (empty stomach)',
        notApplicable: 'Not applicable',
        withFood: 'With food',
      },
      Frequency: {
        asNeeded: 'As needed',
        daily: 'Daily',
      },
      Status: {
        medicationExpired: 'Medication expired',
        needReview: 'Need review',
      },
    },
    MembershipRegisters: {
      clockedIn: 'Clocked in',
      clockedOut: 'Clocked out',
      insideBuilding: 'Inside building',
      leaveTypes: {
        holiday: 'Holiday',
        other: 'Other',
        sick: 'Sick',
      },
      logTypes: {
        break: 'break',
        holiday: 'holiday',
        leave: 'leave',
        shift: 'work',
        sick: 'sick',
      },
      mainTypes: {
        leave: 'Leave',
        work: 'Work',
      },
      onBreak: 'On break',
      outsideBuilding: 'Outside building',
      work: 'Work',
      workTypes: {
        break: 'Break (fixed)',
        breakDuration: 'Break (flexible)',
        contracted: 'Contracted',
        overtime: 'Overtime',
      },
    },
    MembershipsShifts: {
      leaveType: {
        holidays: 'Holidays',
        sick: 'Sick leave',
      },
    },
    NextSteps: {
      Achieved: 'Achieved',
      AchievedNoObservation: 'Achieved (No observation made)',
      WorkingOn: 'Working on',
    },
    Nurseries: {
      Timezone: {
        america: 'EST (UTC-05:00) or EDT (UTC-04:00)',
        europe: 'GMT (UTC+01:00) or BST (UTC+01:00)',
      },
    },
    NurseryFundingV3: {
      FundingInvoiceDeduction: {
        DeductedFromInvoiceTotal: {
          label: 'Funding deducted from invoice total',
          tooltip: 'This will show the a break down of the original session cost prior to Funding being deducted.',
        },
        DeductedFromSession: {
          label: 'Funding deducted from session line items',
          tooltip: 'This will show the cost of the Session after Funding has already been deducted.',
        },
      },
      FundingLineItem: {
        DoNotShow: {
          label: 'Hide entire line item',
          tooltip: 'This funding type will not be shown on invoices',
        },
        HideHours: {
          label: 'Hide funded hours',
          tooltip: 'The line item on invoices will be displayed as the funding name only.',
        },
        HideValue: {
          label: 'Hide funding value',
          tooltip: 'The line item on invoices will be displayed as the funding name only.',
        },
        ShowHours: {
          label: 'Show funded hours',
          tooltip: 'The line item on invoices will be displayed as the funding name and number of hours funded for the period.',
        },
        ShowValue: {
          label: 'Show funding value',
          tooltip: 'The line item on invoices will be displayed as the funding name and the amount subtracted from the invoice.',
        },
      },
      FundingPeriod: {
        stretched: 'Stretched',
        termTime: 'Term time',
      },
      InvoiceDeduction: {
        fundingLocalAuthorityHourlyRate: 'Deduct funding local authority hourly rate',
        sessionHourlyRate: 'Deduct session hourly rate',
      },
      fundingRedistributionRules: {
        apply: 'Apply funding',
        notApply: 'Do not apply funding',
        otherDays: 'Redistribute funding to other days',
      },
      fundingType: {
        oneOffFunding: 'One-off funding',
        regularFunding: 'Regular funding',
      },
    },
    NurseryIntegrations: {
      PaymentMethod: {
        bacs_debit: 'BACS Direct Debit',
        card: 'Recurring card payment',
      },
      SetupType: {
        custom: 'Added manually to Blossom',
        stripe: 'Added via Parent App (Stripe)',
      },
      Status: {
        active: 'Active',
        notActive: 'Not active',
      },
      chargeTypeOptions: {
        first: 'First working day of each month',
        last: 'Last working day of each month',
      },
      payoutFailures: {
        accountClosed: 'The bank account has been closed.',
        accountFrozen: 'The bank account has been frozen.',
        bankAccountRestricted: 'The bank account has restrictions on either the type, or the number, of payouts allowed. This normally indicates that the bank account is a savings or other non-checking account.',
        bankOwnershipChanged: 'The destination bank account is no longer valid because its branch has changed ownership.',
        couldNotProcess: 'The bank could not process this payout.',
        debitNotAuthorized: 'Debit transactions are not approved on the bank account. (Stripe requires bank accounts to be set up for both credit and debit payouts.)',
        declined: 'The bank has declined this transfer. Please contact the bank before retrying.',
        incorrectAccountHolderAddress: 'Your bank notified us that the bank account holder address on file is incorrect.',
        incorrectAccountHolderName: 'Your bank notified us that the bank account holder name on file is incorrect.',
        incorrectAccountHolderTaxId: 'Your bank notified us that the bank account holder tax ID on file is incorrect.',
        insufficientFunds: 'Your Stripe account has insufficient funds to cover the payout.',
        invalidAccountNumber: 'The routing number seems correct, but the account number is invalid.',
        invalidCurrency: 'The bank was unable to process this payout because of its currency. This is probably because the bank account cannot accept payments in that currency.',
        noAccount: 'The bank account details on file are probably incorrect. No bank account could be located with those details.',
        unsupportedCard: 'The bank no longer supports payouts to this card.',
      },
      payoutsStatuses: {
        canceled: 'Cancelled',
        failed: 'Failed',
        inTransit: 'In transit',
        paid: 'Paid',
        pending: 'Pending',
      },
    },
    Occupancy: {
      genericValidationErrorMessage: 'Ups, looks like some of your rooms are not configured properly. Please check the room settings.',
    },
    Product: {
      NurseryDiscounts: {
        amountDiscount: 'Discount amount',
        feeCalculation: {
          actual: 'Calendar monthly',
          annualised: 'Annualised',
          monthlyPackage: 'Monthly package',
          weeklyPackage: 'Weekly package',
        },
        percentageDiscount: 'Discount percentage',
      },
    },
    Review: {
      ReviewMedication: {
        endMedication: 'End medication',
        medicationStillNeeded: 'Medication is still needed',
      },
    },
    Rooms: {
      Leaving: 'Leaving',
    },
    Viewings: {
      StatusOptions: {
        attended: 'Attended',
        booked: 'Booked',
        canceledByNursery: 'Cancelled by nursery',
        canceledByParent: 'Cancelled by parent',
        noShow: 'Not attended',
      },
    },
  },
  utils: {
    Data: {
      NumberSuffix: {
        nd: 'nd',
        rd: 'rd',
        st: 'st',
        th: 'th',
      },
    },
    Validation: {
      cannotBeBlank: 'This value cannot be blank.',
      greaterOrEqual: 'This value should be greater than or equal to {{ value }}.',
      isChildSession: {
        sessionRequired: 'Session field is required.',
        startTimeFinishTimeRequired: 'Start time and Finish time fields are required.',
      },
      isEmailValid: 'Enter valid email address.',
      isEndTimeGreaterThanStartTime: 'End time must be greater than start time.',
      isMaxLengthLessThan: 'This field should be shorter than {{ maxLength }} characters',
      isMinLengthLessThan: 'This field should be greater than {{ minLength }} characters',
      isNegativeNumber: 'The amount has to be negative.',
      isNumberGreaterOrEqualThan: 'Value should be greater or equal than {{ minValue }}',
      isNumberLessOrEqualThan: 'Value should be less or equal than {{ maxValue }}.',
      isPositiveNumber: 'The amount has to be positive.',
      isRequired: 'This field is required.',
      isSortCodeValid: 'Sort Code must be in the following format 00-00-00.',
      isSubdomainValid: 'The subdomain can only consist of lowercase letters, numbers and hyphens.',
      isValidBankAccountNumber: 'Please provide an 8 digit account number.',
      isValidBigInt: 'This value should be less than or equal to 9000000000000000000.',
      isValidDateRange: {
        endDateSmallerThanStart: 'Start date should not be after the end date.',
        invalid: 'Invalid date range.',
      },
      isValidFileType: 'Invalid file type',
      isValidInteger: 'This value can only be a whole number.',
      isValidMinutes: 'Value should be less then or equal to 60.',
      isValidNumber: {
        invalid: 'Invalid number.',
        noPrecision: 'This value can only be a whole number.',
        precision: 'Only {{ precision }} decimal places can be entered.',
      },
      overlappingAgeGroups: 'There are overlapping age groups.',
    },
  },
}
